{
  "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
  "bflc": "http://id.loc.gov/ontologies/bflc/",
  "foaf": "http://xmlns.com/foaf/0.1/",
  "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "dbo": "http://dbpedia.org/ontology/",
  "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
  "yago": "http://yago-knowledge.org/resource/",
  "dc": "http://purl.org/dc/elements/1.1/",
  "dbp": "http://dbpedia.org/property/",
  "owl": "http://www.w3.org/2002/07/owl#",
  "skos": "http://www.w3.org/2004/02/skos/core#",
  "gr": "http://purl.org/goodrelations/v1#",
  "geo": "http://www.opengis.net/ont/geosparql#",
  "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "ex": "http://example.org/",
  "xsd": "http://www.w3.org/2001/XMLSchema#",
  "dcat": "http://www.w3.org/ns/dcat#",
  "org": "http://www.w3.org/ns/org#",
  "dct": "http://purl.org/dc/terms/",
  "dcterms": "http://purl.org/dc/terms/",
  "qb": "http://purl.org/linked-data/cube#",
  "prov": "http://www.w3.org/ns/prov#",
  "sioc": "http://rdfs.org/sioc/ns#",
  "xtypes": "http://purl.org/xtypes/",
  "dbpedia": "http://dbpedia.org/resource/",
  "void": "http://rdfs.org/ns/void#",
  "ont": "http://purl.org/net/ns/ontology-annot#",
  "onto": "http://www.ontotext.com/",
  "sio": "http://semanticscience.org/resource/",
  "obo": "http://purl.obolibrary.org/obo/",
  "dcterm": "http://purl.org/dc/terms/",
  "schema": "http://schema.org/",
  "bf": "http://id.loc.gov/ontologies/bibframe/",
  "search": "http://sindice.com/vocab/search#",
  "sd": "http://www.w3.org/ns/sparql-service-description#",
  "frbr": "http://purl.org/vocab/frbr/core#",
  "stat": "http://www.w3.org/ns/posix/stat#",
  "vcard": "http://www.w3.org/2006/vcard/ns#",
  "commerce": "http://purl.org/commerce#",
  "dbr": "http://dbpedia.org/resource/",
  "bibo": "http://purl.org/ontology/bibo/",
  "pto": "http://www.productontology.org/id/",
  "rss": "http://purl.org/rss/1.0/",
  "oo": "http://purl.org/openorg/",
  "gldp": "http://www.w3.org/ns/people#",
  "geonames": "http://www.geonames.org/ontology#",
  "content": "http://purl.org/rss/1.0/modules/content/",
  "fb": "http://rdf.freebase.com/ns/",
  "event": "http://purl.org/NET/c4dm/event.owl#",
  "vann": "http://purl.org/vocab/vann/",
  "wd": "http://www.wikidata.org/entity/",
  "gen": "http://purl.org/gen/0.1#",
  "dcmit": "http://purl.org/dc/dcmitype/",
  "cc": "http://creativecommons.org/ns#",
  "http": "http://www.w3.org/2011/http#",
  "dbpprop": "http://dbpedia.org/property/",
  "doap": "http://usefulinc.com/ns/doap#",
  "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "rr": "http://www.w3.org/ns/r2rml#",
  "swrc": "http://swrc.ontoware.org/ontology#",
  "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
  "sc": "https://schema.org/",
  "md": "http://www.w3.org/ns/md#",
  "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
  "as": "https://www.w3.org/ns/activitystreams#",
  "fn": "http://www.w3.org/2005/xpath-functions#",
  "leaks": "https://onlyfans.com/chelxie/",
  "cv": "http://rdfs.org/resume-rdf/",
  "prog": "http://purl.org/prog/",
  "wot": "http://xmlns.com/wot/0.1/",
  "aiiso": "http://purl.org/vocab/aiiso/schema#",
  "ma": "http://www.w3.org/ns/ma-ont#",
  "uniprot": "http://purl.uniprot.org/uniprot/",
  "tl": "http://purl.org/NET/c4dm/timeline.owl#",
  "akt": "http://www.aktors.org/ontology/portal#",
  "daia": "http://purl.org/ontology/daia/",
  "swc": "http://data.semanticweb.org/ns/swc/ontology#",
  "ical": "http://www.w3.org/2002/12/cal/ical#",
  "xhtml": "http://www.w3.org/1999/xhtml#",
  "crm": "http://www.cidoc-crm.org/cidoc-crm/",
  "rel": "http://purl.org/vocab/relationship/",
  "bio": "http://purl.org/vocab/bio/0.1/",
  "earl": "http://www.w3.org/ns/earl#",
  "ov": "http://open.vocab.org/terms/",
  "unit": "http://qudt.org/vocab/unit/",
  "mo": "http://purl.org/ontology/mo/",
  "dv": "http://rdf.data-vocabulary.org/#",
  "marcrel": "http://id.loc.gov/vocabulary/relators/",
  "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "xhv": "http://www.w3.org/1999/xhtml/vocab#",
  "cs": "http://purl.org/vocab/changeset/schema#",
  "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "ad": "http://schemas.talis.com/2005/address/schema#",
  "afn": "http://jena.apache.org/ARQ/function#",
  "co": "http://purl.org/ontology/co/core#",
  "dc11": "http://purl.org/dc/elements/1.1/",
  "og": "http://opengraphprotocol.org/schema/",
  "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
  "xs": "http://www.w3.org/2001/XMLSchema#",
  "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
  "mu": "http://mu.semte.ch/vocabularies/core/",
  "test2": "http://this.invalid/test2#",
  "book": "http://purl.org/NET/book/vocab#",
  "log": "http://www.w3.org/2000/10/swap/log#",
  "musim": "http://purl.org/ontology/similarity/",
  "xfn": "http://gmpg.org/xfn/11#",
  "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
  "media": "http://search.yahoo.com/searchmonkey/media/",
  "dcq": "http://purl.org/dc/qualifiers/1.0/",
  "ome": "http://purl.org/ontomedia/core/expression#",
  "prop": "http://dbpedia.org/property/",
  "xf": "http://www.w3.org/2002/xforms/",
  "cld": "http://purl.org/cld/terms/",
  "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
  "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "cal": "http://www.w3.org/2002/12/cal/ical#",
  "qudt": "http://qudt.org/schema/qudt/",
  "biblio": "http://purl.org/net/biblio#",
  "reco": "http://purl.org/reco#",
  "rev": "http://purl.org/stuff/rev#",
  "sism": "http://purl.oclc.org/NET/sism/0.1/",
  "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
  "ttp": "http://eample.com/test#",
  "days": "http://ontologi.es/days#",
  "botany": "http://purl.org/NET/biol/botany#",
  "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
  "af": "http://purl.org/ontology/af/",
  "rif": "http://www.w3.org/2007/rif#",
  "ctag": "http://commontag.org/ns#",
  "dir": "http://schemas.talis.com/2005/dir/schema#",
  "ok": "http://okkam.org/terms#",
  "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
  "tzont": "http://www.w3.org/2006/timezone#",
  "sr": "http://www.openrdf.org/config/repository/sail#",
  "admin": "http://webns.net/mvcb/",
  "pc": "http://purl.org/procurement/public-contracts#",
  "math": "http://www.w3.org/2000/10/swap/math#",
  "myspace": "http://purl.org/ontology/myspace#",
  "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
  "giving": "http://ontologi.es/giving#",
  "sdmx": "http://purl.org/linked-data/sdmx#",
  "xmp": "http://ns.adobe.com/xap/1.0/",
  "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
  "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
  "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
  "swanq": "http://purl.org/swan/1.2/qualifiers/",
  "time": "http://www.w3.org/2006/time#",
  "jdbc": "http://d2rq.org/terms/jdbc/",
  "lyou": "http://purl.org/linkingyou/",
  "owlim": "http://www.ontotext.com/trree/owlim#",
  "omn": "http://open-multinet.info/ontology/omn#",
  "dcam": "http://purl.org/dc/dcam/",
  "swande": "http://purl.org/swan/1.2/discourse-elements/",
  "gn": "http://www.geonames.org/ontology#",
  "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
  "skosxl": "http://www.w3.org/2008/05/skos-xl#",
  "con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "cyc": "http://sw.opencyc.org/concept/",
  "adms": "http://www.w3.org/ns/adms#",
  "oa": "http://www.w3.org/ns/oa#",
  "cdm": "http://publications.europa.eu/ontology/cdm#",
  "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
  "gvp": "http://vocab.getty.edu/ontology#",
  "ontology": "http://dbpedia.org/ontology/",
  "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "db": "http://dbpedia.org/",
  "sh": "http://www.w3.org/ns/shacl#",
  "type": "http://teste.com/teste/",
  "om": "http://opendata.caceres.es/def/ontomunicipio#",
  "isbd": "http://iflastandards.info/ns/isbd/elements/",
  "lemon": "http://lemon-model.net/lemon#",
  "photoshop": "http://ns.adobe.com/photoshop/1.0/",
  "aat": "http://vocab.getty.edu/aat/",
  "eat": "http://www.eat.rl.ac.uk/#",
  "wfs": "http://schemas.opengis.net/wfs/",
  "room": "http://vocab.deri.ie/rooms#",
  "wdt": "http://www.wikidata.org/prop/direct/",
  "exif": "http://www.w3.org/2003/12/exif/ns#",
  "tgn": "http://vocab.getty.edu/tgn/",
  "fabio": "http://purl.org/spar/fabio/",
  "ac": "http://umbel.org/umbel/ac/",
  "ulan": "http://vocab.getty.edu/ulan/",
  "test": "https://test4.example.com/",
  "ore": "http://www.openarchives.org/ore/terms/",
  "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
  "cert": "http://www.w3.org/ns/auth/cert#",
  "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
  "prism": "http://prismstandard.org/namespaces/basic/2.0/",
  "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
  "cnt": "http://www.w3.org/2011/content#",
  "nsogi": "http://prefix.cc/nsogi:",
  "fise": "http://fise.iks-project.eu/ontology/",
  "sf": "http://www.opengis.net/ont/sf#",
  "core": "http://vivoweb.org/ontology/core#",
  "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
  "voaf": "http://purl.org/vocommons/voaf#",
  "edm": "http://www.europeana.eu/schemas/edm/",
  "swrl": "http://www.w3.org/2003/11/swrl#",
  "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
  "lv": "http://purl.org/lobid/lv#",
  "eg": "http://www.example.org/",
  "gndo": "http://d-nb.info/standards/elementset/gnd#",
  "gtfs": "http://vocab.gtfs.org/terms#",
  "urn": "http://fliqz.com/",
  "dbc": "http://dbpedia.org/resource/Category:",
  "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
  "ro": "http://purl.org/wf4ever/ro#",
  "swrlb": "http://www.w3.org/2003/11/swrlb#",
  "ssn": "http://www.w3.org/ns/ssn/",
  "movie": "http://data.linkedmdb.org/resource/movie/",
  "xml": "http://www.w3.org/XML/1998/namespace/",
  "music": "http://musicontology.com/",
  "bif": "http://www.openlinksw.com/schemas/bif#",
  "wikidata": "http://www.wikidata.org/entity/",
  "dbprop": "http://dbpedia.org/property/",
  "go": "http://purl.obolibrary.org/obo/GO_",
  "wp": "http://vocabularies.wikipathways.org/",
  "leak": "http://maco.com/",
  "pat": "http://purl.org/hpi/patchr#",
  "ceo": "https://linkeddata.cultureelerfgoed.nl/def/ceo#",
  "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
  "ping": "https://namso-gen.com/",
  "loc": "http://id.loc.gov/",
  "sp": "http://spinrdf.org/sp#",
  "penn": "http://purl.org/olia/penn.owl#",
  "dbkwik": "http://dbkwik.webdatacommons.org/",
  "am": "http://vocab.deri.ie/am#",
  "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
  "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
  "mods": "http://www.loc.gov/mods/v3#",
  "ldp": "http://www.w3.org/ns/ldp#",
  "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
  "st": "http://ns.inria.fr/sparql-template/",
  "sec": "https://w3id.org/security#",
  "geoes": "http://geo.linkeddata.es/ontology/",
  "product": "http://purl.org/commerce/product#",
  "dce": "http://purl.org/dc/elements/1.1/",
  "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
  "sioct": "http://rdfs.org/sioc/types#",
  "bd": "http://www.bigdata.com/rdf#",
  "chebi": "http://purl.obolibrary.org/obo/CHEBI_",
  "sdo": "https://schema.org/",
  "imm": "http://schemas.microsoft.com/imm/",
  "siocserv": "http://rdfs.org/sioc/services#",
  "example": "http://www.example.org/rdf#",
  "sparql": "http://www.w3.org/ns/sparql#",
  "gnd": "http://d-nb.info/gnd/",
  "up": "http://purl.uniprot.org/core/",
  "coref": "http://www.rkbexplorer.com/ontologies/coref#",
  "cerif": "http://spi-fm.uca.es/neologism/cerif#",
  "rec": "http://purl.org/ontology/rec/core#",
  "ptr": "http://www.w3.org/2009/pointers#",
  "scovo": "http://purl.org/NET/scovo#",
  "list": "http://www.w3.org/2000/10/swap/list#",
  "gd": "http://rdf.data-vocabulary.org/#",
  "acc": "http://purl.org/NET/acc#",
  "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "whois": "http://www.kanzaki.com/ns/whois#",
  "spin": "http://spinrdf.org/spin#",
  "java": "http://www.w3.org/2007/uwa/context/java.owl#",
  "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
  "wiki": "http://en.wikipedia.org/wiki/",
  "sirext": "http://t.me/sirextt/247:",
  "ms": "http://purl.org/obo/owl/MS#",
  "gold": "http://purl.org/linguistics/gold/",
  "space": "http://www.w3.org/ns/pim/space#",
  "cube": "https://cube.link/",
  "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
  "olia": "http://purl.org/olia/olia.owl#",
  "opm": "https://w3id.org/opm#",
  "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
  "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
  "dbnary": "http://kaiko.getalp.org/dbnary#",
  "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
  "geof": "http://www.opengis.net/def/function/geosparql/",
  "lgd": "http://linkedgeodata.org/triplify/",
  "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "pext": "http://www.ontotext.com/proton/protonext#",
  "rdfsharp": "https://rdfsharp.codeplex.com/",
  "rsa": "http://www.w3.org/ns/auth/rsa#",
  "iot": "http://iotschema.org/",
  "vivo": "http://vivoweb.org/ontology/core#",
  "sim": "http://www.w3id.org/simulation/ontology/",
  "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
  "hg": "http://rdf.histograph.io/",
  "bp": "http://www.biopax.org/release/biopax-level3.owl#",
  "akts": "http://www.aktors.org/ontology/support#",
  "georss": "http://www.georss.org/georss/",
  "po": "http://purl.org/ontology/po/",
  "api": "http://purl.org/linked-data/api/vocab#",
  "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
  "bing": "http://bing.com/schema/media/",
  "acl": "http://www.w3.org/ns/auth/acl#",
  "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "geosparql": "http://www.opengis.net/ont/geosparql#",
  "pim": "http://www.w3.org/ns/pim/space#",
  "cito": "http://purl.org/spar/cito/",
  "cgov": "http://reference.data.gov.uk/def/central-government/",
  "resource": "http://dbpedia.org/resource/",
  "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
  "video": "http://purl.org/ontology/video#",
  "xl": "http://langegger.at/xlwrap/vocab#",
  "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "seas": "https://w3id.org/seas/",
  "pr": "http://purl.org/ontology/prv/core#",
  "dbpediaowl": "http://dbpedia.org/owl/",
  "wikipedia": "https://en.wikipedia.org/wiki/",
  "name": "http://example.org/name#",
  "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
  "gist": "https://ontologies.semanticarts.com/o/gistCore#",
  "ean": "http://openean.kaufkauf.net/id/",
  "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
  "web": "http://www.w3.org/2007/uwa/context/web.owl#",
  "exterms": "http://www.example.org/terms/",
  "role": "https://w3id.org/role/",
  "httph": "http://www.w3.org/2007/ont/httph#",
  "acm": "http://www.rkbexplorer.com/ontologies/acm#",
  "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
  "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
  "pav": "http://purl.org/pav/",
  "sosa": "http://www.w3.org/ns/sosa/",
  "dco": "http://info.deepcarbon.net/schema#",
  "wn": "http://xmlns.com/wordnet/1.6/",
  "stanford": "http://purl.org/olia/stanford.owl#",
  "dcm": "http://purl.org/dc/dcmitype/",
  "prv": "http://purl.org/net/provenance/ns#",
  "pgterms": "http://www.gutenberg.org/2009/pgterms/",
  "purl": "http://purl.org/dc/terms/",
  "iso": "http://purl.org/iso25964/skos-thes#",
  "ps": "https://w3id.org/payswarm#",
  "overheid": "http://standaarden.overheid.nl/owms/",
  "service": "http://purl.org/ontology/service#",
  "ass": "http://uptheasset.org/ontology#",
  "dcatapit": "http://dati.gov.it/onto/dcatapit#",
  "ocd": "http://dati.camera.it/ocd/",
  "wo": "http://purl.org/ontology/wo/",
  "formats": "http://www.w3.org/ns/formats/",
  "ero": "http://purl.obolibrary.org/obo/",
  "inno": "http://purl.org/innovation/ns#",
  "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
  "lime": "http://www.w3.org/ns/lemon/lime#",
  "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "greg": "http://kasei.us/about/foaf.xrdf#",
  "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
  "atom": "http://www.w3.org/2005/Atom/",
  "wdrs": "http://www.w3.org/2007/05/powder-s#",
  "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
  "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
  "smf": "http://topbraid.org/sparqlmotionfunctions#",
  "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
  "bmo": "http://collection.britishmuseum.org/id/ontology/",
  "daml": "http://www.daml.org/2001/03/daml+oil#",
  "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "zoology": "http://purl.org/NET/biol/zoology#",
  "euvoc": "http://publications.europa.eu/ontology/euvoc#",
  "premis": "http://www.loc.gov/premis/rdf/v3/",
  "iao": "http://purl.obolibrary.org/obo/IAO_",
  "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
  "lode": "http://linkedevents.org/ontology/",
  "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
  "gsp": "http://www.opengis.net/ont/geosparql#",
  "res": "http://dbpedia.org/resource/",
  "edam": "http://edamontology.org/",
  "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
  "saref": "https://saref.etsi.org/core/",
  "won": "https://w3id.org/won/core#",
  "myspo": "http://purl.org/ontology/myspace#",
  "swid": "http://semanticweb.org/id/",
  "hydra": "http://www.w3.org/ns/hydra/core#",
  "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
  "agg": "http://purl.org/twc/health/vocab/aggregate/",
  "so": "http://schema.org/",
  "hp": "http://pictogram.tokyo/vocabulary#",
  "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
  "resist": "http://www.rkbexplorer.com/ontologies/resist#",
  "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
  "scot": "http://rdfs.org/scot/ns#",
  "spl": "http://spinrdf.org/spl#",
  "dt": "http://w3id.org/dt#",
  "bfo": "http://purl.obolibrary.org/obo/",
  "omt": "http://purl.org/ontomedia/ext/common/trait#",
  "label": "http://purl.org/net/vocab/2004/03/label#",
  "sdl": "http://purl.org/vocab/riro/sdl#",
  "omp": "http://purl.org/ontomedia/ext/common/profession#",
  "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
  "fed": "http://www.openrdf.org/config/sail/federation#",
  "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
  "site": "http://ns.ontowiki.net/SysOnt/Site/",
  "ignf": "http://data.ign.fr/def/ignf#",
  "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
  "rov": "http://www.w3.org/ns/regorg#",
  "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
  "faldo": "http://biohackathon.org/resource/faldo#",
  "bibframe": "http://id.loc.gov/ontologies/bibframe/",
  "ya": "http://blogs.yandex.ru/schema/foaf/",
  "isothes": "http://purl.org/iso25964/skos-thes#",
  "ses": "http://lod.taxonconcept.org/ses/",
  "user": "http://schemas.talis.com/2005/user/schema#",
  "cpm": "http://catalogus-professorum.org/cpm/2/",
  "sml": "https://w3id.org/sml/def#",
  "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
  "oad": "http://lod.xdams.org/reload/oad/",
  "ref": "http://purl.org/vocab/relationship/",
  "rdau": "http://rdaregistry.info/Elements/u/",
  "food": "http://purl.org/foodontology#",
  "act": "http://www.w3.org/2007/rif-builtin-action#",
  "link": "http://www.w3.org/2007/ont/link#",
  "library": "http://purl.org/library/",
  "airport": "http://www.daml.org/2001/10/html/airport-ont#",
  "cordis": "http://cordis.europa.eu/projects/",
  "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
  "prj": "http://purl.org/stuff/project/",
  "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
  "swp": "http://www.w3.org/2004/03/trix/swp-2/",
  "rnews": "http://iptc.org/std/rNews/2011-10-07#",
  "audio": "http://purl.org/media/audio#",
  "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "sesame": "http://www.openrdf.org/schema/sesame#",
  "fresnel": "http://www.w3.org/2004/09/fresnel#",
  "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
  "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
  "biocore": "http://bio2rdf.org/core#",
  "ludo": "http://ns.inria.fr/ludo/v1#",
  "sport": "http://purl.org/ontology/sport/",
  "npg": "http://ns.nature.com/terms/",
  "taxon": "http://purl.uniprot.org/taxonomy/",
  "efo": "http://www.ebi.ac.uk/efo/",
  "granatum": "http://chem.deri.ie/granatum/",
  "city": "http://datos.localidata.com/def/City#",
  "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
  "rs": "http://rightsstatements.org/vocab/",
  "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
  "asn": "http://purl.org/ASN/schema/core/",
  "net": "http://www.w3.org/2007/uwa/context/network.owl#",
  "meteo": "http://purl.org/ns/meteo#",
  "acco": "http://purl.org/acco/ns#",
  "umbelrc": "http://umbel.org/umbel/rc/",
  "linkedmdb": "http://data.linkedmdb.org/",
  "wv": "http://vocab.org/waiver/terms/",
  "os": "http://www.w3.org/2000/10/swap/os#",
  "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
  "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
  "conv": "http://purl.org/twc/vocab/conversion/",
  "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
  "bio2rdf": "http://bio2rdf.org/",
  "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
  "vra": "http://purl.org/vra/",
  "conversion": "http://purl.org/twc/vocab/conversion/",
  "uco": "http://purl.org/uco/ns#",
  "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
  "dctype": "http://purl.org/dc/dcmitype/",
  "doac": "http://ramonantonio.net/doac/0.1/#",
  "mime": "https://www.iana.org/assignments/media-types/",
  "tdb": "http://jena.hpl.hp.com/2008/tdb#",
  "rail": "http://ontologi.es/rail/vocab#",
  "rep": "http://www.openrdf.org/config/repository#",
  "arg": "http://spinrdf.org/arg#",
  "ao": "http://purl.org/ontology/ao/core#",
  "omb": "http://purl.org/ontomedia/ext/common/being#",
  "oc": "http://opencoinage.org/rdf/",
  "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
  "spc": "http://purl.org/ontomedia/core/space#",
  "compass": "http://purl.org/net/compass#",
  "lgdo": "http://linkedgeodata.org/ontology/",
  "code": "http://telegraphis.net/ontology/measurement/code#",
  "bne": "http://datos.bne.es/resource/",
  "pbo": "http://purl.org/ontology/pbo/core#",
  "dwc": "http://rs.tdwg.org/dwc/terms/",
  "custom": "http://www.openrdf.org/config/sail/custom#",
  "vocab": "http://rdf.ontology2.com/vocab#",
  "cdt": "https://w3id.org/cdt/",
  "protege": "http://protege.stanford.edu/system#",
  "money": "http://purl.org/net/rdf-money/",
  "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
  "lfm": "http://purl.org/ontology/last-fm/",
  "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "ct": "http://data.linkedct.org/resource/linkedct/",
  "umbel": "http://umbel.org/umbel#",
  "crypto": "http://www.w3.org/2000/10/swap/crypto#",
  "lx": "http://purl.org/NET/lx#",
  "bl": "https://w3id.org/biolink/vocab/",
  "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
  "frir": "http://purl.org/twc/ontology/frir.owl#",
  "powder": "http://www.w3.org/2007/05/powder#",
  "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
  "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
  "sco": "http://purl.org/ontology/sco#",
  "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "ic": "http://imi.go.jp/ns/core/rdf#",
  "lang": "http://ontologi.es/lang/core#",
  "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
  "atomix": "http://buzzword.org.uk/rdf/atomix#",
  "obj": "http://www.openrdf.org/rdf/2009/object#",
  "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
  "omm": "http://purl.org/ontomedia/core/media#",
  "pom": "http://maven.apache.org/POM/4.0.0#",
  "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
  "coo": "http://purl.org/coo/ns#",
  "muto": "http://purl.org/muto/core#",
  "ddc": "http://purl.org/NET/decimalised#",
  "pay": "http://reference.data.gov.uk/def/payment#",
  "arch": "http://purl.org/archival/vocab/arch#",
  "rei": "http://www.w3.org/2004/06/rei#",
  "pro": "http://purl.org/hpi/patchr#",
  "biol": "http://purl.org/NET/biol/ns#",
  "bbc": "http://www.bbc.co.uk/ontologies/news/",
  "mit": "http://purl.org/ontology/mo/mit#",
  "isq": "http://purl.org/ontology/is/quality/",
  "soc": "http://purl.org/net/hdlipcores/ontology/soc#",
  "interval": "http://reference.data.gov.uk/def/intervals/",
  "contact": "http://www.w3.org/2000/10/swap/pim/contact#",
  "vsr": "http://purl.org/twc/vocab/vsr#",
  "aos": "http://rdf.muninn-project.org/ontologies/appearances#",
  "worldbank": "http://worldbank.270a.info/dataset/",
  "swh": "http://plugin.org.uk/swh-plugins/",
  "yoda": "http://purl.org/NET/yoda#",
  "xds": "http://www.w3.org/2001/XMLSchema#",
  "gso": "http://www.w3.org/2006/gen/ont#",
  "locn": "http://www.w3.org/ns/locn#",
  "mp": "http://jicamaro.info/mp#",
  "person": "http://www.w3.org/ns/person#",
  "deo": "http://purl.org/spar/deo/",
  "apivc": "http://purl.org/linked-data/api/vocab#",
  "mysql": "http://web-semantics.org/ns/mysql/",
  "gpt": "http://purl.org/vocab/riro/gpt#",
  "rdac": "http://rdaregistry.info/Elements/c/",
  "gml": "http://www.opengis.net/ont/gml#",
  "ppo": "http://vocab.deri.ie/ppo#",
  "hard": "http://www.w3.org/2007/uwa/context/hardware.owl#",
  "r2rml": "http://www.w3.org/ns/r2rml#",
  "ngeo": "http://geovocab.org/geometry#",
  "bib": "http://zeitkunst.org/bibtex/0.1/bibtex.owl#",
  "xro": "http://purl.org/xro/ns#",
  "freebase": "http://rdf.freebase.com/ns/",
  "rlog": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
  "zem": "http://s.zemanta.com/ns#",
  "usgov": "http://www.rdfabout.com/rdf/schema/usgovt/",
  "pmlr": "http://inference-web.org/2.0/pml-relation.owl#",
  "courseware": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "climb": "http://climb.dataincubator.org/vocabs/climb/",
  "doclist": "http://www.junkwork.net/xml/DocumentList#",
  "cpv": "http://purl.org/weso/cpv/",
  "rv": "https://data.elsevier.com/research/schema/rv/",
  "gob": "http://purl.org/ontology/last-fm/",
  "aifb": "http://www.aifb.kit.edu/id/",
  "nexif": "http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#",
  "is": "http://purl.org/ontology/is/core#",
  "game": "http://data.totl.net/game/",
  "payment": "http://reference.data.gov.uk/def/payment#",
  "vso": "http://purl.org/vso/ns#",
  "pos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "cycann": "http://sw.cyc.com/CycAnnotations_v1#",
  "states": "http://www.w3.org/2005/07/aaa#",
  "sem": "http://semanticweb.cs.vu.nl/2009/11/sem/",
  "eli": "http://data.europa.eu/eli/ontology#",
  "xen": "http://buzzword.org.uk/rdf/xen#",
  "ui": "http://www.w3.org/ns/ui#",
  "meetup": "http://www.lotico.com/meetup/",
  "bridge": "http://purl.org/vocommons/bridge#",
  "address": "http://schemas.talis.com/2005/address/schema#",
  "viaf": "http://viaf.org/viaf/",
  "article": "http://ogp.me/ns/article#",
  "oac": "https://w3id.org/oac#",
  "dso": "http://purl.org/ontology/dso#",
  "odrl": "http://www.w3.org/ns/odrl/2/",
  "pdo": "http://ontologies.smile.deri.ie/pdo#",
  "omc": "http://purl.org/ontomedia/ext/common/bestiary#",
  "teach": "http://linkedscience.org/teach/ns#",
  "bsb": "http://opacplus.bsb-muenchen.de/title/",
  "dcmitype": "http://purl.org/dc/dcmitype/",
  "soft": "http://www.w3.org/2007/uwa/context/software.owl#",
  "cdc": "https://w3id.org/cdc#",
  "wnschema": "http://www.cogsci.princeton.edu/~wn/schema/",
  "uri": "http://purl.org/NET/uri#",
  "nuts": "http://dd.eionet.europa.eu/vocabulary/common/nuts/",
  "kwijibo": "http://kwijibo.talis.com/",
  "cex": "http://purl.org/weso/ontology/computex#",
  "prot": "http://www.proteinontology.info/po.owl#",
  "politico": "http://www.rdfabout.com/rdf/schema/politico/",
  "dbpp": "http://dbpedia.org/property/",
  "swanco": "http://purl.org/swan/1.2/swan-commons/",
  "chord": "http://purl.org/ontology/chord/",
  "oauth": "http://demiblog.org/vocab/oauth#",
  "agro": "http://purl.obolibrary.org/obo/agro.owl#",
  "psys": "http://proton.semanticweb.org/protonsys#",
  "sdm": "https://w3id.org/okn/o/sdm#",
  "oboinowl": "http://www.geneontology.org/formats/oboInOwl#",
  "xforms": "http://www.w3.org/2002/xforms/",
  "muo": "http://purl.oclc.org/NET/muo/muo#",
  "coin": "http://purl.org/court/def/2009/coin#",
  "rda": "http://www.rdaregistry.info/",
  "vote": "http://www.rdfabout.com/rdf/schema/vote/",
  "wi": "http://purl.org/ontology/wi/core#",
  "ttl": "http://www.w3.org/2008/turtle#",
  "biopax": "http://www.biopax.org/release/biopax-level3.owl#",
  "oboe": "http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#",
  "com": "http://purl.org/commerce#",
  "lfn": "http://www.dotnetrdf.org/leviathan#",
  "conserv": "http://conserv.deri.ie/ontology#",
  "recipe": "http://linkedrecipes.org/schema/",
  "lp": "http://launchpad.net/rdf/launchpad#",
  "rooms": "http://vocab.deri.ie/rooms#",
  "ebucore": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
  "string": "http://www.w3.org/2000/10/swap/string#",
  "voag": "http://voag.linkedmodel.org/schema/voag#",
  "bsbm": "http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/",
  "sv": "http://schemas.talis.com/2005/service/schema#",
  "vitro": "http://vitro.mannlib.cornell.edu/ns/vitro/public#",
  "moat": "http://moat-project.org/ns#",
  "lifecycle": "http://purl.org/vocab/lifecycle/schema#",
  "rdapo": "http://rdaregistry.info/Elements/p/object/",
  "fea": "http://vocab.data.gov/def/fea#",
  "dailymed": "http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/",
  "puc": "http://purl.org/NET/puc#",
  "fo": "http://www.w3.org/1999/XSL/Format#",
  "scv": "http://purl.org/NET/scovo#",
  "vaem": "http://www.linkedmodel.org/schema/vaem#",
  "eclap": "http://www.eclap.eu/schema/eclap/",
  "wdr": "http://www.w3.org/2007/05/powder#",
  "dnr": "http://www.dotnetrdf.org/configuration#",
  "opo": "http://online-presence.net/opo/ns#",
  "card": "http://www.ashutosh.com/test/",
  "isi": "http://purl.org/ontology/is/inst/",
  "swanqs": "http://purl.org/swan/1.2/qualifiers/",
  "mygrid": "http://www.mygrid.org.uk/ontology#",
  "provone": "http://purl.org/provone#",
  "push": "http://www.w3.org/2007/uwa/context/push.owl#",
  "oslc": "http://open-services.net/ns/core#",
  "dcr": "http://www.isocat.org/ns/dcr.rdf#",
  "cogs": "http://vocab.deri.ie/cogs#",
  "dady": "http://purl.org/NET/dady#",
  "toby": "http://tobyinkster.co.uk/#",
  "osn": "http://spatial.ucd.ie/lod/osn/",
  "lex": "http://purl.org/lex#",
  "h5": "http://buzzword.org.uk/rdf/h5#",
  "posh": "http://poshrdf.org/ns/posh/",
  "play": "http://uriplay.org/spec/ontology/#",
  "wlp": "http://weblab-project.org/core/model/property/processing/",
  "spatial": "http://geovocab.org/spatial#",
  "meb": "http://rdf.myexperiment.org/ontologies/base/",
  "countries": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "br": "http://vocab.deri.ie/br#",
  "ldap": "http://purl.org/net/ldap/",
  "resex": "http://resex.rkbexplorer.com/ontologies/resex#",
  "b2bo": "http://purl.org/b2bo#",
  "lotico": "http://www.lotico.com/resource/",
  "lvont": "http://lexvo.org/ontology#",
  "care": "http://eulersharp.sourceforge.net/2003/03swap/care#",
  "sail": "http://www.openrdf.org/config/sail#",
  "lastfm": "http://purl.org/ontology/last-fm/",
  "enc": "http://www.w3.org/2001/04/xmlenc#",
  "wgspos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "sede": "http://eventography.org/sede/0.1/",
  "hospital": "http://www.agfa.com/w3c/2009/hospital#",
  "fls": "http://lukasblaho.sk/football_league_schema#",
  "bte": "http://purl.org/twc/vocab/between-the-edges/",
  "hlisting": "http://sindice.com/hlisting/0.1/",
  "ext": "http://mu.semte.ch/vocabularies/ext/",
  "html": "http://www.w3.org/1999/xhtml/",
  "evset": "http://dsnotify.org/vocab/eventset/0.1/",
  "rdaa": "http://rdaregistry.info/Elements/a/",
  "wbp": "http://worldbank.270a.info/property/",
  "csvw": "http://www.w3.org/ns/csvw#",
  "geospecies": "http://rdf.geospecies.org/ont/geospecies#",
  "fd": "http://foodable.co/ns/",
  "uni": "http://purl.org/weso/uni/uni.html#",
  "swandr": "http://purl.org/swan/1.2/discourse-relationships/",
  "ist": "http://purl.org/ontology/is/types/",
  "wai": "http://purl.org/wai#",
  "pubmed": "http://bio2rdf.org/pubmed_vocabulary:",
  "marl": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
  "icaltzd": "http://www.w3.org/2002/12/cal/icaltzd#",
  "fno": "https://w3id.org/function/ontology#",
  "lark1": "http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#",
  "anca": "http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#",
  "lingvoj": "http://www.lingvoj.org/ontology#",
  "irrl": "http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#",
  "okkam": "http://models.okkam.org/ENS-core-vocabulary#",
  "profiling": "http://ontologi.es/profiling#",
  "hcterms": "http://purl.org/uF/hCard/terms/",
  "cos": "http://www.inria.fr/acacia/corese#",
  "tarot": "http://data.totl.net/tarot/card/",
  "ncbitaxon": "http://purl.obolibrary.org/obo/NCBITaxon_",
  "oat": "http://openlinksw.com/schemas/oat/",
  "calli": "http://callimachusproject.org/rdf/2009/framework#",
  "grddl": "http://www.w3.org/2003/g/data-view#",
  "cmd": "https://w3id.org/cmd#",
  "places": "http://purl.org/ontology/places#",
  "ops": "https://w3id.org/ops#",
  "p3p": "http://www.w3.org/2002/01/p3prdfv1#",
  "like": "http://ontologi.es/like#",
  "pol": "http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#",
  "pobo": "http://purl.obolibrary.org/obo/",
  "data": "http://data.odw.tw/",
  "ann": "http://www.w3.org/2000/10/annotation-ns#",
  "shv": "http://ns.aksw.org/spatialHierarchy/",
  "xmls": "http://www.w3.org/2001/XMLSchema#",
  "archdesc": "http://archdesc.info/archEvent#",
  "foo": "http://filmontology.org/ontology/1.0/",
  "ec": "http://eulergui.sourceforge.net/contacts.owl.n3#",
  "parl": "https://id.parliament.uk/schema/",
  "swivt": "http://semantic-mediawiki.org/swivt/1.0#",
  "rdfa": "http://www.w3.org/ns/rdfa#",
  "remus": "http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#",
  "ddl": "http://purl.org/vocab/riro/ddl#",
  "sioca": "http://rdfs.org/sioc/actions#",
  "cb": "http://cbasewrap.ontologycentral.com/vocab#",
  "algo": "http://securitytoolbox.appspot.com/securityAlgorithms#",
  "exo": "https://w3id.org/example#",
  "tr": "http://www.thomsonreuters.com/",
  "wsc": "http://www.openk.org/wscaim.owl#",
  "datafaqs": "http://purl.org/twc/vocab/datafaqs#",
  "sawsdl": "http://www.w3.org/ns/sawsdl#",
  "td": "https://www.w3.org/2019/wot/td#",
  "psych": "http://purl.org/vocab/psychometric-profile/",
  "httpvoc": "http://www.w3.org/2006/http#",
  "tio": "http://purl.org/tio/ns#",
  "nex": "http://www.nexml.org/2009/",
  "identity": "http://purl.org/twc/ontologies/identity.owl#",
  "infosys": "http://www.infosys.com/",
  "phss": "http://ns.poundhill.com/phss/1.0/",
  "esd": "http://def.esd.org.uk/",
  "gridworks": "http://purl.org/net/opmv/types/gridworks#",
  "opwn": "http://www.ontologyportal.org/WordNet.owl#",
  "scsv": "http://purl.org/NET/schema-org-csv#",
  "geom": "http://data.ign.fr/def/geometrie#",
  "osr": "http://dati.senato.it/osr/",
  "psh": "http://ns.inria.fr/probabilistic-shacl/",
  "gs1": "https://ref.gs1.org/voc/",
  "common": "http://www.w3.org/2007/uwa/context/common.owl#",
  "esdir": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#",
  "wl": "http://www.wsmo.org/ns/wsmo-lite#",
  "tags": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "fab": "http://purl.org/fab/ns#",
  "wisski": "http://wiss-ki.eu/",
  "prissma": "http://ns.inria.fr/prissma/v1#",
  "dnb": "http://d-nb.info/gnd/",
  "copyright": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "imreg": "http://www.w3.org/2004/02/image-regions#",
  "pmlp": "http://inference-web.org/2.0/pml-provenance.owl#",
  "nsa": "http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#",
  "ezcontext": "http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#",
  "ogp": "http://ogp.me/ns#",
  "prf": "http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#",
  "dita": "http://purl.org/dita/ns#",
  "session": "http://redfoot.net/2005/session#",
  "drug": "http://www.agfa.com/w3c/2009/drugTherapy#",
  "span": "http://www.ifomis.org/bfo/1.1/span#",
  "geographis": "http://telegraphis.net/ontology/geography/geography#",
  "eprints": "http://eprints.org/ontology/",
  "pml": "http://provenanceweb.org/ns/pml#",
  "lr": "http://linkedrecipes.org/schema/",
  "xt": "http://purl.org/twc/vocab/cross-topix#",
  "wfm": "http://purl.org/net/wf-motifs#",
  "dbt": "http://dbpedia.org/resource/Template:",
  "pccz": "http://purl.org/procurement/public-contracts-czech#",
  "dbpedia2": "http://dbpedia.org/property/",
  "ecc": "https://ns.eccenca.com/",
  "osoc": "http://web-semantics.org/ns/opensocial#",
  "rulz": "http://purl.org/NET/rulz#",
  "ple": "http://pleiades.stoa.org/places/",
  "pam": "http://prismstandard.org/namespaces/pam/2.0/",
  "status": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "admssw": "http://purl.org/adms/sw/",
  "provenir": "http://knoesis.wright.edu/provenir/provenir.owl#",
  "fowl": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
  "visit": "http://purl.org/net/vocab/2004/07/visit#",
  "smiley": "http://www.smileyontology.com/ns#",
  "san": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
  "ecos": "http://purl.org/ecos#",
  "ecb": "http://ecb.270a.info/class/1.0/",
  "timeline": "http://purl.org/NET/c4dm/timeline.owl#",
  "grel": "http://users.ugent.be/~bjdmeest/function/grel.ttl#",
  "wbc": "http://worldbank.270a.info/classification/",
  "elog": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "tp": "https://triplydb.com/Triply/tp/def/",
  "units": "http://eulersharp.sourceforge.net/2003/03swap/units#",
  "agent": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "sl": "http://www.semanlink.net/2001/00/semanlink-schema#",
  "visko": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "cao": "http://purl.org/makolab/caont/",
  "dsp": "http://purl.org/metainfo/terms/dsp#",
  "pimo": "http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#",
  "human": "http://eulersharp.sourceforge.net/2003/03swap/human#",
  "np": "http://www.nanopub.org/nschema#",
  "quantity": "http://qudt.org/schema/quantity#",
  "sindice": "http://vocab.sindice.net/",
  "mesh": "http://id.nlm.nih.gov/mesh/",
  "omv": "http://omv.ontoware.org/2005/05/ontology#",
  "sysont": "http://ns.ontowiki.net/SysOnt/",
  "iswc": "http://annotation.semanticweb.org/2004/iswc#",
  "odp": "http://ontologydesignpatterns.org/",
  "ibis": "http://purl.org/ibis#",
  "hxl": "http://hxl.humanitarianresponse.info/ns/#",
  "vf": "https://w3id.org/valueflows/ont/vf#",
  "skip": "http://skipforward.net/skipforward/resource/",
  "ling": "http://purl.org/voc/ling/",
  "wordmap": "http://purl.org/net/ns/wordmap#",
  "reve": "http://data.eurecom.fr/ontology/reve#",
  "xsl": "http://www.w3.org/1999/XSL/Transform#",
  "sm": "http://topbraid.org/sparqlmotion#",
  "dis": "http://stanbol.apache.org/ontology/disambiguation/disambiguation#",
  "eztag": "http://ontologies.ezweb.morfeo-project.org/eztag/ns#",
  "rdo": "http://purl.org/rdo/ns#",
  "doco": "http://purl.org/spar/doco/",
  "olo": "http://purl.org/ontology/olo/core#",
  "nxp": "http://purl.org/nxp/schema/v1/",
  "ncal": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
  "c4n": "http://vocab.deri.ie/c4n#",
  "cl": "http://advene.org/ns/cinelab/",
  "lt": "http://diplomski.nelakolundzija.org/LTontology.rdf#",
  "json": "https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#",
  "mei": "http://www.music-encoding.org/ns/mei/",
  "osgb": "http://data.ordnancesurvey.co.uk/id/",
  "out": "http://ontologies.hypios.com/out#",
  "un": "http://www.w3.org/2007/ont/unit#",
  "swanci": "http://purl.org/swan/1.2/citations/",
  "pns": "http://data.press.net/ontology/stuff/",
  "gv": "http://rdf.data-vocabulary.org/#",
  "zbwext": "http://zbw.eu/namespaces/zbw-extensions/",
  "carfo": "http://purl.org/carfo#",
  "arpfo": "http://vocab.ouls.ox.ac.uk/projectfunding#",
  "geofla": "http://data.ign.fr/ontologies/geofla#",
  "gazetteer": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
  "ipad": "http://www.padinthecity.com/",
  "orca": "http://geni-orca.renci.org/owl/topology.owl#",
  "soap": "http://www.w3.org/2003/05/soap-envelope/",
  "fl": "http://eulersharp.sourceforge.net/2003/03swap/fl-rules#",
  "dossier": "https://data.omgeving.vlaanderen.be/ns/dossier#",
  "ne": "http://umbel.org/umbel/ne/",
  "geop": "http://aims.fao.org/aos/geopolitical.owl#",
  "func": "http://www.w3.org/2007/rif-builtin-function#",
  "prvtypes": "http://purl.org/net/provenance/types#",
  "decl": "http://www.linkedmodel.org/1.0/schema/decl#",
  "aapi": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "nsl": "http://purl.org/ontology/storyline/",
  "trackback": "http://madskills.com/public/xml/rss/module/trackback/",
  "life": "http://life.deri.ie/schema/",
  "sql": "http://ns.inria.fr/ast/sql#",
  "spif": "http://spinrdf.org/spif#",
  "fcm": "http://eulersharp.sourceforge.net/2006/02swap/fcm#",
  "myprefix": "http://myprefix.org/",
  "dgfoaf": "http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#",
  "ecpo": "http://purl.org/ontology/ecpo#",
  "gelo": "http://krauthammerlab.med.yale.edu/ontologies/gelo#",
  "luc": "http://www.ontotext.com/owlim/lucene#",
  "opus": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
  "agents": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
  "set": "http://www.w3.org/2000/10/swap/set#",
  "aigp": "http://swat.cse.lehigh.edu/resources/onto/aigp.owl#",
  "dtype": "http://www.linkedmodel.org/schema/dtype#",
  "nytimes": "http://data.nytimes.com/elements/",
  "gc": "http://www.oegov.org/core/owl/gc#",
  "dpd": "http://www.kanzaki.com/ns/dpd#",
  "swanpav": "http://purl.org/swan/1.2/pav/",
  "eye": "http://jena.hpl.hp.com/Eyeball#",
  "govtrackus": "http://www.rdfabout.com/rdf/usgov/geo/us/",
  "enhancer": "http://stanbol.apache.org/ontology/enhancer/enhancer#",
  "wairole": "http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#",
  "atomowl": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "muni": "http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#",
  "pmlt": "http://inference-web.org/2.0/pml-trust.owl#",
  "agrelon": "http://d-nb.info/standards/elementset/agrelon#",
  "rlno": "http://rdflivenews.aksw.org/ontology/",
  "sor": "http://purl.org/net/soron/",
  "prolog": "http://eulersharp.sourceforge.net/2003/03swap/prolog#",
  "hgnc": "http://bio2rdf.org/hgnc:",
  "ls": "http://linkedspending.aksw.org/instance/",
  "pne": "http://data.press.net/ontology/event/",
  "wf": "http://www.w3.org/2005/01/wf/flow#",
  "rdagr1": "http://rdvocab.info/Elements/",
  "xhtmlvocab": "http://www.w3.org/1999/xhtml/vocab/",
  "rad": "http://www.w3.org/ns/rad#",
  "oboro": "http://obofoundry.org/ro/ro.owl#",
  "comm": "http://vocab.resc.info/communication#",
  "bioskos": "http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#",
  "sw": "http://linkedwidgets.org/statisticalwidget/ontology/",
  "evopat": "http://ns.aksw.org/Evolution/",
  "organiz": "http://eulersharp.sourceforge.net/2003/03swap/organization#",
  "webtlab": "http://webtlab.it.uc3m.es/",
  "cidoccrm": "http://purl.org/NET/cidoc-crm/core#",
  "dummy": "http://hello.com/",
  "sdgp": "http://stats.data-gov.ie/property/",
  "xbrli": "http://www.xbrl.org/2003/instance#",
  "nid3": "http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#",
  "semtweet": "http://semantictweet.com/",
  "rdam": "http://rdaregistry.info/Elements/m/",
  "ens": "http://models.okkam.org/ENS-core-vocabulary.owl#",
  "pf": "http://jena.hpl.hp.com/ARQ/property#",
  "open": "http://open.vocab.org/terms/",
  "rkd": "http://data.rkd.nl/def#",
  "r2r": "http://www4.wiwiss.fu-berlin.de/bizer/r2r/",
  "derecho": "http://purl.org/derecho#",
  "prefix": "http://prefix.cc/",
  "dgtwc": "http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#",
  "req": "http://purl.org/req/",
  "commons": "http://commons.psi.enakting.org/def/",
  "w3p": "http://prov4j.org/w3p/",
  "transit": "http://vocab.org/transit/terms/",
  "wao": "http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#",
  "aneo": "http://akonadi-project.org/ontologies/aneo#",
  "steel": "https://w3id.org/steel/ProcessOntology/",
  "linkedct": "http://data.linkedct.org/vocab/",
  "vcardx": "http://buzzword.org.uk/rdf/vcardx#",
  "sad": "http://vocab.deri.ie/sad#",
  "owltime": "http://www.w3.org/TR/owl-time#",
  "qa": "http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#",
  "dqv": "http://www.w3.org/ns/dqv#",
  "plo": "http://purl.org/net/po#",
  "pna": "http://data.press.net/ontology/asset/",
  "httpm": "http://www.w3.org/2011/http-methods#",
  "agetec": "http://www.agetec.org/",
  "rso": "http://www.researchspace.org/ontology/",
  "plink": "http://buzzword.org.uk/rdf/personal-link-types#",
  "tvc": "http://www.essepuntato.it/2012/04/tvc/",
  "moby": "http://www.mygrid.org.uk/mygrid-moby-service#",
  "theatre": "http://purl.org/theatre#",
  "ospost": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
  "abs": "http://abs.270a.info/dataset/",
  "xesam": "http://freedesktop.org/standards/xesam/1.0/core#",
  "opl": "http://openlinksw.com/schema/attribution#",
  "gxa": "http://www.ebi.ac.uk/gxa/",
  "ifc": "http://ifcowl.openbimstandards.org/IFC2X3_Final#",
  "qdoslf": "http://foaf.qdos.com/lastfm/schema/",
  "ianarel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "rdaw": "http://rdaregistry.info/Elements/w/",
  "oax": "http://www.w3.org/ns/openannotation/extensions/",
  "aersv": "http://aers.data2semantics.org/vocab/",
  "frbre": "http://purl.org/vocab/frbr/extended#",
  "tripfs": "http://purl.org/tripfs/2010/02#",
  "fc": "http://www.freeclass.eu/freeclass_v1#",
  "nyt": "http://data.nytimes.com/",
  "owls": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "geodata": "http://sws.geonames.org/",
  "rml": "http://w3id.org/rml/",
  "dl": "http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#",
  "frbrcore": "http://purl.org/vocab/frbr/core#",
  "wapp": "http://ns.rww.io/wapp#",
  "hemogram": "http://www.agfa.com/w3c/2009/hemogram#",
  "oj": "http://ontojob.at/",
  "wikibase": "http://wikiba.se/ontology#",
  "italy": "http://data.kasabi.com/dataset/italy/schema/",
  "no": "http://km.aifb.kit.edu/projects/numbers/number#",
  "aims": "http://aims.fao.org/aos/common/",
  "htir": "http://www.w3.org/2011/http#",
  "dbpo": "http://dbpedia.org/ontology/",
  "xfnv": "http://vocab.sindice.com/xfn#",
  "va": "http://code-research.eu/ontology/visual-analytics#",
  "lindt": "http://purl.org/NET/lindt#",
  "emotion": "http://ns.inria.fr/emoca#",
  "swpo": "http://sw-portal.deri.org/ontologies/swportal#",
  "oecd": "http://oecd.270a.info/dataset/",
  "protons": "http://proton.semanticweb.org/2005/04/protons#",
  "metalex": "http://www.metalex.eu/schema/1.0#",
  "dctypes": "http://purl.org/dc/dcmitype/",
  "tcga": "http://purl.org/tcga/core#",
  "oboso": "http://purl.org/obo/owl/SO#",
  "languages": "http://eulersharp.sourceforge.net/2003/03swap/languages#",
  "kw": "http://kwantu.net/kw/",
  "health": "http://purl.org/twc/health/vocab/",
  "intervals": "http://reference.data.gov.uk/def/intervals/",
  "quak": "http://dev.w3.org/cvsweb/2000/quacken/vocab#",
  "flow": "http://www.w3.org/2005/01/wf/flow#",
  "wfdesc": "http://purl.org/wf4ever/wfdesc#",
  "estrn": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#",
  "solid": "http://www.w3.org/ns/solid/terms#",
  "scowt": "http://purl.org/weso/ontologies/scowt#",
  "atlas": "http://rdf.ebi.ac.uk/resource/atlas/",
  "xch": "http://oanda2rdf.appspot.com/xch/",
  "sro": "http://salt.semanticauthoring.org/ontologies/sro#",
  "rpubl": "http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#",
  "fct": "http://openlinksw.com/services/facets/1.0/",
  "c4o": "http://purl.org/spar/c4o/",
  "iron": "http://purl.org/ontology/iron#",
  "eseduc": "http://www.purl.org/ontologia/eseduc#",
  "mmo": "http://purl.org/momayo/mmo/",
  "tripfs2": "http://purl.org/tripfs/2010/06#",
  "oper": "http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#",
  "kdo": "http://kdo.render-project.eu/kdo#",
  "jita": "http://aims.fao.org/aos/jita/",
  "opmv": "http://purl.org/net/opmv/ns#",
  "shex": "http://www.w3.org/ns/shex#",
  "swo": "http://www.ebi.ac.uk/swo/",
  "ogorg": "http://opengraph.org/schema/",
  "crtv": "http://open-services.net/ns/crtv#",
  "swanag": "http://purl.org/swan/1.2/agents/",
  "npgd": "http://ns.nature.com/datasets/",
  "transmed": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
  "rich": "http://rdf.data-vocabulary.org/",
  "lgv": "http://linkedgeodata.org/ontology/",
  "qu": "http://purl.oclc.org/NET/ssnx/qu/qu#",
  "gbv": "http://purl.org/ontology/gbv/",
  "re": "http://www.w3.org/2000/10/swap/reason#",
  "crmdig": "http://www.ics.forth.gr/isl/CRMdig/",
  "opmw": "http://www.opmw.org/ontology/",
  "rating": "http://www.tvblob.com/ratings/#",
  "ncit": "http://purl.obolibrary.org/obo/NCIT_",
  "hartigprov": "http://purl.org/net/provenance/ns#",
  "clineva": "http://www.agfa.com/w3c/2009/clinicalEvaluation#",
  "environ": "http://eulersharp.sourceforge.net/2003/03swap/environment#",
  "govwild": "http://govwild.org/0.6/GWOntology.rdf/",
  "bdd": "https://api.bloomberg.com/eap/catalogs/bbg/fields/",
  "wm": "http://ns.inria.fr/webmarks#",
  "cf": "http://mmisw.org/ont/cf/parameter/",
  "gfo": "http://www.onto-med.de/ontologies/gfo.owl#",
  "humanbody": "http://eulersharp.sourceforge.net/2003/03swap/humanBody#",
  "ccard": "http://purl.org/commerce/creditcard#",
  "dssn": "http://purl.org/net/dssn/",
  "events": "http://eulersharp.sourceforge.net/2003/03swap/event#",
  "bm": "http://bio2rdf.org/",
  "nndsr": "http://semanticdiet.com/schema/usda/nndsr/",
  "ufmedia": "http://purl.org/microformat/hmedia/",
  "aair": "http://xmlns.notu.be/aair#",
  "fingal": "http://vocab.deri.ie/fingal#",
  "sgv": "http://www.w3.org/TR/SVG/",
  "igeo": "http://rdf.insee.fr/def/geo#",
  "ldr": "http://purl.oclc.org/NET/ldr/ns#",
  "emp": "http://purl.org/ctic/empleo/oferta#",
  "kontakt": "http://richard.cyganiak.de/",
  "goef": "http://purl.org/twc/vocab/goef#",
  "coeus": "http://bioinformatics.ua.pt/coeus/",
  "daq": "http://purl.org/eis/vocab/daq#",
  "openskos": "http://openskos.org/xmlns#",
  "skiresort": "http://www.openlinksw.com/ski_resorts/schema#",
  "sig": "http://purl.org/signature#",
  "osmsemnet": "http://spatial.ucd.ie/2012/08/osmsemnet/",
  "bookmark": "http://www.w3.org/2002/01/bookmark#",
  "mohammad": "http://manesht.ir/",
  "cdtype": "http://purl.org/cld/cdtype/",
  "ru": "http://purl.org/imbi/ru-meta.owl#",
  "occult": "http://data.totl.net/occult/",
  "coun": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
  "dayta": "http://dayta.me/resource#",
  "cold": "http://purl.org/configurationontology#",
  "telix": "http://purl.org/telix#",
  "d2r": "http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#",
  "marshall": "http://sites.google.com/site/xgmaitc/",
  "hcard": "http://purl.org/uF/hCard/terms/",
  "ccom": "http://purl.org/ontology/cco/mappings#",
  "tmpl": "http://purl.org/restdesc/http-template#",
  "bco": "http://purl.obolibrary.org/obo/bco.owl#",
  "tei": "http://www.tei-c.org/ns/1.0/",
  "npgg": "http://ns.nature.com/graphs/",
  "dive": "http://scubadive.networld.to/dive.rdf#",
  "artstor": "http://simile.mit.edu/2003/10/ontologies/artstor#",
  "loticoowl": "http://www.lotico.com/ontology/",
  "arecipe": "http://purl.org/amicroformat/arecipe/",
  "daiaserv": "http://purl.org/ontology/daia/Service/",
  "date": "http://contextus.net/ontology/ontomedia/misc/date#",
  "frad": "http://iflastandards.info/ns/fr/frad/",
  "ipo": "http://purl.org/ipo/core#",
  "frapo": "http://purl.org/cerif/frapo/",
  "wscaim": "http://www.openk.org/wscaim.owl#",
  "grs": "http://www.georss.org/georss/",
  "adr": "http://kg.artsdata.ca/resource/",
  "prism21": "http://prismstandard.org/namespaces/basic/2.1/",
  "rankrage": "https://rankrage.de/",
  "paia": "http://purl.org/ontology/paia#",
  "clinic": "http://example.com/clinic#",
  "kupkb": "http://www.e-lico.eu/data/kupkb/",
  "mte": "http://nl.ijs.si/ME/owl/",
  "protegedc": "http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#",
  "dannet": "http://www.wordnet.dk/owl/instance/2009/03/instances/",
  "ev": "http://www.w3.org/2001/xml-events/",
  "genab": "http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#",
  "harrisons": "http://harrisons.cc/",
  "bcncon": "http://datos.bcn.cl/ontologies/bcn-congress#",
  "pso": "http://purl.org/spar/pso/",
  "property": "http://fr.dbpedia.org/property/",
  "decision": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
  "tao": "http://pubannotation.org/ontology/tao.owl#",
  "wro": "http://purl.org/net/wf4ever/ro#",
  "osukdt": "http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#",
  "stac": "http://securitytoolbox.appspot.com/stac#",
  "diseasome": "http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/",
  "ends": "http://labs.mondeca.com/vocab/endpointStatus#",
  "bk": "http://www.provbook.org/ns/#",
  "p20": "http://zbw.eu/beta/p20/vocab/",
  "ost": "http://w3id.org/ost/ns#",
  "pco": "http://purl.org/procurement/public-contracts#",
  "csm": "http://purl.org/csm/1.0#",
  "s2s": "http://escience.rpi.edu/ontology/sesf/s2s/4/0/",
  "curr": "https://w3id.org/cc#",
  "pizza": "http://www.co-ode.org/ontologies/pizza/pizza.owl#",
  "str": "http://nlp2rdf.lod2.eu/schema/string/",
  "mod": "http://www.isibang.ac.in/ns/mod#",
  "l4a": "http://labels4all.info/ns/",
  "lod2": "http://lod2.eu/schema/",
  "wno": "http://wordnet-rdf.princeton.edu/ontology#",
  "mads": "http://www.loc.gov/mads/rdf/v1#",
  "odo": "http://ocean-data.org/schema/",
  "penis": "http://penis.to/#",
  "kbp": "http://tackbp.org/2013/ontology#",
  "lso": "http://linkedspending.aksw.org/ontology/",
  "skos08": "http://www.w3.org/2008/05/skos#",
  "wfprov": "http://purl.org/wf4ever/wfprov#",
  "shacl": "http://www.w3.org/ns/shacl#",
  "genea": "http://www.owl-ontologies.com/generations.owl#",
  "fma": "http://sig.uw.edu/fma#",
  "b2rpubchem": "http://bio2rdf.org/ns/ns/ns/pubchem#",
  "gesis": "http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#",
  "rdacarrier": "http://rdvocab.info/termList/RDACarrierType/",
  "verb": "https://w3id.org/verb/",
  "sci": "http://data.scientology.org/ns/",
  "ds": "http://purl.org/ctic/dcat#",
  "art": "http://w3id.org/art/terms/1.0/",
  "nocal": "http://vocab.deri.ie/nocal#",
  "atomrdf": "http://atomowl.org/ontologies/atomrdf#",
  "poder": "http://poderopedia.com/vocab/",
  "doas": "http://deductions.github.io/doas.owl.ttl#",
  "hasco": "http://hadatac.org/ont/hasco/",
  "sbench": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "oslo": "http://purl.org/oslo/ns/localgov#",
  "wsl": "http://www.wsmo.org/ns/wsmo-lite#",
  "scms": "http://ns.aksw.org/scms/annotations/",
  "dpl": "http://dbpedialite.org/things/",
  "vgo": "http://purl.org/net/VideoGameOntology#",
  "opllic": "http://www.openlinksw.com/ontology/licenses#",
  "of": "http://owlrep.eu01.aws.af.cm/fridge#",
  "smg": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
  "prvr": "http://purl.org/ontology/prv/rules#",
  "camelot": "http://vocab.ox.ac.uk/camelot#",
  "dpc": "http://hospee.org/ontologies/dpc/",
  "itsmo": "http://ontology.it/itsmo/v1#",
  "biordf": "http://purl.org/net/biordfmicroarray/ns#",
  "pod": "https://project-open-data.cio.gov/v1.1/schema/#",
  "lio": "http://purl.org/net/lio#",
  "tac": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
  "scor": "http://purl.org/eis/vocab/scor#",
  "sam": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
  "prvt": "http://purl.org/net/provenance/types#",
  "lc": "http://semweb.mmlab.be/ns/linkedconnections#",
  "omnlife": "http://open-multinet.info/ontology/omn-lifecycle#",
  "healthcare": "http://www.agfa.com/w3c/2009/healthCare#",
  "cpsv": "http://purl.org/vocab/cpsv#",
  "dn": "http://purl.org/datanode/ns/",
  "insdc": "http://ddbj.nig.ac.jp/ontologies/sequence#",
  "opencyc": "http://sw.opencyc.org/concept/",
  "ptop": "http://www.ontotext.com/proton/protontop#",
  "bv": "http://purl.org/vocommons/bv#",
  "osp": "http://data.lirmm.fr/ontologies/osp#",
  "clinproc": "http://www.agfa.com/w3c/2009/clinicalProcedure#",
  "lh": "http://vocab.inf.ed.ac.uk/library/holdings#",
  "latitude": "https://www.w3.org/2006/vcard/ns#",
  "ql": "http://www.w3.org/2004/ql#",
  "faq": "http://www.openlinksw.com/ontology/faq#",
  "campsite": "http://www.openlinksw.com/campsites/schema#",
  "shoah": "http://dati.cdec.it/lod/shoah/",
  "sioctypes": "http://rdfs.org/sioc/types#",
  "aerols": "http://xmlns.com/aerols/0.1/",
  "sso": "http://nlp2rdf.lod2.eu/schema/sso/",
  "ssso": "http://purl.org/ontology/ssso#",
  "jpo": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "mpeg7": "http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#",
  "shw": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
  "cart": "http://purl.org/net/cartCoord#",
  "tisc": "http://observedchange.com/tisc/ns#",
  "okg": "http://openknowledgegraph.org/ontology/",
  "centrifuge": "http://purl.org/twc/vocab/centrifuge#",
  "mmd": "http://musicbrainz.org/ns/mmd-1.0#",
  "ngeoi": "http://vocab.lenka.no/geo-deling#",
  "guo": "http://purl.org/hpi/guo#",
  "category": "http://dbpedia.org/resource/Category:",
  "te": "http://www.w3.org/2006/time-entry#",
  "gov": "http://gov.genealogy.net/ontology.owl#",
  "iol": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
  "chembl": "http://rdf.ebi.ac.uk/terms/chembl#",
  "dbyago": "http://dbpedia.org/class/yago/",
  "refe": "http://orion.tw.rpi.edu/~xgmatwc/refe/",
  "pronom": "http://reference.data.gov.uk/technical-registry/",
  "security": "http://securitytoolbox.appspot.com/securityMain#",
  "sao": "http://salt.semanticauthoring.org/ontologies/sao#",
  "hifm": "http://purl.org/net/hifm/data#",
  "dash": "http://datashapes.org/dash#",
  "vsto": "http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#",
  "ebu": "http://semantic.eurobau.com/eurobau-utility.owl#",
  "thors": "http://resource.geosciml.org/ontology/timescale/thors#",
  "ottr": "http://ns.ottr.xyz/templates#",
  "alchemy": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
  "stream": "http://dbpedia.org/ontology/Stream/",
  "mtecore": "http://purl.org/olia/mte/multext-east.owl#",
  "rdamt": "http://rdaregistry.info/termList/RDAMediaType/",
  "ecrm": "http://erlangen-crm.org/current/",
  "qrl": "http://www.aifb.kit.edu/project/ld-retriever/qrl#",
  "lctr": "http://data.linkedct.org/vocab/resource/",
  "rec54": "http://www.w3.org/2001/02pd/rec54.rdf#",
  "saxon": "http://saxon.sf.net/",
  "cis": "http://purl.org/NET/cloudisus#",
  "xlime": "http://xlime-project.org/vocab/",
  "twaapi": "http://purl.org/twc/vocab/aapi-schema#",
  "trait": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
  "tw": "http://tw.rpi.edu/schema/",
  "oml": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
  "cpant": "http://purl.org/NET/cpan-uri/terms#",
  "onssprel": "http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#",
  "odcs": "http://opendata.cz/infrastructure/odcleanstore/",
  "malignneo": "http://www.agfa.com/w3c/2009/malignantNeoplasm#",
  "lsc": "http://linkedscience.org/lsc/ns#",
  "cosmo": "http://purl.org/ontology/cosmo#",
  "dpv": "http://www.w3.org/ns/dpv#",
  "oarj": "http://opendepot.org/reference/linked/1.0/",
  "idemo": "http://rdf.insee.fr/def/demo#",
  "who": "http://www.who.int/vocab/ontology#",
  "msr": "http://www.telegraphis.net/ontology/measurement/measurement#",
  "bcnnorms": "http://datos.bcn.cl/ontologies/bcn-norms#",
  "cts2": "http://schema.omg.org/spec/CTS2/1.0/",
  "w3con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "bgdbp": "http://bg.dbpedia.org/property/",
  "zoomaterms": "http://rdf.ebi.ac.uk/vocabulary/zooma/",
  "ekaw": "http://data.semanticweb.org/conference/ekaw/2012/complete/",
  "bihap": "http://bihap.kb.gov.tr/ontology/",
  "yo": "http://yovisto.com/",
  "fao": "http://fao.270a.info/dataset/",
  "obsm": "http://rdf.geospecies.org/methods/observationMethod#",
  "germplasm": "http://purl.org/germplasm/terms#",
  "wlo": "http://purl.org/ontology/wo/",
  "xrd": "http://docs.oasis-open.org/ns/xri/xrd-1.0#",
  "osgeom": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
  "hints2005": "http://purl.org/twc/cabig/model/HINTS2005-1.owl#",
  "raul": "http://vocab.deri.ie/raul#",
  "strdf": "http://strdf.di.uoa.gr/ontology#",
  "gf": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
  "pkmn": "http://pokedex.dataincubator.org/pkm/",
  "vin": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
  "pnt": "http://data.press.net/ontology/tag/",
  "li": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
  "l4lod": "http://ns.inria.fr/l4lod/v2/",
  "crv": "http://purl.org/twc/vocab/datacarver#",
  "geovocab": "http://geovocab.org/",
  "c4dm": "http://purl.org/NET/c4dm/event.owl#",
  "ccrel": "http://creativecommons.org/ns#",
  "goog": "http://schema.googleapis.com/",
  "qud": "http://qudt.org/1.1/schema/qudt#",
  "conf": "http://richard.cyganiak.de/2007/pubby/config.rdf#",
  "scoro": "http://purl.org/spar/scoro/",
  "rdafr": "http://rdaregistry.info/termList/frequency/",
  "dr": "http://purl.org/swan/2.0/discourse-relationships/",
  "rmo": "http://eatld.et.tu-dresden.de/rmo#",
  "ep": "http://eprints.org/ontology/",
  "antenne": "https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#",
  "dawgt": "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
  "mmf": "http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#",
  "vartrans": "http://www.w3.org/ns/lemon/vartrans#",
  "rdarel2": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
  "oae": "http://www.ics.forth.gr/isl/oae/core#",
  "lsmap": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "part": "http://purl.org/vocab/participation/schema#",
  "op": "http://environment.data.gov.au/def/op#",
  "rdae": "http://rdaregistry.info/Elements/e/",
  "mico": "http://www.mico-project.eu/ns/platform/1.0/schema#",
  "quantities": "http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#",
  "tm": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
  "odrs": "http://schema.theodi.org/odrs#",
  "emtr": "http://purl.org/NET/ssnext/electricmeters#",
  "brick": "https://brickschema.org/schema/Brick#",
  "puelia": "http://kwijibo.talis.com/vocabs/puelia#",
  "semio": "http://www.lingvoj.org/semio#",
  "seq": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
  "sdmxd": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "bn": "http://babelnet.org/rdf/",
  "s4ac": "http://ns.inria.fr/s4ac/v2#",
  "oplcert": "http://www.openlinksw.com/schemas/cert#",
  "webbox": "http://webbox.ecs.soton.ac.uk/ns#",
  "rssynd": "http://web.resource.org/rss/1.0/modules/syndication/",
  "bgt": "https://bgt.basisregistraties.overheid.nl/bgt/def/",
  "rdafnm": "http://rdaregistry.info/termList/FormNoteMus/",
  "rdasoi": "http://rdaregistry.info/termList/statIdentification/",
  "esco": "http://data.europa.eu/esco/model#",
  "stories": "http://purl.org/ontology/stories/",
  "pv": "https://piveau.eu/ns/voc#",
  "dbcat": "http://dbpedia.org/resource/Category:",
  "omapi": "http://purl.org/omapi/0.2/#",
  "dcs": "http://ontologi.es/doap-changeset#",
  "activity": "https://www.w3.org/TR/activitystreams-vocabulary/",
  "ll": "http://lodlaundromat.org/resource/",
  "namespaces": "https://vg.no/",
  "wb": "http://data.worldbank.org/",
  "crml": "http://semweb.mmlab.be/ns/rml/condition#",
  "wikterms": "http://wiktionary.dbpedia.org/terms/",
  "fos": "http://futurios.org/fos/spec/",
  "lcy": "http://purl.org/vocab/lifecycle/schema#",
  "kbv": "https://id.kb.se/vocab/",
  "d2d": "http://rdfns.org/d2d/",
  "bgn": "http://bibliograph.net/schemas/",
  "disease": "http://www.agfa.com/w3c/2009/humanDisorder#",
  "oan": "http://data.lirmm.fr/ontologies/oan/",
  "dcndl": "http://ndl.go.jp/dcndl/terms/",
  "seokoeln": "http://rankrage.de/",
  "vsso": "http://automotive.eurecom.fr/vsso#",
  "mb": "http://dbtune.org/musicbrainz/resource/instrument/",
  "laposte": "http://data.lirmm.fr/ontologies/laposte#",
  "spt": "http://spitfire-project.eu/ontology/ns/",
  "mv": "http://schema.mobivoc.org/",
  "tblcard": "http://www.w3.org/People/Berners-Lee/card#",
  "cbo": "http://comicmeta.org/cbo/",
  "wkd": "http://schema.wolterskluwer.de/",
  "eui": "http://institutions.publicdata.eu/#",
  "lodac": "http://lod.ac/ns/lodac#",
  "rdacontent": "http://rdvocab.info/termList/RDAContentType/",
  "mt": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "holding": "http://purl.org/ontology/holding#",
  "my": "http://www.mobile.com/model/",
  "rdamedia": "http://rdvocab.info/termList/RDAMediaType/",
  "nidm": "http://nidm.nidash.org/",
  "mged": "http://mged.sourceforge.net/ontologies/MGEDOntology.owl#",
  "gastro": "http://www.ebsemantics.net/gastro#",
  "lsqv": "http://lsq.aksw.org/vocab#",
  "pingback": "http://purl.org/net/pingback/",
  "kees": "http://linkeddata.center/kees/v1#",
  "cwrc": "http://sparql.cwrc.ca/ontology/cwrc#",
  "xapi": "https://w3id.org/xapi/ontology#",
  "vsws": "http://verticalsearchworks.com/ontology/synset#",
  "gl": "http://schema.geolink.org/",
  "finlaw": "http://purl.org/finlex/schema/laki/",
  "im": "http://imgpedia.dcc.uchile.cl/resource/",
  "tg": "https://triplydb.com/Triply/tg/def/",
  "sg": "http://name.scigraph.com/ontologies/core/",
  "xcql": "http://docs.oasis-open.org/ns/search-ws/xcql#",
  "scip": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
  "cbase": "http://ontologycentral.com/2010/05/cb/vocab#",
  "deps": "http://ontologi.es/doap-deps#",
  "pattern": "http://www.essepuntato.it/2008/12/pattern#",
  "delta": "http://www.w3.org/2004/delta#",
  "telmap": "http://purl.org/telmap/",
  "dqm": "http://purl.org/dqm-vocabulary/v1/dqm#",
  "pni": "http://data.press.net/ontology/identifier/",
  "dbpr": "http://dbpedia.org/resource/",
  "pnc": "http://data.press.net/ontology/classification/",
  "onyx": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
  "allot": "https://w3id.org/akn/ontology/allot#",
  "ogc": "http://www.opengis.net/def/",
  "rdacct": "http://rdaregistry.info/termList/CollTitle/",
  "cvbase": "http://purl.org/captsolo/resume-rdf/0.2/base#",
  "quty": "http://www.telegraphis.net/ontology/measurement/quantity#",
  "prof": "http://www.w3.org/ns/dx/prof/",
  "ox": "http://vocab.ox.ac.uk/projectfunding#",
  "app": "http://jmvanel.free.fr/ontology/software_applications.n3#",
  "c9d": "http://purl.org/twc/vocab/conversion/",
  "doi": "https://doi.org/",
  "mrel": "http://id.loc.gov/vocabulary/relators/",
  "auto": "http://auto.schema.org/",
  "moac": "http://observedchange.com/moac/ns#",
  "accom": "http://purl.org/acco/ns#",
  "gm": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
  "saws": "http://purl.org/saws/ontology#",
  "rvdata": "http://data.rvdata.us/",
  "snarm": "http://rdf.myexperiment.org/ontologies/snarm/",
  "fog": "https://w3id.org/fog#",
  "ostop": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
  "affymetrix": "http://bio2rdf.org/affymetrix_vocabulary:",
  "friends": "http://www.openarchives.org/OAI/2.0/friends/",
  "stats": "http://purl.org/rdfstats/stats#",
  "osspr": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "lmo": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#",
  "daisy": "http://www.daisy.org/z3998/2012/vocab/",
  "rdatc": "http://rdaregistry.info/termList/trackConfig/",
  "lsweb": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
  "orth": "http://purl.org/net/orth#",
  "bcnbio": "http://datos.bcn.cl/ontologies/bcn-biographies#",
  "lldr": "http://purl.oclc.org/NET/lldr/ns#",
  "rdagd": "http://rdaregistry.info/termList/gender/",
  "evident": "http://purl.org/net/evident#",
  "fam": "http://vocab.fusepool.info/fam#",
  "foam": "https://www.koerperfettwaage-test.de/",
  "tsioc": "http://rdfs.org/sioc/types#",
  "oss": "http://opendata.caceres.es/def/ontosemanasanta#",
  "drm": "http://vocab.data.gov/def/drm#",
  "isocat": "http://www.isocat.org/datcat/",
  "dbrc": "http://dbpedia.org/resource/Category:",
  "fincaselaw": "http://purl.org/finlex/schema/oikeus/",
  "bgcat": "http://bg.dbpedia.org/resource/?????????:",
  "eumida": "http://data.kasabi.com/dataset/eumida/terms/",
  "mvco": "http://purl.oclc.org/NET/mvco.owl#",
  "od": "http://purl.org/twc/vocab/opendap#",
  "pair": "http://virtual-assembly.org/ontologies/pair#",
  "spfood": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
  "ftcontent": "http://www.ft.com/ontology/content/",
  "bot": "https://w3id.org/bot#",
  "origins": "http://origins.link/",
  "gcis": "http://data.globalchange.gov/gcis.owl#",
  "dbptmpl": "http://dbpedia.org/resource/Template:",
  "employee": "http://www.employee.com/data#",
  "dvia": "http://data.eurecom.fr/ontology/dvia#",
  "biro": "http://purl.org/spar/biro/",
  "mil": "http://rdf.muninn-project.org/ontologies/military#",
  "aers": "http://aers.data2semantics.org/resource/",
  "swperson": "http://data.semanticweb.org/person/",
  "driver": "http://deductions.github.io/drivers.owl.ttl#",
  "particip": "http://purl.org/vocab/participation/schema#",
  "ljkl": "http://teste.com/",
  "graffle": "http://purl.org/twc/vocab/vsr/graffle#",
  "agls": "http://www.agls.gov.au/agls/terms/",
  "nerd": "http://nerd.eurecom.fr/ontology#",
  "viso": "http://purl.org/viso/",
  "rdami": "http://rdaregistry.info/termList/modeIssue/",
  "radion": "http://www.w3.org/ns/radion#",
  "add": "https://mre.zcu.cz/ontology/stroke.owl#",
  "mml": "http://www.w3.org/1998/Math/MathML/",
  "salad": "https://w3id.org/cwl/salad#",
  "mtlo": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
  "wn31": "http://wordnet-rdf.princeton.edu/wn31/",
  "gpml": "http://vocabularies.wikipathways.org/gpml#",
  "turismo": "http://idi.fundacionctic.org/cruzar/turismo#",
  "npgx": "http://ns.nature.com/extensions/",
  "onc": "http://www.ics.forth.gr/isl/oncm/core#",
  "dao": "http://purl.org/dao#",
  "infor": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "esaloj": "http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#",
  "pkm": "http://www.ontotext.com/proton/protonkm#",
  "call": "http://webofcode.org/wfn/call:",
  "pvcs": "http://purl.org/twc/vocab/pvcs#",
  "company": "http://intellimind.io/ns/company#",
  "merge": "http://jazz.net/ns/lqe/merge/",
  "gawd": "http://gawd.atlantides.org/terms/",
  "ccp": "http://cookingbigdata.com/linkeddata/ccpricing#",
  "fcs": "http://clarin.eu/fcs/resource#",
  "rdagw": "http://rdaregistry.info/termList/grooveWidth/",
  "rdarel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "odpart": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
  "sct": "http://snomed.info/id/",
  "oh": "http://semweb.mmlab.be/ns/oh#",
  "llo": "http://lodlaundromat.org/ontology/",
  "icane": "http://www.icane.es/opendata/vocab#",
  "cdao": "http://purl.obolibrary.org/obo/",
  "ramon": "http://rdfdata.eionet.europa.eu/ramon/ontology/",
  "w3po": "http://purl.org/provenance/w3p/w3po#",
  "voidp": "http://www.enakting.org/provenance/voidp/",
  "ctorg": "http://purl.org/ctic/infraestructuras/organizacion#",
  "lden": "http://www.linklion.org/lden/",
  "dogont": "http://elite.polito.it/ontologies/dogont.owl#",
  "lsd": "http://linkedwidgets.org/statisticaldata/ontology/",
  "pmd": "https://w3id.org/pmd/co/",
  "viskov": "http://trust.utep.edu/visko/ontology/visko-view-v3.owl#",
  "ontopic": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
  "agr": "http://promsns.org/def/agr#",
  "dcoid": "http://dx.deepcarbon.net/",
  "qb4o": "http://purl.org/olap#",
  "bwb": "http://doc.metalex.eu/bwb/ontology/",
  "pic": "http://www.ipaw.info/ns/picaso#",
  "ids": "https://w3id.org/idsa/core/",
  "ws": "http://www.w3.org/ns/pim/space#",
  "hto": "http://project-haystack.org/hto#",
  "lexcz": "http://purl.org/lex/cz#",
  "odapp": "http://vocab.deri.ie/odapp#",
  "rdabm": "http://rdaregistry.info/termList/RDABaseMaterial/",
  "s3db": "http://www.s3db.org/core#",
  "pato": "http://purl.obolibrary.org/obo/",
  "language": "http://id.loc.gov/vocabulary/iso639-1/",
  "olad": "http://openlad.org/vocab#",
  "lpeu": "http://purl.org/linkedpolitics/vocabulary/eu/plenary/",
  "lexicon": "http://www.example.org/lexicon#",
  "being": "http://purl.org/ontomedia/ext/common/being#",
  "emoca": "http://ns.inria.fr/emoca#",
  "swpm": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
  "esequip": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#",
  "qvoc": "http://mlode.nlp2rdf.org/quranvocab#",
  "uc": "http://ucuenca.edu.ec/ontology#",
  "dot": "https://w3id.org/dot#",
  "ldt": "https://www.w3.org/ns/ldt#",
  "dcite": "http://purl.org/spar/datacite/",
  "roevo": "http://purl.org/wf4ever/roevo#",
  "samfl": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
  "sylld": "http://www.semanticweb.org/syllabus/data/",
  "lda": "http://purl.org/linked-data/api/vocab#",
  "webservice": "http://www.openlinksw.com/ontology/webservices#",
  "bgdbr": "http://bg.dbpedia.org/resource/",
  "geojson": "https://purl.org/geojson/vocab#",
  "geos": "http://www.telegraphis.net/ontology/geography/geography#",
  "lw": "http://linkedwidgets.org/ontologies/",
  "eurostat": "http://dd.eionet.europa.eu/vocabulary/eurostat/",
  "cmdm": "http://infra.clarin.eu/cmd/",
  "lmm1": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
  "agrd": "http://agrinepaldata.com/",
  "rdact": "http://rdaregistry.info/termList/RDACarrierType/",
  "imo": "http://imgpedia.dcc.uchile.cl/ontology#",
  "phdd": "http://rdf-vocabulary.ddialliance.org/phdd#",
  "dbtont": "http://dbtropes.org/ont/",
  "lmm2": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
  "wfn": "http://webofcode.org/wfn/",
  "dcx": "http://dublincore.org/dcx/",
  "ou": "https://opendata.unex.es/def/ontouniversidad#",
  "d0": "http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#",
  "zr": "http://explain.z3950.org/dtd/2.0/",
  "tddo": "http://databugger.aksw.org/ns/core#",
  "amalgame": "http://purl.org/vocabularies/amalgame#",
  "bioc": "http://deductions.github.io/biological-collections.owl.ttl#",
  "ppn": "http://parliament.uk/ontologies/person-name/",
  "gadm": "http://gadm.geovocab.org/ontology#",
  "fire": "http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#",
  "rdl": "http://data.posccaesar.org/rdl/",
  "gnvc": "http://purl.org/gc/",
  "eunis": "http://eunis.eea.europa.eu/rdf/species-schema.rdf#",
  "year": "http://www.w3.org/year/",
  "pmc": "http://identifiers.org/pmc/",
  "olac": "http://www.language-archives.org/OLAC/1.0/",
  "gt": "https://vocab.eccenca.com/geniustex/",
  "hico": "http://purl.org/emmedi/hico/",
  "situ": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "kai": "http://kai.uni-kiel.de/",
  "pois": "http://purl.oclc.org/POIS/vcblr#",
  "ceterms": "http://purl.org/ctdl/terms/",
  "bbcprov": "http://www.bbc.co.uk/ontologies/provenance/",
  "scufl2": "http://ns.taverna.org.uk/2010/scufl2#",
  "s4envi": "https://w3id.org/def/saref4envi#",
  "coll": "http://purl.org/co/",
  "ns1": "http://www.w3.org/1999/xhtml/vocab#",
  "elec": "http://purl.org/ctic/sector-publico/elecciones#",
  "wf4ever": "http://purl.org/wf4ever/wf4ever#",
  "vext": "http://ldf.fi/void-ext#",
  "wikim": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
  "galaksiya": "http://ontoloji.galaksiya.com/vocab/",
  "vsw": "http://verticalsearchworks.com/ontology/",
  "waarde": "https://lod.milieuinfo.be/ns/waarde#",
  "gaf": "http://groundedannotationframework.org/",
  "msm": "http://iserve.kmi.open.ac.uk/ns/msm#",
  "dq": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
  "prviv": "http://purl.org/net/provenance/integrity#",
  "jp1": "http://rdf.muninn-project.org/ontologies/jp1/",
  "step": "http://purl.org/net/step#",
  "roar": "https://w3id.org/roar#",
  "static": "http://vocab-ld.org/vocab/static-ld#",
  "viskoo": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
  "locwd": "http://purl.org/locwd/schema#",
  "biotop": "http://purl.org/biotop/biotop.owl#",
  "graves": "http://rdf.muninn-project.org/ontologies/graves#",
  "omnfed": "http://open-multinet.info/ontology/omn-federation#",
  "jolux": "http://data.legilux.public.lu/resource/ontology/jolux#",
  "si": "https://si-digital-framework.org/SI#",
  "puml": "http://plantuml.com/ontology#",
  "dio": "https://w3id.org/dio#",
  "fcp": "http://www.newmedialab.at/fcp/",
  "lmdb": "http://data.linkedmdb.org/",
  "vmm": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
  "vvo": "http://purl.org/vvo/ns#",
  "rdafs": "http://rdaregistry.info/termList/fontSize/",
  "pcdt": "http://purl.org/procurement/public-contracts-datatypes#",
  "omdoc": "http://omdoc.org/ontology/",
  "location": "http://sw.deri.org/2006/07/location/loc#",
  "oplprod": "http://www.openlinksw.com/ontology/products#",
  "trig": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "opengov": "http://www.w3.org/opengov#",
  "poste": "http://data.lirmm.fr/ontologies/poste#",
  "osadm": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "vapour": "http://vapour.sourceforge.net/vocab.rdf#",
  "ldl": "https://w3id.org/ldpdl/ns#",
  "vag": "http://www.essepuntato.it/2013/10/vagueness/",
  "ecglview": "http://schema.geolink.org/view/",
  "pid": "http://permid.org/ontology/organization/",
  "frb": "http://frb.270a.info/dataset/",
  "fred": "http://www.ontologydesignpatterns.org/ont/fred/domain.owl#",
  "mammal": "http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#",
  "rdai": "http://rdaregistry.info/Elements/i/",
  "vir": "http://w3id.org/vir#",
  "bnf": "http://www.w3.org/2000/10/swap/grammar/bnf#",
  "wn20": "http://www.w3.org/2006/03/wn/wn20/",
  "opmo": "http://openprovenance.org/model/opmo#",
  "rut": "http://rdfunit.aksw.org/ns/core#",
  "moo": "http://www.movieontology.org/2009/11/09/movieontology.owl#",
  "aws": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
  "geocontext": "http://www.geocontext.org/publ/2013/vocab#",
  "geosp": "http://rdf.geospecies.org/ont/geospecies#",
  "npdv": "http://sws.ifi.uio.no/vocab/npd#",
  "oecc": "http://www.oegov.org/core/owl/cc#",
  "fuseki": "http://jena.apache.org/fuseki#",
  "uis": "http://uis.270a.info/dataset/",
  "regorg": "http://www.w3.org/ns/regorg#",
  "rlnr": "http://rdflivenews.aksw.org/resource/",
  "rdagrp": "http://rdaregistry.info/termList/groovePitch/",
  "led": "http://led.kmi.open.ac.uk/term/",
  "owl2xml": "http://www.w3.org/2006/12/owl2-xml#",
  "airs": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
  "crime": "http://purl.org/vocab/reloc/",
  "odbc": "http://www.openlinksw.com/ontology/odbc#",
  "incident": "http://vocab.resc.info/incident#",
  "dsn": "http://purl.org/dsnotify/vocab/eventset/",
  "pwo": "http://purl.org/spar/pwo/",
  "rvz": "http://rdfvizler.dyreriket.xyz/vocabulary/core#",
  "saif": "http://wwwiti.cs.uni-magdeburg.de/~srahman/",
  "fnabox": "http://www.ontologydesignpatterns.org/ont/framenet/abox/",
  "gci": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
  "llm": "http://lodlaundromat.org/metrics/ontology/",
  "bpo": "https://w3id.org/bpo#",
  "rdatr": "http://rdaregistry.info/termList/typeRec/",
  "teamwork": "http://topbraid.org/teamwork#",
  "rdf123": "http://rdf123.umbc.edu/ns/",
  "lcdr": "http://ns.lucid-project.org/revision/",
  "vrank": "http://purl.org/voc/vrank#",
  "aktivesa": "http://sa.aktivespace.org/ontologies/aktivesa#",
  "acrt": "http://privatealpha.com/ontology/certification/1#",
  "obeu": "http://data.openbudgets.eu/ontology/",
  "ontosec": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
  "beth": "http://www.google.com/",
  "proms": "http://promsns.org/def/proms#",
  "mocanal": "http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#",
  "cd": "http://citydata.wu.ac.at/ns#",
  "cpack": "http://cliopatria.swi-prolog.org/schema/cpack#",
  "eccauth": "https://vocab.eccenca.com/auth/",
  "topo": "http://data.ign.fr/def/topo#",
  "jpost": "http://rdf.jpostdb.org/ontology/jpost.owl#",
  "lido": "http://www.lido-schema.org/",
  "owlse": "http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#",
  "genre": "http://sparql.cwrc.ca/ontologies/genre#",
  "tis": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#",
  "rdacc": "http://rdaregistry.info/termList/RDAColourContent/",
  "mmoon": "http://mmoon.org/mmoon/",
  "frbrer": "http://iflastandards.info/ns/fr/frbr/frbrer/",
  "pkgsrc": "http://pkgsrc.co/schema#",
  "limo": "http://www.purl.org/limo-ontology/limo#",
  "locah": "http://data.archiveshub.ac.uk/def/",
  "bcngeo": "http://datos.bcn.cl/ontologies/bcn-geographics#",
  "odv": "http://reference.data.gov.uk/def/organogram/",
  "ln": "https://w3id.org/ln#",
  "rdarole": "http://rdvocab.info/roles/",
  "limoo": "http://purl.org/LiMo/0.1/",
  "text": "http://jena.apache.org/text#",
  "ali": "http://www.niso.org/schemas/ali/1.0/",
  "omg": "https://w3id.org/omg#",
  "studiop": "http://purl.org/resource/pilatesstudio/",
  "pdf": "http://ns.adobe.com/pdf/1.3/",
  "reegle": "http://reegle.info/schema#",
  "ssno": "http://www.w3.org/ns/ssn/",
  "lexvo": "http://lexvo.org/ontology#",
  "roterms": "http://purl.org/wf4ever/roterms#",
  "imf": "http://imf.270a.info/dataset/",
  "ldvm": "http://linked.opendata.cz/ontology/ldvm/",
  "oils": "http://lemon-model.net/oils#",
  "condition": "http://www.kinjal.com/condition:",
  "sx": "http://shex.io/ns/shex#",
  "hlygt": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "bner": "http://datos.bne.es/resource/",
  "defns": "http://www.openarchives.org/OAI/2.0/",
  "edgar": "http://edgarwrap.ontologycentral.com/vocab/edgar#",
  "output": "http://volt-name.space/vocab/output#",
  "reg": "http://purl.org/linked-data/registry#",
  "afr": "http://purl.allotrope.org/ontologies/result#",
  "nxs": "http://www.neclimateus.org/",
  "rdafmn": "http://rdaregistry.info/termList/MusNotation/",
  "plg": "http://parliament.uk/ontologies/legislation/",
  "jjd": "http://www.joshuajeeson.com/",
  "passim": "http://data.lirmm.fr/ontologies/passim#",
  "rofch": "http://rdaregistry.info/termList/rofch/",
  "cwlprov": "https://w3id.org/cwl/prov#",
  "muldicat": "http://iflastandards.info/ns/muldicat#",
  "r3d": "http://www.re3data.org/schema/3-0#",
  "babelnet": "http://babelnet.org/2.0/",
  "frsad": "http://iflastandards.info/ns/fr/frsad/",
  "csp": "http://vocab.deri.ie/csp#",
  "sru": "http://www.loc.gov/zing/srw/",
  "kegg": "http://bio2rdf.org/ns/kegg#",
  "laabs": "http://dbpedia.org/resource/",
  "tb": "https://w3id.org/timebank#",
  "ordf": "http://purl.org/NET/ordf/",
  "csv": "http://vocab.sindice.net/csv/",
  "gq": "http://genomequest.com/",
  "glview": "http://schema.geolink.org/dev/view/",
  "logies": "https://data.vlaanderen.be/ns/logies#",
  "ecgl": "http://schema.geolink.org/",
  "sto": "https://w3id.org/i40/sto#",
  "sirene": "https://sireneld.io/vocab/sirene#",
  "water": "http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#",
  "tui": "http://data.ifs.tuwien.ac.at/study/resource/",
  "rdarm": "http://registry.info/termList/recMedium/",
  "orcid": "http://orcid.org/",
  "caplibacl": "http://schemas.capita-libraries.co.uk/2015/acl/schema#",
  "pproc": "http://contsem.unizar.es/def/sector-publico/pproc#",
  "webac": "http://fedora.info/definitions/v4/webac#",
  "citof": "http://www.essepuntato.it/2013/03/cito-functions#",
  "basic": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
  "form": "http://deductions-software.com/ontologies/forms.owl.ttl#",
  "spdx": "http://spdx.org/rdf/terms#",
  "infection": "http://www.agfa.com/w3c/2009/infectiousDisorder#",
  "rdaterm": "http://rdaregistry.info/termList/RDATerms/",
  "crowd": "http://purl.org/crowd/",
  "dicom": "http://purl.org/healthcarevocab/v1#",
  "afm": "http://purl.allotrope.org/ontologies/material/",
  "iana": "http://www.iana.org/assignments/relation/",
  "figigii": "http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/",
  "lyon": "http://dbpedia.org/resource/Lyon/",
  "agrovoc": "http://aims.fao.org/aos/agrovoc/",
  "eem": "http://purl.org/eem#",
  "cocoon": "https://w3id.org/cocoon/v1.0#",
  "ubiq": "http://server.ubiqore.com/ubiq/core#",
  "voc": "http://voc.odw.tw/",
  "lofv": "http://purl.org/legal_form/vocab#",
  "vdpp": "http://data.lirmm.fr/ontologies/vdpp#",
  "iati": "http://purl.org/collections/iati/",
  "mdi": "http://w3id.org/multidimensional-interface/ontology#",
  "lingvo": "http://www.lingvoj.org/ontology#",
  "swpatho": "http://swpatho.ag-nbi.de/context/meta.owl#",
  "oprovo": "http://openprovenance.org/ontology#",
  "lawd": "http://lawd.info/ontology/",
  "eccrev": "https://vocab.eccenca.com/revision/",
  "task": "http://deductions.github.io/task-management.owl.ttl#",
  "rdaftn": "http://rdaregistry.info/termList/TacNotation/",
  "eurlex": "http://eur-lex.publicdata.eu/ontology/",
  "rdaco": "http://rdaregistry.info/termList/RDAContentType/",
  "eepsa": "https://w3id.org/eepsa#",
  "oplcb": "http://www.openlinksw.com/schemas/crunchbase#",
  "fntbox": "http://www.ontologydesignpatterns.org/ont/framenet/tbox/",
  "asgv": "http://aims.fao.org/aos/agrovoc/",
  "bbccms": "http://www.bbc.co.uk/ontologies/cms/",
  "gts": "http://resource.geosciml.org/ontology/timescale/gts#",
  "gdc": "https://portal.gdc.cancer.gov/cases/",
  "clirio": "http://clirio.kaerle.com/clirio.owl#",
  "oxi": "http://omerxi.com/ontologies/core.owl.ttl#",
  "hva": "http://www.ebusiness-unibw.org/ontologies/hva/ontology#",
  "oplecrm": "http://www.openlinksw.com/ontology/ecrm#",
  "conference": "https://w3id.org/scholarlydata/ontology/conference-ontology.owl#",
  "datacite": "http://purl.org/spar/datacite/",
  "cim": "http://iec.ch/TC57/2013/CIM-schema-cim16#",
  "contsem": "http://contsem.unizar.es/def/sector-publico/contratacion#",
  "roadmap": "http://mappings.roadmap.org/",
  "owsom": "https://onlinesocialmeasures.wordpress.com/",
  "lswmo": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
  "bb": "http://www.snik.eu/ontology/bb/",
  "rls": "https://w3id.org/lovcube/ns/relovstats#",
  "ruian": "https://data.cssz.cz/ontology/ruian/",
  "cbim": "http://www.coinsweb.nl/cbim-2.0.rdf#",
  "yd": "https://yodata.io/",
  "open311": "http://ontology.eil.utoronto.ca/open311#",
  "lswpm": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
  "pep": "https://w3id.org/pep/",
  "customer": "http://www.valuelabs.com/",
  "umls": "http://bioportal.bioontology.org/ontologies/umls/",
  "meeting": "http://www.w3.org/2002/07/meeting#",
  "sdmxcode": "http://purl.org/linked-data/sdmx/2009/code#",
  "voidext": "http://rdfs.org/ns/void-ext#",
  "bsym": "http://bsym.bloomberg.com/sym/",
  "volt": "http://volt-name.space/ontology/",
  "county": "http://myexample.org/county#",
  "shui": "https://vocab.eccenca.com/shui/",
  "ha": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
  "rdafrbr": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
  "videogame": "http://purl.org/net/vgo#",
  "bdc": "http://dbpedia.org/resource/Category:",
  "ago": "http://awesemantic-geo.link/ontology/",
  "hr": "http://iserve.kmi.open.ac.uk/ns/hrests#",
  "essglobal": "http://purl.org/essglobal/vocab/v1.0/",
  "scco": "http://rdf.ebi.ac.uk/terms/surechembl#",
  "fr": "https://w3id.org/fr/def/core#",
  "sfd": "http://semantic-forms.cc:9112/ldp/",
  "rdalay": "http://rdaregistry.info/termList/layout/",
  "dsv": "https://w3id.org/dsv#",
  "tsn": "http://purl.org/net/tsn#",
  "keys": "http://purl.org/NET/c4dm/keys.owl#",
  "kml": "http://www.opengis.net/kml/2.2#",
  "bevon": "http://rdfs.co/bevon/",
  "tree": "https://w3id.org/tree#",
  "cmdi": "http://www.clarin.eu/cmd/",
  "rdarr": "http://rdaregistry.info/termList/RDAReductionRatio/",
  "crsw": "http://courseware.rkbexplorer.com/ontologies/courseware#",
  "qms": "http://data.europa.eu/esco/qms#",
  "mls": "http://www.w3.org/ns/mls#",
  "nlon": "http://lod.nl.go.kr/ontology/",
  "numbers": "http://km.aifb.kit.edu/projects/numbers/",
  "organ": "http://www.univalle.edu.co/ontologies/Organ#",
  "mmt": "http://linkedmultimedia.org/sparql-mm/functions/temporal#",
  "drk": "http://drakon.su/",
  "cjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "sakthi": "http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/",
  "mexv": "http://mex.aksw.org/mex-algo#",
  "uom": "http://www.opengis.net/def/uom/OGC/1.0/",
  "ogbd": "http://www.ogbd.fr/2012/ontologie#",
  "ja": "http://jena.hpl.hp.com/2005/11/Assembler#",
  "rdag2": "http://rdvocab.info/ElementsGr2/",
  "pfeepsa": "https://w3id.org/pfeepsa#",
  "diag": "http://www.loc.gov/zing/srw/diagnostic/",
  "chear": "http://hadatac.org/ont/chear#",
  "wdtn": "http://www.wikidata.org/prop/direct-normalized/",
  "rofer": "http://rdaregistry.info/termList/rofer/",
  "apf": "http://jena.apache.org/ARQ/property#",
  "opa": "https://w3id.org/laas-iot/adream#",
  "adf": "http://purl.allotrope.org/ontologies/datapackage#",
  "fun": "http://w3id.org/sparql-generate/fn/",
  "dpn": "http://purl.org/dpn#",
  "mds": "http://doc.metalex.eu/id/",
  "td5": "http://td5.org/#",
  "munc": "http://ns.inria.fr/munc#",
  "trao": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
  "lmx": "http://www.w3.org/XML/1998/namespace/",
  "bds": "http://www.bigdata.com/rdf/search#",
  "itm": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
  "demlab": "http://www.demcare.eu/ontologies/demlab.owl#",
  "az": "https://w3id.org/people/az/",
  "rofrr": "http://rdaregistry.info/termList/rofrr/",
  "pp": "http://peoplesplaces.de/ontology#",
  "composer": "http://dbpedia.org/ontology/composer/",
  "owms": "http://standaarden.overheid.nl/owms/terms/",
  "navm": "https://w3id.org/navigation_menu#",
  "cwl": "https://w3id.org/cwl/cwl#",
  "ruto": "http://rdfunit.aksw.org/ns/core#",
  "lgdm": "http://linkedgeodata.org/meta/",
  "csdbp": "http://cs.dbpedia.org/",
  "whisky": "http://vocab.org/whisky/terms/",
  "bblfish": "http://bblfish.net/people/henry/card#",
  "audit": "http://fedora.info/definitions/v4/audit#",
  "soch": "http://kulturarvsdata.se/ksamsok#",
  "olca": "http://www.lingvoj.org/olca#",
  "door": "http://kannel.open.ac.uk/ontology#",
  "ndnp": "http://chroniclingamerica.loc.gov/terms#",
  "amt": "http://academic-meta-tool.xyz/vocab#",
  "vstoi": "http://hadatac.org/ont/vstoi#",
  "aprov": "http://purl.org/a-proc#",
  "lslife": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
  "doacc": "http://purl.org/net/bel-epa/doacc#",
  "bis": "http://bis.270a.info/dataset/",
  "faostat": "http://reference.eionet.europa.eu/faostat/schema/",
  "radar": "http://www.radar-projekt.org/display/",
  "gnm": "http://www.geonames.org/ontology/mappings/",
  "wimpo": "http://rdfex.org/withImports?uri=",
  "one": "https://bioportal.bioontology.org/ontologies/ONE/",
  "rdasco": "http://rdaregistry.info/termList/soundCont/",
  "sdshare": "http://www.sdshare.org/2012/extension/",
  "cwork": "http://www.bbc.co.uk/ontologies/creativework/",
  "rofem": "http://rdaregistry.info/termList/rofem/",
  "maso": "http://securitytoolbox.appspot.com/MASO#",
  "bob": "http://good.dad/meaning/bob#",
  "dk": "http://www.data-knowledge.org/dk/schema/rdf/latest/",
  "oliasystem": "http://purl.org/olia/system.owl#",
  "ctrl": "https://w3id.org/ibp/CTRLont#",
  "efrbroo": "http://erlangen-crm.org/efrbroo/",
  "jerm": "http://jermontology.org/ontology/JERMOntology#",
  "markus": "http://www.markus.com/",
  "seeds": "http://deductions.github.io/seeds.owl.ttl#",
  "dcosample": "http://info.deepcarbon.net/sample/schema#",
  "datex": "http://vocab.datex.org/terms#",
  "mexalgo": "http://mex.aksw.org/mex-algo#",
  "bdo": "http://purl.bdrc.io/ontology/core/",
  "hello": "https://www.youtube.com/user/SuperTellAFriend/featured/",
  "rofid": "http://rdaregistry.info/termList/rofid/",
  "oplmkt": "http://www.openlinksw.com/ontology/market#",
  "mandaat": "http://data.vlaanderen.be/ns/mandaat#",
  "bld": "http://biglinkeddata.com/",
  "assoc": "https://w3id.org/associations/vocab#",
  "conll": "http://ufal.mff.cuni.cz/conll2009-st/task-description.html#",
  "ecore": "http://www.eclipse.org/emf/2002/Ecore#",
  "opllog": "http://www.openlinksw.com/ontology/logging#",
  "memento": "http://mementoweb.org/ns#",
  "oplres": "http://www.openlinksw.com/ontology/restrictions#",
  "lheo": "http://www.conjecto.com/ontology/2015/lheo#",
  "scho": "http://www.scholarlydata.org/ontology/conference-ontology.owl#",
  "fhir": "http://hl7.org/fhir/",
  "bdr": "http://purl.bdrc.io/resource/",
  "erce": "http://xxefe.de/",
  "osd": "http://a9.com/-/spec/opensearch/1.1/",
  "rpath": "https://w3id.org/lodsight/rdf-path#",
  "svcs": "http://rdfs.org/sioc/services#",
  "timex": "http://data.wu.ac.at/ns/timex#",
  "spcm": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
  "rdapmt": "http://rdaregistry.info/termList/prodTactile/",
  "rofrt": "http://rdaregistry.info/termList/rofrt/",
  "sgg": "http://www.springernature.com/scigraph/graphs/",
  "llont": "http://www.linklion.org/ontology#",
  "sdt": "http://statisticaldata.linkedwidgets.org/terms/",
  "physics": "http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#",
  "bbccore": "http://www.bbc.co.uk/ontologies/coreconcepts/",
  "tix": "http://toptix.com/2010/esro/",
  "hasneto": "http://hadatac.org/ont/hasneto#",
  "planet": "http://dbpedia.org/",
  "emergelm": "http://purl.org/emergel/modules#",
  "frappe": "http://streamreasoning.org/ontologies/frappe#",
  "ver": "https://w3id.org/version/ontology#",
  "fnom": "https://w3id.org/function/vocabulary/mapping#",
  "oplli": "http://www.openlinksw.com/schemas/linkedin#",
  "rdabf": "http://rdaregistry.info/termList/bookFormat/",
  "escom": "http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#",
  "qkdv": "http://qudt.org/vocab/dimensionvector/",
  "geod": "http://vocab.lenka.no/geo-deling#",
  "lemonuby": "http://lemon-model.net/lexica/uby/",
  "rdaemm": "http://rdaregistry.info/termList/emulsionMicro/",
  "vogd": "http://ogd.ifs.tuwien.ac.at/vienna/geo/",
  "ntag": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "lg": "https://purl.org/lg/",
  "lovc": "https://w3id.org/lovcube/ns/lovcube#",
  "yaco": "https://www.irit.fr/recherches/MELODI/ontologies/cinema#",
  "edr": "https://w3id.org/laas-iot/edr#",
  "gbol": "http://gbol.life/0.1#",
  "traffic": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
  "eame": "http://www.semanticweb.org/ontologia_EA#",
  "travel": "http://www.co-ode.org/roberts/travel.owl#",
  "eol": "http://purl.org/biodiversity/eol/",
  "ofrd": "http://purl.org/opdm/refrigerator#",
  "its": "http://www.w3.org/2005/11/its/rdf#",
  "r4ta": "http://ns.inria.fr/ratio4ta/v1#",
  "gont": "https://gont.ch/",
  "rdacarx": "http://rdaregistry.info/termList/RDACarrierEU/",
  "dbms": "http://www.openlinksw.com/ontology/dbms-app-ontology#",
  "mwapi": "https://www.mediawiki.org/ontology#API/",
  "uta": "http://uptheasset.org/ontology#",
  "fdbp": "http://fr.dbpedia.org/property/",
  "swrc2": "https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#",
  "eccpubsub": "https://vocab.eccenca.com/pubsub/",
  "foaffff": "http://gogl.com/",
  "otl": "https://w3id.org/opentrafficlights#",
  "biml": "http://schemas.varigence.com/biml.xsd#",
  "voidex": "http://www.swi-prolog.org/rdf/library/",
  "rdaz": "http://rdaregistry.info/Elements/z/",
  "oplweb": "http://www.openlinksw.com/schemas/oplweb#",
  "oplwebsrv": "http://www.openlinksw.com/ontology/webservices#",
  "summa": "http://purl.org/voc/summa/",
  "espresup": "http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#",
  "pmo": "http://premon.fbk.eu/ontology/core#",
  "rdabs": "http://rdaregistry.info/termList/broadcastStand/",
  "oplstocks": "http://www.openlinksw.com/ontology/stocks#",
  "w3cgeo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "vcard2006": "http://www.w3.org/2006/vcard/ns#",
  "besluit": "http://data.vlaanderen.be/ns/besluit#",
  "sgfn": "http://w3id.org/sparql-generate/fn/",
  "ims": "http://www.imsglobal.org/xsd/imsmd_v1p2/",
  "dbug": "http://ontologi.es/doap-bugs#",
  "oplacl": "http://www.openlinksw.com/ontology/acl#",
  "rofin": "http://rdaregistry.info/termList/rofin/",
  "minim": "http://purl.org/minim/minim#",
  "ecoll": "http://purl.org/ceu/eco/1.0#",
  "rdapm": "http://rdaregistry.info/termList/RDAproductionMethod/",
  "lmu": "https://w3id.org/laas-iot/lmu#",
  "mem": "http://mementoweb.org/ns#",
  "system": "http://www.univalle.edu.co/ontologies/System#",
  "semiot": "http://w3id.org/semiot/ontologies/semiot#",
  "frgeo": "http://rdf.insee.fr/geo/",
  "iter": "http://w3id.org/sparql-generate/iter/",
  "cubeont": "http://ontology.cube.global/",
  "vidont": "http://vidont.org/",
  "lfov": "https://w3id.org/legal_form#",
  "h2o": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
  "ensembl": "http://rdf.ebi.ac.uk/resource/ensembl/",
  "nno": "https://w3id.org/nno/ontology#",
  "ipsv": "http://id.esd.org.uk/list/",
  "nkos": "http://w3id.org/nkos#",
  "aml": "https://w3id.org/i40/aml#",
  "url": "http://schema.org/",
  "onisep": "http://rdf.onisep.fr/resource/",
  "vehma": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "cue": "http://www.clarin.eu/cmdi/cues/display/1.0#",
  "persee": "http://data.persee.fr/ontology/persee_ontology/",
  "oplbenefit": "http://www.openlinksw.com/ontology/benefits#",
  "religion": "http://rdf.muninn-project.org/ontologies/religion#",
  "duv": "http://www.w3.org/ns/duv#",
  "spvqa": "https://bmake.th-brandenburg.de/spv#",
  "meshv": "http://id.nlm.nih.gov/mesh/vocab#",
  "irsteaont": "http://ontology.irstea.fr/weather/ontology#",
  "rdaar": "http://rdaregistry.info/termList/AspectRatio/",
  "literature": "http://purl.org/net/cnyt-literature#",
  "eccdi": "https://vocab.eccenca.com/di/",
  "oup": "http://purl.org/ontology-use-patterns#",
  "newsevents": "http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#",
  "odf": "http://docs.oasis-open.org/ns/office/1.2/meta/odf#",
  "s4syst": "https://saref.etsi.org/saref4syst/",
  "cpov": "http://data.europa.eu/m8g/",
  "physo": "http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#",
  "km4c": "http://www.disit.org/km4city/schema#",
  "esapar": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#",
  "dsw": "http://purl.org/dsw/",
  "esadm": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#",
  "geovoid": "http://purl.org/geovocamp/ontology/geovoid/",
  "gns": "http://sws.geonames.org/",
  "rdag1": "http://rdvocab.info/Elements/",
  "lmf": "http://www.lexinfo.net/lmf#",
  "nih": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "rdfp": "https://w3id.org/rdfp/",
  "vacseen1": "http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/",
  "pmhb": "http://pmhb.org/",
  "id": "http://identifiers.org/",
  "ca": "http://complyadvantage.com/",
  "phy": "https://w3id.org/skgo/phy#",
  "bsh": "https://brickschema.org/schema/1.1.0/BrickShape#",
  "tx": "http://swtmp.gitlab.io/vocabulary/templates.owl#",
  "rgml": "http://purl.org/puninj/2001/05/rgml-schema#",
  "ilap": "http://data.posccaesar.org/ilap/",
  "sorg": "http://schema.org/",
  "tgm": "http://id.loc.gov/vocabulary/graphicMaterials/",
  "literal": "http://www.essepuntato.it/2010/06/literalreification/",
  "dwciri": "http://rs.tdwg.org/dwc/iri/",
  "esservicio": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#",
  "mexcore": "http://mex.aksw.org/mex-core#",
  "pcit": "http://public-contracts.nexacenter.org/id/propertiesRole/",
  "rdacdt": "http://rdaregistry.info/termList/RDACartoDT/",
  "uby": "http://purl.org/olia/ubyCat.owl#",
  "iiif": "http://iiif.io/api/image/2#",
  "vplan": "http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#",
  "odapps": "http://semweb.mmlab.be/ns/odapps#",
  "fluidops": "http://www.fluidops.com/",
  "swcomp": "https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#",
  "glycan": "http://purl.jp/bio/12/glyco/glycan#",
  "sfn": "http://semweb.datasciencelab.be/ns/sfn#",
  "dcap": "http://purl.org/ws-mmi-dc/terms/",
  "pcdm": "http://pcdm.org/models#",
  "escjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
  "cff": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
  "cpi": "http://www.ebusiness-unibw.org/ontologies/cpi/ns#",
  "rdafnv": "http://rdaregistry.info/termList/noteForm/",
  "naval": "http://rdf.muninn-project.org/ontologies/naval#",
  "mmm": "http://www.mico-project.eu/ns/mmm/2.0/schema#",
  "ido": "http://purl.obolibrary.org/obo/ido.owl#",
  "rofit": "http://rdaregistry.info/termList/rofit/",
  "hdo": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
  "provinsi": "http://provinsi.com/",
  "spv": "http://completeness.inf.unibz.it/sp-vocab#",
  "nature": "http://deductions.github.io/nature_observation.owl.ttl#",
  "fp3": "http://vocab.fusepool.info/fp3#",
  "cog": "http://purl.org/ontology/cco/core#",
  "beer": "http://beer.com/",
  "wsdl": "http://www.w3.org/ns/wsdl-rdf#",
  "vocnet": "http://schema.vocnet.org/",
  "uneskos": "http://purl.org/voc/uneskos#",
  "ioto": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
  "s4ee": "https://w3id.org/saref4ee#",
  "dicera": "http://semweb.mmlab.be/ns/dicera#",
  "dbfo": "http://dbpedia.org/facts/ontology#",
  "da": "https://www.wowman.org/index.php?id=1&type=get#",
  "bkb": "https://budayakb.cs.ui.ac.id/ns#",
  "beo": "https://w3id.org/beo#",
  "veo": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
  "aksw": "http://aksw.org/",
  "gg": "http://www.gemeentegeschiedenis.nl/gg-schema#",
  "alice": "http://example.org/",
  "dby": "http://dbpedia.org/class/yago/",
  "tarql": "http://tarql.github.io/tarql#",
  "devuan": "https://devuan.net.br/",
  "rdare": "http://rdaregistry.info/termList/RDARegionalEncoding/",
  "modsci": "https://w3id.org/skgo/modsci#",
  "itcat": "http://th-brandenburg.de/ns/itcat#",
  "nobel": "http://data.nobelprize.org/terms/",
  "rm": "http://jazz.net/ns/rm#",
  "ogdl4m": "https://github.com/martynui/OGDL4M/",
  "brk": "http://brk.basisregistraties.overheid.nl/def/brk#",
  "ontoneo": "http://purl.obolibrary.org/obo/ontoneo/",
  "rdacpc": "http://rdaregistry.info/termList/configPlayback/",
  "sdmxm": "http://purl.org/linked-data/sdmx/2009/measure#",
  "xslopm": "http://purl.org/net/opmv/types/xslt#",
  "vam": "http://www.metmuseum.org/",
  "dead": "http://utpl.edu.ec/sbc/data/",
  "rofsm": "http://rdaregistry.info/termList/rofsm/",
  "vocals": "http://w3id.org/rsp/vocals#",
  "crmeh": "http://purl.org/crmeh#",
  "apb": "http://www.analysispartners.org/businessmodel/",
  "rdag3": "http://rdvocab.info/ElementsGr3/",
  "qbe": "http://citydata.wu.ac.at/qb-equations#",
  "wde": "http://www.wikidata.org/entity/",
  "ncicp": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
  "number": "http://km.aifb.kit.edu/projects/numbers/number#",
  "ldq": "http://www.linkeddata.es/ontology/ldq#",
  "l2sp": "http://www.linked2safety-project.eu/properties/",
  "roc": "https://w3id.org/ro/curate#",
  "ppr": "http://purl.org/datanode/ppr/ns/",
  "legal": "http://www.w3.org/ns/legal#",
  "ethc": "http://ethoinformatics.org/ethocore/",
  "tosh": "http://topbraid.org/tosh#",
  "ifcowl": "http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#",
  "atlasterms": "http://rdf.ebi.ac.uk/terms/atlas/",
  "ldn": "https://www.w3.org/TR/ldn/#",
  "mydb": "http://mydb.org/",
  "ttla": "https://w3id.org/ttla/",
  "oop": "http://w3id.org/oop#",
  "mobivoc": "http://schema.mobivoc.org/",
  "or": "http://openresearch.org/vocab/",
  "input": "http://volt-name.space/vocab/input#",
  "mus": "http://data.doremus.org/ontology#",
  "halyard": "http://merck.github.io/Halyard/ns#",
  "lgdt": "http://linkedgeodata.org/triplify/",
  "swa": "http://topbraid.org/swa#",
  "rofrm": "http://rdaregistry.info/termList/rofrm/",
  "huto": "http://ns.inria.fr/huto/",
  "rdaspc": "http://rdaregistry.info/termList/specPlayback/",
  "rofim": "http://rdaregistry.info/termList/rofim/",
  "semsur": "http://purl.org/SemSur/",
  "edg": "http://edg.topbraid.solutions/model/",
  "geor": "http://www.opengis.net/def/rule/geosparql/",
  "ucum": "http://purl.oclc.org/NET/muo/ucum/",
  "imjv": "https://data.imjv.omgeving.vlaanderen.be/ns/imjv#",
  "sciprov": "http://sweetontology.net/reprSciProvenance/",
  "lgt": "http://linkedgadget.com/wiki/Property:",
  "yso": "http://www.yso.fi/onto/yso/",
  "ocds": "http://purl.org/onto-ocds/ocds#",
  "gobierno": "http://www.gobierno.es/gobierno/",
  "ul": "http://underlay.mit.edu/ns/",
  "decprov": "http://promsns.org/def/decprov#",
  "nosql": "http://purl.org/db/nosql#",
  "rdaft": "http://rdaregistry.info/termList/fileType/",
  "gvoith": "http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#",
  "tadirah": "http://tadirah.dariah.eu/vocab/",
  "sgiter": "http://w3id.org/sparql-generate/iter/",
  "mbgd": "http://mbgd.genome.ad.jp/owl/mbgd.owl#",
  "srx": "http://www.w3.org/2005/sparql-results#",
  "iotlite": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
  "dnbt": "http://d-nb.info/standards/elementset/dnb#",
  "dcodt": "http://info.deepcarbon.net/datatype/schema#",
  "loted": "http://loted.eu/ontology#",
  "ontop": "https://w3id.org/ontop/",
  "neotecbib": "http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/",
  "rvl": "http://purl.org/rvl/",
  "isbdu": "http://iflastandards.info/ns/isbd/unc/elements/",
  "occ": "http://w3id.org/occ#",
  "rdapf": "http://rdaregistry.info/termList/presFormat/",
  "scholl": "http://menemeneml.com/school#",
  "um": "http://intelleo.eu/ontologies/user-model/ns/",
  "it": "http://www.influencetracker.com/ontology#",
  "aozora": "http://purl.org/net/aozora/",
  "sdterms": "http://statisticaldata.linkedwidgets.org/terms/",
  "ldqm": "http://linkeddata.es/resource/ldqm/",
  "docker": "http://www.w3.org/ns/bde/docker/",
  "uri4uri": "http://uri4uri.net/vocab#",
  "koly": "http://www.ensias.ma/",
  "imind": "http://schema.intellimind.ns/symbology#",
  "rdax": "http://rdaregistry.info/Elements/x/",
  "alethio": "http://aleth.io/",
  "idot": "http://identifiers.org/idot/",
  "dataid": "http://dataid.dbpedia.org/ns/core#",
  "esair": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#",
  "pmonb": "http://premon.fbk.eu/ontology/nb#",
  "neotec": "http://neotec.rc.unesp.br/resource/Neotectonics/",
  "geo7": "https://www.geo7.ch/",
  "sdmxc": "http://purl.org/linked-data/sdmx/2009/concept#",
  "rofhf": "http://rdaregistry.info/termList/rofhf/",
  "edgarcik": "http://edgarwrap.ontologycentral.com/cik/",
  "cska": "http://pfclitex.com/",
  "tissue": "http://www.univalle.edu.co/ontologies/Tissue#",
  "elod": "http://linkedeconomy.org/ontology#",
  "pbody": "http://reference.data.gov.uk/def/public-body/",
  "crminf": "http://www.cidoc-crm.org/cidoc-crm/CRMinf/",
  "ods": "http://lod.xdams.org/ontologies/ods/",
  "smxm": "http://smxm.ga/",
  "b3kat": "http://lod.b3kat.de/title/",
  "piero": "http://reactionontology.org/piero/",
  "iso37120": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
  "nas": "https://data.nasa.gov/ontologies/atmonto/NAS#",
  "sohukd": "http://sweetontology.net/humanKnowledgeDomain/",
  "alg": "http://drakon.su/ADF#",
  "undata": "http://citydata.wu.ac.at/Linked-UNData/data/",
  "juso": "http://rdfs.co/juso/",
  "edac": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
  "ondc": "http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#",
  "dto": "http://www.datatourisme.fr/ontology/core/1.0#",
  "geoloc": "http://deductions.github.io/geoloc.owl.ttl#",
  "datacron": "http://www.datacron-project.eu/datAcron#",
  "maeco": "http://edg.topbraid.solutions/maeco/",
  "sorepsf": "http://sweetontology.net/reprSciFunction/",
  "pand": "http://bag.basisregistraties.overheid.nl/bag/id/pand/",
  "eproc": "http://10.0.3.120/download/eproc_FORN_v02.owl#",
  "remetca": "http://www.purl.org/net/remetca#",
  "xbrll": "https://w3id.org/vocab/xbrll#",
  "seo": "http://sda.tech/SEOontology/SEO/",
  "wab": "http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#",
  "rfd": "http://com.intrinsec//ontology#",
  "amsl": "http://vocab.ub.uni-leipzig.de/amsl/",
  "globalcube": "http://kalmar32.fzi.de/triples/global-cube.ttl#",
  "ns2": "http://ogp.me/ns#video:",
  "lsq": "http://lsq.aksw.org/vocab#",
  "dcodata": "http://info.deepcarbon.net/data/schema#",
  "connard": "https://mail.google.com/mail/u/1/#",
  "ii": "http://sparql.cwrc.ca/ontologies/ii#",
  "geofabric": "http://linked.data.gov.au/def/geofabric#",
  "kmgeo": "http://km.aifb.kit.edu/services/geo/ontology#",
  "wail": "http://www.eyrie.org/~zednenem/2002/wail/",
  "olac11": "http://www.language-archives.org/OLAC/1.1/",
  "rdfdata": "http://rdf.data-vocabulary.org/rdf.xml#",
  "metadata": "http://purl.oreilly.com/ns/meta/",
  "pmofn": "http://premon.fbk.eu/ontology/fn#",
  "pop": "http://wiki.dbpedia.org/",
  "tsnchange": "http://purl.org/net/tsnchange#",
  "loci": "http://linked.data.gov.au/def/loci#",
  "rico": "https://www.ica.org/standards/RiC/ontology#",
  "efd": "http://data.foodanddrinkeurope.eu/ontology#",
  "imas": "https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#",
  "iab": "https://www.iab.com/guidelines/taxonomy/",
  "d3s": "http://vocbench.solidaridad.cloud/taxonomies#",
  "dm2e": "http://onto.dm2e.eu/schemas/dm2e/",
  "llr": "http://lodlaundromat.org/resource/",
  "brt": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
  "soma": "http://sweetontology.net/matr/",
  "ncbigene": "http://identifiers.org/ncbigene/",
  "unspsc": "http://ontoview.org/schema/unspsc/1#",
  "m3": "http://sensormeasurement.appspot.com/m3#",
  "m3lite": "http://purl.org/iot/vocab/m3-lite#",
  "s4bldg": "https://w3id.org/def/saref4bldg#",
  "scra": "http://purl.org/net/schemarama#",
  "bibrm": "http://vocab.ub.uni-leipzig.de/bibrm/",
  "valueflows": "https://w3id.org/valueflows/",
  "estatwrap": "http://ontologycentral.com/2009/01/eurostat/ns#",
  "soprocsc": "http://sweetontology.net/procStateChange/",
  "pmovn": "http://premon.fbk.eu/ontology/vn#",
  "sopropsdis": "http://sweetontology.net/propSpaceDistance/",
  "esproc": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#",
  "sorepmo": "http://sweetontology.net/reprMathOperation/",
  "sophatmow": "http://sweetontology.net/phenAtmoWind/",
  "marcrole": "http://id.loc.gov/vocabulary/relators/",
  "tikag": "https://www.tikag.com/",
  "soproptg": "http://sweetontology.net/propTemperatureGradient/",
  "gdprtext": "https://w3id.org/GDPRtEXT#",
  "rofsf": "http://rdaregistry.info/termList/rofsf/",
  "eustd": "http://eurostat.linked-statistics.org/data#",
  "s3n": "http://w3id.org/s3n/",
  "vsearch": "http://vocab.sti2.at/vsearch#",
  "wn30": "http://purl.org/vocabularies/princeton/wn30/",
  "manto": "http://com.vortic3.MANTO/",
  "pm": "http://premon.fbk.eu/resource/",
  "gdprov": "https://w3id.org/GDPRov#",
  "biolink": "https://w3id.org/biolink/vocab/",
  "fnml": "http://semweb.mmlab.be/ns/fnml#",
  "ispra": "http://dati.isprambiente.it/ontology/core#",
  "master1": "http://idl.u-grenoble3.fr/",
  "rami": "http://iais.fraunhofer.de/vocabs/rami#",
  "tavprov": "http://ns.taverna.org.uk/2012/tavernaprov/",
  "clapit": "http://dati.gov.it/onto/clapit/",
  "hosp": "http://health.data.gov/def/hospital/",
  "llalg": "http://www.linklion.org/algorithm/",
  "sophatmowm": "https://sweetontology.net/phenAtmoWindMesoscale/",
  "isidore": "http://www.rechercheisidore.fr/class/",
  "bioentity": "http://bioentity.io/vocab/",
  "rdavf": "http://rdaregistry.info/termList/videoFormat/",
  "gdpr": "https://vocab.eccenca.com/gdpr/",
  "sorepsrs": "http://sweetontology.net/reprSpaceReferenceSystem/",
  "bci": "https://w3id.org/BCI-ontology#",
  "soproptf": "http://sweetontology.net/propTimeFrequency/",
  "rimmf": "http://rimmf.com/vocab/",
  "rdaill": "http://rdaregistry.info/termList/IllusContent/",
  "dgfr": "http://colin.maudry.com/ontologies/dgfr#",
  "smartapi": "http://smart-api.io/ontology/1.0/smartapi#",
  "sopropp": "http://sweetontology.net/propPressure/",
  "irstea": "http://ontology.irstea.fr/",
  "cbb": "https://data.cbb.omgeving.vlaanderen.be/ns/cbb#",
  "vss": "http://automotive.eurecom.fr/vsso#",
  "refexo": "http://purl.jp/bio/01/refexo#",
  "sopropsl": "http://sweetontology.net/propSpaceLocation/",
  "asawoo": "http://liris.cnrs.fr/asawoo/",
  "ksam": "http://kulturarvsdata.se/ksamsok#",
  "psv": "http://www.wikidata.org/prop/statement/value/",
  "ctxdesc": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
  "chemsci": "https://w3id.org/skgo/chemsci#",
  "pham": "https://w3id.org/skgo/pham#",
  "osys": "http://purl.org/olia/system.owl#",
  "rdagen": "http://rdaregistry.info/termList/RDAGeneration/",
  "changeset": "http://purl.org/vocab/changeset/schema#",
  "emergel": "http://purl.org/emergel/core#",
  "rsctx": "http://softeng.polito.it/rsctx#",
  "linkrel": "https://www.w3.org/ns/iana/link-relations/relation#",
  "eqp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
  "dpla": "http://dp.la/info/developers/map/",
  "fel": "http://w3id.org/vcb/fel#",
  "stencila": "http://schema.stenci.la/",
  "qk": "http://qudt.org/vocab/quantitykind/",
  "dsfv": "http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#",
  "ermrk": "http://www.essepuntato.it/2008/12/earmark#",
  "goaf": "http://goaf.fr/goaf#",
  "oplp": "http://www.openlinksw.com/ontology/purchases#",
  "sostc": "http://sweetontology.net/stateChemical/",
  "noise": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#",
  "pplan": "http://purl.org/net/p-plan#",
  "maet": "http://edg.topbraid.solutions/taxonomy/macroeconomics/",
  "sopropcat": "http://sweetontology.net/propCategorical/",
  "bitl": "http://lib.bit.edu.cn/ontology/1.0/",
  "oplangel": "http://www.openlinksw.com/schemas/angel#",
  "prohow": "https://w3id.org/prohow#",
  "rdaad": "http://rdaregistry.info/Elements/a/datatype/",
  "sohuecons": "http://sweetontology.net/humanEnvirConservation/",
  "omnlc": "http://open-multinet.info/ontology/omn-lifecycle#",
  "pq": "http://www.wikidata.org/prop/qualifier/",
  "isoadr": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
  "ordo": "http://www.orpha.net/ORDO/",
  "sopropsh": "http://sweetontology.net/propSpaceHeight/",
  "gnaf": "http://linked.data.gov.au/def/gnaf#",
  "aseonto": "http://requirement.ase.ru/requirements_ontology#",
  "sorepmso": "http://sweetontology.net/reprMathSolution/",
  "dmp": "http://www.sysresearch.org/rda-common-dmp#",
  "soproc": "http://sweetontology.net/proc/",
  "terms": "http://purl.org/dc/terms/",
  "somaoc": "http://sweetontology.net/matrOrganicCompound/",
  "wild": "http://purl.org/wild/vocab#",
  "soprocp": "http://sweetontology.net/procPhysical/",
  "snac": "http://socialarchive.iath.virginia.edu/",
  "dm": "http://datamusee.givingsense.eu/onto/",
  "provoc": "http://ns.inria.fr/provoc/",
  "sorepsu": "http://sweetontology.net/reprSciUnits/",
  "skosthes": "http://purl.org/iso25964/skos-thes#",
  "cwlgit": "https://w3id.org/cwl/view/git/",
  "country": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
  "gcon": "https://w3id.org/GConsent#",
  "extech": "https://w3id.org/executionTechnique/ontology/",
  "mdont": "http://ont.matchdeck.com/",
  "sorepmfo": "http://sweetontology.net/reprMathFunctionOrthogonal/",
  "capes": "http://vocab.capes.gov.br/def/vcav#",
  "lesa": "http://hadatac.org/ont/lesa#",
  "sopropsp": "http://sweetontology.net/propSpeed/",
  "jsonschema": "https://www.w3.org/2019/wot/json-schema#",
  "sostv": "http://sweetontology.net/stateVisibility/",
  "sophatmofo": "http://sweetontology.net/phenAtmoFog/",
  "soreaofl": "http://sweetontology.net/realmOceanFloor/",
  "sosttf": "http://sweetontology.net/stateTimeFrequency/",
  "eproc2": "http://10.0.3.120/download/eproc_FORN_v04.owl#",
  "losp": "http://sparql.sstu.ru:3030/speciality/",
  "powla": "http://purl.org/powla/powla.owl#",
  "sorepsc": "http://sweetontology.net/reprSciComponent/",
  "sorepscd": "http://sweetontology.net/reprSpaceCoordinate/",
  "pmopb": "http://premon.fbk.eu/ontology/pb#",
  "rofet": "http://rdaregistry.info/termList/rofet/",
  "sorepdsa": "http://sweetontology.net/reprDataServiceAnalysis/",
  "sorepdf": "http://sweetontology.net/reprDataFormat/",
  "sohut": "http://sweetontology.net/humanTransportation/",
  "sopropsdir": "http://sweetontology.net/propSpaceDirection/",
  "wdv": "http://www.wikidata.org/value/",
  "daap": "http://daap.dsi.universite-paris-saclay.fr/wiki/",
  "sophec": "http://sweetontology.net/phenEcology/",
  "esagen": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "sophoc": "http://sweetontology.net/phenOceanCoastal/",
  "constant": "http://qudt.org/vocab/constant/",
  "sopropef": "http://sweetontology.net/propEnergyFlux/",
  "sorepmst": "http://sweetontology.net/reprMathStatistics/",
  "sorelm": "http://sweetontology.net/relaMath/",
  "cwmo": "http://purl.org/cwmo/#",
  "dqc": "http://semwebquality.org/ontologies/dq-constraints#",
  "soprops": "http://sweetontology.net/propSpace/",
  "sophatmopc": "http://sweetontology.net/phenAtmoPrecipitation/",
  "theme": "http://voc.odw.tw/theme/",
  "lcsh": "http://id.loc.gov/authorities/subjects/",
  "r4r": "http://guava.iis.sinica.edu.tw/r4r/",
  "dentsci": "https://w3id.org/skgo/dentsci#",
  "hctl": "https://www.w3.org/2019/wot/hypermedia#",
  "dcatnl": "http://standaarden.overheid.nl/dcatnl/terms/",
  "sopropti": "http://sweetontology.net/propTime/",
  "sorept": "http://sweetontology.net/reprTime/",
  "earth": "http://linked.earth/ontology#",
  "wikimedia": "http://upload.wikimedia.org/wikipedia/commons/f/f6/",
  "sorepsme": "http://sweetontology.net/reprSciMethodology/",
  "esgs": "https://w3id.org/edwin/ontology/",
  "sweet": "http://sweetontology.net/",
  "epplan": "https://w3id.org/ep-plan#",
  "shema": "http://schema.org/",
  "obws": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
  "soreaa": "http://sweetontology.net/realmAtmo/",
  "atts": "https://data.nasa.gov/ontologies/atmonto/general#",
  "sorepdsv": "http://sweetontology.net/reprDataServiceValidation/",
  "gmo": "http://purl.jp/bio/10/gmo/",
  "sophsy": "http://sweetontology.net/phenSystem/",
  "sorepdsr": "http://sweetontology.net/reprDataServiceReduction/",
  "medred": "http://w3id.org/medred/medred#",
  "sostb": "http://sweetontology.net/stateBiological/",
  "sorepdp": "http://sweetontology.net/reprDataProduct/",
  "sophso": "http://sweetontology.net/phenSolid/",
  "nrv": "http://ns.inria.fr/nrv#",
  "bs": "https://w3id.org/bs#",
  "orgesv2": "http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#",
  "isaterms": "http://purl.org/isaterms/",
  "sopropcap": "http://sweetontology.net/propCapacity/",
  "voidwh": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#",
  "sorepsl": "http://sweetontology.net/reprSciLaw/",
  "sopropsm": "http://sweetontology.net/propSpaceMultidimensional/",
  "sorepmf": "http://sweetontology.net/reprMathFunction/",
  "sopropmf": "http://sweetontology.net/propMassFlux/",
  "eppl": "https://w3id.org/ep-plan#",
  "stx": "http://purl.org/cyber/stix#",
  "sorelpr": "http://sweetontology.net/relaProvenance/",
  "sopropcha": "http://sweetontology.net/propCharge/",
  "fssp": "http://linkeddata.fssprus.ru/resource/",
  "lblodlg": "http://data.lblod.info/vocabularies/leidinggevenden/",
  "iospress": "http://ld.iospress.nl/rdf/ontology/",
  "gvoi": "http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#",
  "pineapple": "http://hexananas.com/pineapple#",
  "sostrr": "http://sweetontology.net/stateRoleRepresentative/",
  "mexperf": "http://mex.aksw.org/mex-perf#",
  "jup": "http://w3id.org/charta77/jup/",
  "sopropdifu": "http://sweetontology.net/propDiffusivity/",
  "sopropq": "http://sweetontology.net/propQuantity/",
  "sopropcou": "http://sweetontology.net/propCount/",
  "skoslex": "https://bp4mc2.org/def/skos-lex#",
  "sostri": "http://sweetontology.net/stateRoleImpact/",
  "sorepsp": "http://sweetontology.net/reprSciProvenance/",
  "sorealc": "http://sweetontology.net/realmLandCoastal/",
  "inchikey": "https://identifiers.org/inchikey:",
  "dprov": "http://promsns.org/def/do#",
  "ingredient": "http://www.owl-ontologies.com/test.owl/ingredient/",
  "vehman": "http://deductions.github.io/vehicule-management.owl.ttl#",
  "somanr": "http://sweetontology.net/matrNaturalResource/",
  "soprope": "http://sweetontology.net/propEnergy/",
  "estrf": "http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#",
  "estatgph": "http://estatwrap.ontologycentral.com/id/nama_aux_gph#",
  "sophatmoc": "http://sweetontology.net/phenAtmoCloud/",
  "sorepts": "http://sweetontology.net/reprTimeSeason/",
  "sophfd": "http://sweetontology.net/phenFluidDynamics/",
  "iaph": "http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28",
  "esdbpr": "http://es.dbpedia.org/resource/",
  "somamin": "http://sweetontology.net/matrMineral/",
  "sopropdr": "http://sweetontology.net/propDimensionlessRatio/",
  "ldc": "https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#",
  "sopropb": "http://sweetontology.net/propBinary/",
  "wotsec": "https://www.w3.org/2019/wot/security#",
  "odw": "http://odw.tw/",
  "sostth": "http://sweetontology.net/stateThermodynamic/",
  "soreahb": "http://sweetontology.net/realmHydroBody/",
  "sorep": "http://sweetontology.net/repr/",
  "sopropcon": "http://sweetontology.net/propConductivity/",
  "sorelcl": "http://sweetontology.net/relaClimate/",
  "sorepmg": "http://sweetontology.net/reprMathGraph/",
  "sopropm": "http://sweetontology.net/propMass/",
  "soreps": "http://sweetontology.net/reprSpace/",
  "vort": "http://rockets.topbraid.solutions/vort/",
  "sorelh": "http://sweetontology.net/relaHuman/",
  "ideotalex": "http://www.ideotalex.eu/datos/recurso/",
  "soreacz": "http://sweetontology.net/realmClimateZone/",
  "sosto": "http://sweetontology.net/stateOrdinal/",
  "soreao": "http://sweetontology.net/realmOcean/",
  "sosttg": "http://sweetontology.net/stateTimeGeologic/",
  "sopropo": "http://sweetontology.net/propOrdinal/",
  "sfl": "http://data.finlex.fi/schema/sfl/",
  "yandex": "http://yandex.ru/",
  "sorealo": "http://sweetontology.net/realmLandOrographic/",
  "foio": "https://w3id.org/seas/FeatureOfInterestOntology/",
  "sohutr": "http://sweetontology.net/humanTechReadiness/",
  "dave": "http://theme-e.adaptcentre.ie/dave#",
  "sophatmofr": "http://sweetontology.net/phenAtmoFront/",
  "sopropr": "http://sweetontology.net/propRotation/",
  "sorepsd": "http://sweetontology.net/reprSpaceDirection/",
  "ddb": "http://www.deutsche-digitale-bibliothek.de/edm/",
  "sopropche": "http://sweetontology.net/propChemical/",
  "sopropi": "http://sweetontology.net/propIndex/",
  "soreaas": "http://sweetontology.net/realmAstroStar/",
  "somains": "http://sweetontology.net/matrInstrument/",
  "sophpc": "http://sweetontology.net/phenPlanetClimate/",
  "loupe": "http://ont-loupe.linkeddata.es/def/core/",
  "sophatmos": "http://sweetontology.net/phenAtmoSky/",
  "cci": "http://cookingbigdata.com/linkeddata/ccinstances#",
  "sohuj": "http://sweetontology.net/humanJurisdiction/",
  "sophcr": "http://sweetontology.net/phenCryo/",
  "sopropfr": "http://sweetontology.net/propFraction/",
  "sorepm": "http://sweetontology.net/reprMath/",
  "d2s": "https://w3id.org/d2s/",
  "somac": "http://sweetontology.net/matrCompound/",
  "somaae": "http://sweetontology.net/matrAerosol/",
  "frbroo": "http://iflastandards.info/ns/fr/frbr/frbroo/",
  "sophatmops": "http://sweetontology.net/phenAtmoPressure/",
  "lprov": "http://id.learning-provider.data.ac.uk/terms#",
  "sophatmol": "http://sweetontology.net/phenAtmoLightning/",
  "proton": "http://www.ontotext.com/proton/",
  "sophst": "http://sweetontology.net/phenStar/",
  "sostrg": "http://sweetontology.net/stateRoleGeographic/",
  "w3id": "https://w3id.org/",
  "sorear": "http://sweetontology.net/realmRegion/",
  "ecowlim": "http://ecowlim.tfri.gov.tw/lode/resource/",
  "sopropfu": "http://sweetontology.net/propFunction/",
  "cfrl": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
  "trek": "https://w3id.org/trek/",
  "osmm": "https://www.openstreetmap.org/meta/",
  "sophwn": "http://sweetontology.net/phenWaveNoise/",
  "sopropdife": "http://sweetontology.net/propDifference/",
  "esagm": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
  "sohur": "http://sweetontology.net/humanResearch/",
  "sorelph": "http://sweetontology.net/relaPhysical/",
  "sorelsc": "http://sweetontology.net/relaSci/",
  "sostso": "http://sweetontology.net/stateSolid/",
  "soprocw": "http://sweetontology.net/procWave/",
  "somab": "http://sweetontology.net/matrBiomass/",
  "somapl": "http://sweetontology.net/matrPlant/",
  "sophatmo": "http://sweetontology.net/phenAtmo/",
  "sohues": "http://sweetontology.net/humanEnvirStandards/",
  "sost": "http://sweetontology.net/state/",
  "soreas": "http://sweetontology.net/realmSoil/",
  "somaf": "http://sweetontology.net/matrFacility/",
  "sophm": "http://sweetontology.net/phenMixing/",
  "sorepdsg": "http://sweetontology.net/reprDataServiceGeospatial/",
  "sostrt": "http://sweetontology.net/stateRoleTrust/",
  "sorealp": "http://sweetontology.net/realmLandProtected/",
  "sorepdm": "http://sweetontology.net/reprDataModel/",
  "eccf": "http://data.europa.eu/54i/",
  "taxref": "http://taxref.mnhn.fr/lod/taxon/",
  "sosttc": "http://sweetontology.net/stateTimeCycle/",
  "hdgi": "https://w3id.org/hdgi#",
  "sorepsg3": "http://sweetontology.net/reprSpaceGeometry3D/",
  "sophcm": "http://sweetontology.net/phenCycleMaterial/",
  "sophel": "http://sweetontology.net/phenElecMag/",
  "soreaabl": "http://sweetontology.net/realmAtmoBoundaryLayer/",
  "soreaaw": "http://sweetontology.net/realmAtmoWeather/",
  "biogrid": "http://thebiogrid.org/",
  "pcdmuse": "http://pcdm.org/use#",
  "sostrc": "http://sweetontology.net/stateRoleChemical/",
  "sorelt": "http://sweetontology.net/relaTime/",
  "sorel": "http://sweetontology.net/rela/",
  "somarock": "http://sweetontology.net/matrRock/",
  "soreaer": "http://sweetontology.net/realmEarthReference/",
  "sohu": "http://sweetontology.net/human/",
  "asgs": "http://linked.data.gov.au/def/asgs#",
  "bldont": "http://ont.biglinkeddata.com/",
  "somaen": "http://sweetontology.net/matrEnergy/",
  "donto": "http://reference.data.gov.au/def/ont/dataset#",
  "ggbn": "http://data.ggbn.org/schemas/ggbn/terms/",
  "mbkeys": "https://pastebin.com/ThBfphb8#",
  "probont": "http://www.probonto.org/ontology#",
  "somaind": "http://sweetontology.net/matrIndustrial/",
  "soreac": "http://sweetontology.net/realmCryo/",
  "somarocki": "http://sweetontology.net/matrRockIgneous/",
  "sostdp": "http://sweetontology.net/stateDataProcessing/",
  "pnv": "https://w3id.org/pnv#",
  "gx": "https://w3id.org/gaia-x/development#",
  "phto": "http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#",
  "sophr": "http://sweetontology.net/phenReaction/",
  "somaem": "http://sweetontology.net/matrElementalMolecule/",
  "sopropst": "http://sweetontology.net/propSpaceThickness/",
  "sophatmot": "http://sweetontology.net/phenAtmoTransport/",
  "sostsy": "http://sweetontology.net/stateSystem/",
  "soreaah": "http://sweetontology.net/realmAstroHelio/",
  "soph": "http://sweetontology.net/phen/",
  "misp": "http://purl.org/cyber/misp#",
  "soreal": "http://sweetontology.net/realmLandform/",
  "sostsp": "http://sweetontology.net/stateSpace/",
  "sophft": "http://sweetontology.net/phenFluidTransport/",
  "soreptd": "http://sweetontology.net/reprTimeDay/",
  "sophcy": "http://sweetontology.net/phenCycle/",
  "dbm": "http://purl.org/net/dbm/ontology#",
  "mmms": "http://ldf.fi/schema/mmm/",
  "sorepds": "http://sweetontology.net/reprDataService/",
  "somais": "http://sweetontology.net/matrIsotope/",
  "sorelch": "http://sweetontology.net/relaChemical/",
  "she": "http://shacleditor.org/",
  "soprocc": "http://sweetontology.net/procChemical/",
  "sophsyc": "http://sweetontology.net/phenSystemComplexity/",
  "soall": "http://sweetontology.net/sweetAll/",
  "sopropt": "http://sweetontology.net/propTemperature/",
  "omop": "http://api.ohdsi.org/WebAPI/vocabulary/concept/",
  "sohuc": "http://sweetontology.net/humanCommerce/",
  "place": "http://purl.org/ontology/places/",
  "sorelsp": "http://sweetontology.net/relaSpace/",
  "lv2": "http://lv2plug.in/ns/lv2core/",
  "soreaofe": "http://sweetontology.net/realmOceanFeature/",
  "osmt": "https://wiki.openstreetmap.org/wiki/Key:",
  "sorepsmo": "http://sweetontology.net/reprSciModel/",
  "sostrb": "http://sweetontology.net/stateRoleBiological/",
  "mccv": "http://purl.jp/bio/10/mccv#",
  "say": "https://say.data.gift/ns/",
  "sophei": "http://sweetontology.net/phenEnvirImpact/",
  "twitter": "http://stocktwits.com/",
  "snomedct": "http://purl.bioontology.org/ontology/SNOMEDCT/",
  "somaw": "http://sweetontology.net/matrWater/",
  "sophod": "http://sweetontology.net/phenOceanDynamics/",
  "somaeq": "http://sweetontology.net/matrEquipment/",
  "sophb": "http://sweetontology.net/phenBiol/",
  "idsc": "https://w3id.org/idsa/code/",
  "soreabb": "http://sweetontology.net/realmBiolBiome/",
  "somas": "http://sweetontology.net/matrSediment/",
  "sohueccont": "http://sweetontology.net/humanEnvirControl/",
  "soprop": "http://sweetontology.net/prop/",
  "sostsb": "http://sweetontology.net/stateSpectralBand/",
  "sophhy": "http://sweetontology.net/phenHydro/",
  "wds": "http://www.wikidata.org/entity/statement/",
  "cto": "https://w3id.org/cto#",
  "compub": "https://sireneld.io/vocab/compub#",
  "sohuea": "http://sweetontology.net/humanEnvirAssessment/",
  "sostro": "http://sweetontology.net/stateRole/",
  "trak": "https://purl.org/trak/metamodel/vocab#",
  "s4city": "https://saref.etsi.org/saref4city/",
  "rank": "http://www.ontotext.com/owlim/RDFRank#",
  "oco": "https://w3id.org/oc/ontology/",
  "somaio": "http://sweetontology.net/matrIon/",
  "sophen": "http://sweetontology.net/phenEnergy/",
  "omim": "http://purl.bioontology.org/ontology/OMIM/",
  "ccomid": "http://www.ontologyrepository.com/CommonCoreOntologies/Mid/",
  "sostef": "http://sweetontology.net/stateEnergyFlux/",
  "edupro": "http://ns.inria.fr/semed/eduprogression#",
  "esbici": "http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#",
  "sorealt": "http://sweetontology.net/realmLandTectonic/",
  "schoi": "https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#",
  "ocsw": "http://data.diekb.org/def/ocsw#",
  "sophw": "http://sweetontology.net/phenWave/",
  "sophgt": "http://sweetontology.net/phenGeolTectonic/",
  "dfc": "http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
  "sostp": "http://sweetontology.net/statePhysical/",
  "cbs": "http://betalinkeddata.cbs.nl/def/cbs#",
  "atd": "https://data.nasa.gov/ontologies/atmonto/data#",
  "oplsoft": "http://www.openlinksw.com/ontology/software#",
  "sorealf": "http://sweetontology.net/realmLandFluvial/",
  "sostre": "http://sweetontology.net/stateRealm/",
  "ldes": "https://w3id.org/ldes#",
  "sostf": "http://sweetontology.net/stateFluid/",
  "osmrel": "https://www.openstreetmap.org/relation/",
  "sophgs": "http://sweetontology.net/phenGeolSeismicity/",
  "ciao": "http://ciao.it/",
  "sorealg": "http://sweetontology.net/realmLandGlacial/",
  "taxrefprop": "http://taxref.mnhn.fr/lod/property/",
  "brot": "https://w3id.org/brot#",
  "gleio": "http://lei.info/gleio/",
  "somael": "http://sweetontology.net/matrElement/",
  "gas": "http://www.bigdata.com/rdf/gas#",
  "sophgg": "http://sweetontology.net/phenGeolGeomorphology/",
  "sostti": "http://sweetontology.net/stateTime/",
  "dd": "http://example.org/dummydata/",
  "birthdate": "http://schema.org/birthDate/",
  "soman": "http://sweetontology.net/matrAnimal/",
  "eupont": "http://elite.polito.it/ontologies/eupont.owl#",
  "sostss": "http://sweetontology.net/stateSpaceScale/",
  "atm": "https://data.nasa.gov/ontologies/atmonto/ATM#",
  "asio": "http://purl.org/hercules/asio/core#",
  "soreala": "http://sweetontology.net/realmLandAeolian/",
  "sophfi": "http://sweetontology.net/phenFluidInstability/",
  "sophhe": "http://sweetontology.net/phenHelio/",
  "sostsc": "http://sweetontology.net/stateSpaceConfiguration/",
  "s4agri": "https://saref.etsi.org/saref4agri/",
  "matvoc": "http://stream-ontology.com/matvoc/",
  "istex": "https://data.istex.fr/ontology/istex#",
  "wasa": "http://vocab.sti2.at/wasa/",
  "somamic": "http://sweetontology.net/matrMicrobiota/",
  "persoon": "http://data.vlaanderen.be/ns/persoon#",
  "sopho": "http://sweetontology.net/phenOcean/",
  "soreaab": "http://sweetontology.net/realmAstroBody/",
  "somapa": "http://sweetontology.net/matrParticle/",
  "sohud": "http://sweetontology.net/humanDecision/",
  "fibo": "https://spec.edmcouncil.org/fibo/ontology/master/latest/",
  "mobiliteit": "https://data.vlaanderen.be/ns/mobiliteit#",
  "ci": "https://privatealpha.com/ontology/content-inventory/1#",
  "docam": "https://www.docam.ca/glossaurus/",
  "malaka": "http://george.gr/",
  "io": "https://iaco.me/",
  "osmnode": "https://www.openstreetmap.org/node/",
  "iaco": "https://iaco.me/",
  "ogura": "https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#",
  "sostsl": "http://sweetontology.net/stateSpectralLine/",
  "ccsla": "http://cookingbigdata.com/linkeddata/ccsla#",
  "ccr": "http://cookingbigdata.com/linkeddata/ccregions#",
  "sophg": "http://sweetontology.net/phenGeol/",
  "waa": "http://purl.oclc.org/NET/WebApiAuthentication#",
  "sostst": "http://sweetontology.net/stateStorm/",
  "sophgv": "http://sweetontology.net/phenGeolVolcano/",
  "rl": "http://rl.com/resources/",
  "s4ener": "https://saref.etsi.org/saref4ener/",
  "sohua": "http://sweetontology.net/humanAgriculture/",
  "toaru": "https://metadata.moe/toaru-sparql/elements/",
  "eppo": "https://gd.eppo.int/taxon/",
  "sorealv": "http://sweetontology.net/realmLandVolcanic/",
  "knows": "http://semantic.komc/usu/2020/knows#",
  "oplfeat": "http://www.openlinksw.com/ontology/features#",
  "dfcb": "http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
  "dbonto": "http://dbepedia.org/ontology/",
  "sophgf": "http://sweetontology.net/phenGeolFault/",
  "osmway": "https://www.openstreetmap.org/way/",
  "fx": "http://sparql.xyz/facade-x/ns/",
  "arp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
  "uimo": "http://vocab.sti2.at/uimo/",
  "kko": "http://kbpedia.org/kko/rc/",
  "bperson": "http://data.vlaanderen.be/ns/persoon#",
  "cts": "http://rdf.cdisc.org/ct/schema#",
  "lexicog": "http://www.w3.org/ns/lemon/lexicog#",
  "fernanda": "http://fernanda.nl/",
  "jur": "http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#",
  "rdasource": "http://rdaregistry.info/termList/RDARecordingSources/",
  "mr": "http://marineregions.org/ns/ontology#",
  "movieo": "http://movie.com/ontology/",
  "wotc": "http://purl.org/wot-catalogue#",
  "ei2a": "http://opendata.aragon.es/def/ei2a#",
  "vlueprint": "https://vlueprint.org/schema/",
  "karstlink": "https://ontology.uis-speleo.org/ontology/#",
  "sorea": "http://sweetontology.net/realm/",
  "ebg": "http://data.businessgraph.io/ontology#",
  "prismdb": "https://prismdb.takanakahiko.me/prism-schema.ttl#",
  "rdapol": "http://rdaregistry.info/termList/RDAPolarity/",
  "saref4envi": "https://saref.etsi.org/saref4envi/",
  "bao": "http://www.bioassayontology.org/bao#",
  "ld": "http://linkeddata.ru/",
  "epcis": "https://ns.gs1.org/epcis/",
  "gco": "http://purl.jp/bio/12/glyco/conjugate#",
  "mgv": "http://mangaview.fr/mgv#",
  "ams": "http://data.amadeus.com/",
  "srv": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
  "gom": "https://w3id.org/gom#",
  "xyz": "http://sparql.xyz/facade-x/data/",
  "hpont": "https://w3id.org/hpont#",
  "ble": "http://vocab.rapidthings.eu/ns/ble.ttl#",
  "textgrid": "https://textgridrep.org/",
  "i18n": "https://www.w3.org/ns/i18n#",
  "marcgt": "https://id.loc.gov/vocabulary/marcgt/",
  "mpg123": "https://devuan.net.br/wiki/mpg123/",
  "freq": "http://purl.org/cld/freq/",
  "bop": "https://w3id.org/bop#",
  "contry": "http://dbpedia.org/resource/Lyon#",
  "ibeacon": "http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#",
  "mag": "https://makg.org/property/",
  "univ": "http://univ.io/",
  "oeso": "http://www.opensilex.org/vocabularies/oeso#",
  "quran": "http://khalidaloufi.sa/quran#",
  "cso": "http://cso.kmi.open.ac.uk/schema/cso/",
  "tso": "https://w3id.org/tso#",
  "maroc": "http://fr.dbpedia.org/page/Maroc/",
  "accid": "http://pid.accurids.com/",
  "bcom": "https://w3id.org/bcom#",
  "estraf": "http://vocab.ciudadesabiertas.es/def/transporte/trafico#",
  "rdat": "http://rdaregistry.info/Elements/t/",
  "vr": "https://www.w3.org/2018/credentials/v1/",
  "mltd": "https://mltd.pikopikopla.net/mltd-schema#",
  "rofchrda": "http://rdaregistry.info/termList/rofchrda/",
  "srr": "https://w3id.org/srr#",
  "motogp": "http://www.motogp.com/",
  "la": "https://linked.art/ns/terms/",
  "hola": "https://moodle.insa-lyon.fr/course/view.php?id=",
  "w3geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "rdaut": "http://rdaregistry.info/termList/RDAUnitOfTime/",
  "cbv": "https://ns.gs1.org/cbv/",
  "vph": "http://purl.org/ozo/vph.owl#",
  "bleadapter": "http://vocab.rapidthings.eu/ns/ble/adapter.ttl#",
  "hops": "https://rdf.ag/o/hops#",
  "dom": "https://html.spec.whatwg.org/#",
  "bdg": "http://data.bigdatagrapes.eu/resource/ontology/",
  "contax": "https://w3id.org/con-tax#",
  "seasd": "https://w3id.org/seas/",
  "samian": "http://lod.archaeology.link/data/samian/",
  "mesh2021": "http://id.nlm.nih.gov/mesh/2021/",
  "esconv": "http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#",
  "smithy": "https://awslabs.github.io/smithy/rdf-1.0#",
  "pgxo": "http://pgxo.loria.fr/",
  "check": "http://pornhub.com/",
  "mdcs": "https://mdcs.monumentenkennis.nl/damageatlas/ontology#",
  "rdaep": "http://rdaregistry.info/termList/RDAExtensionPlan/",
  "geodcat": "http://data.europa.eu/930/",
  "aspect": "http://purl.org/aspect/",
  "kpd": "http://purl.org/kpd/",
  "nsg": "https://neuroshapes.org/",
  "rpg": "http://rpg.data.is4.site/",
  "rdano": "http://rdaregistry.info/Elements/n/object/",
  "mnx": "https://rdf.metanetx.org/schema/",
  "rdaao": "http://rdaregistry.info/Elements/a/object/",
  "ssnx": "http://purl.oclc.org/NET/ssnx/ssn#",
  "melding": "http://lblod.data.gift/vocabularies/automatische-melding/",
  "faas": "http://semantic-faas.com/ontology#",
  "slm": "http://urn.fi/URN:NBN:fi:au:slm:",
  "sty": "http://purl.bioontology.org/ontology/STY/",
  "rdaio": "http://rdaregistry.info/Elements/i/object/",
  "rdamd": "http://rdaregistry.info/Elements/m/datatype/",
  "datagc": "https://data.grottocenter.org/ldp/",
  "signify": "http://purl.org/signify/ns#",
  "roffgrda": "http://rdaregistry.info/termList/roffgrda/",
  "lado": "http://archaeology.link/ontology#",
  "esautob": "http://vocab.ciudadesabiertas.es/def/transporte/autobus#",
  "rdatb": "http://rdaregistry.info/termList/RDATypeOfBinding/",
  "rdaxd": "http://rdaregistry.info/Elements/x/datatype/",
  "rdato": "http://rdaregistry.info/Elements/t/object/",
  "spec": "http://www.w3.org/ns/spec#",
  "sou": "http://qudt.org/vocab/sou/",
  "comp": "http://semweb.mmlab.be/ns/rml-compression#",
  "itops": "https://vocab.eccenca.com/itops/",
  "idpo": "https://w3id.org/idpo#",
  "folio": "http://IBCNServices.github.io/Folio-Ontology/Folio.owl#",
  "rdaid": "http://rdaregistry.info/Elements/i/datatype/",
  "citedcat": "https://w3id.org/citedcat-ap/",
  "cinema": "http://www.semanticweb.org/julien/morgann/cinema#",
  "cerealstoo": "http://rdf.ag/o/cerealstoo#",
  "stax": "https://w3id.org/stax/ontology#",
  "oidc": "http://www.w3.org/ns/solid/oidc#",
  "rdan": "http://rdaregistry.info/Elements/n/",
  "mrk": "http://www.mydomain.org/Mrk-ns#",
  "oghamonto": "http://ontology.ogham.link/",
  "arena": "https://solid.ti.rw.fau.de/public/ns/arena#",
  "rdatask": "http://rdaregistry.info/termList/RDATasks/",
  "rdaed": "http://rdaregistry.info/Elements/e/datatype/",
  "ofn": "http://www.ontotext.com/sparql/functions/",
  "oeo": "https://openenergyplatform.org/ontology/oeo/",
  "esempleo": "http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#",
  "nanopub": "http://www.nanopub.org/nschema#",
  "hqdmontol": "http://www.semanticweb.org/magma-core/ontologies/hqdm#",
  "rdatd": "http://rdaregistry.info/Elements/t/datatype/",
  "rdamo": "http://rdaregistry.info/Elements/m/object/",
  "rofsfrda": "http://rdaregistry.info/termList/rofsfrda/",
  "rofitrda": "http://rdaregistry.info/termList/rofitrda/",
  "matrycs": "http://matrycs.com/",
  "react": "https://w3id.org/react#",
  "luigiusai": "https://www.luigiusai.it/wp#",
  "cpc": "https://data.epo.org/linked-data/def/cpc/",
  "rdamat": "http://rdaregistry.info/termList/RDAMaterial/",
  "magmauser": "http://www.semanticweb.org/magma-core/user#",
  "tci": "https://w3id.org/lbs/tci#",
  "memorix": "http://memorix.io/ontology#",
  "xmlns": "http://www.w3.org/2021/XMLSchema#",
  "rdawo": "http://rdaregistry.info/Elements/w/object/",
  "meat": "http://example.com/",
  "rdapd": "http://rdaregistry.info/Elements/p/datatype/",
  "m8g": "http://data.europa.eu/m8g/",
  "rdaxo": "http://rdaregistry.info/Elements/x/object/",
  "rdaim": "http://rdaregistry.info/termList/RDAInteractivityMode/",
  "mrt": "http://marineregions.org/ns/placetypes#",
  "ch": "https://schema.ld.admin.ch/",
  "ogham": "http://lod.ogham.link/data/",
  "rdasca": "http://rdaregistry.info/termList/scale/",
  "feed": "https://www.feedipedia.org/",
  "encargado": "http://semRAT.edu/",
  "m4i": "http://w3id.org/nfdi4ing/metadata4ing#",
  "paf": "https://paf.link/",
  "nbo": "http://data.bioontology.org/ontologies/NBO/",
  "edu": "https://schema.edu.ee/",
  "bcfowl": "http://lbd.arch.rwth-aachen.de/bcfOWL#",
  "rdap": "http://rdaregistry.info/Elements/p/",
  "eep": "https://w3id.org/eep#",
  "rdand": "http://rdaregistry.info/Elements/n/datatype/",
  "biocrm": "http://ldf.fi/schema/bioc/",
  "aff": "https://w3id.org/affectedBy#",
  "cgo": "https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#",
  "cpg": "http://modellingdh.github.io/ont/odp/pgc/",
  "ewg": "http://ethoinformatics.org/",
  "poke": "https://pokemonkg.org/ontology#",
  "s223": "http://data.ashrae.org/standard223#",
  "eurio": "http://data.europa.eu/s66#",
  "interop": "http://www.w3.org/ns/solid/interop#",
  "gax": "http://w3id.org/gaia-x/core#",
  "djo": "http://purl.org/datajourneys/",
  "nsd": "https://w3id.org/nsd#",
  "rc": "https://w3id.org/rc#",
  "esc": "https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#",
  "rdapath": "http://rdaregistry.info/termList/RDARecordingMethods/",
  "srmo": "https://w3id.org/srmo#",
  "lds": "https://solid.ti.rw.fau.de/public/ns/linked-data-structures#",
  "olias": "http://purl.org/olia/system.owl#",
  "bau": "https://terminology.fraunhofer.de/voc/bau#",
  "rdawd": "http://rdaregistry.info/Elements/w/datatype/",
  "uberon": "http://purl.obolibrary.org/obo/UBERON_",
  "srt": "http://w3id.org/srt#",
  "dsd": "https://w3id.org/dsd#",
  "sds": "https://w3id.org/sds#",
  "asf": "https://www.stm-assoc.org/asf/",
  "tro": "https://w3id.org/TRO/",
  "caso": "http://www.w3id.org/def/caso#",
  "quid": "https://w3id.org/quid/",
  "eb": "https://w3id.org/eb#",
  "srtun": "https://www.inf.bi.rub.de/srtun#",
  "godaddy": "https://sso.godaddy.com/",
  "ea": "http://eaontology.protect.linkeddata.es/def/",
  "chameo": "https://w3id.org/emmo/domain/characterisation-methodology/chameo#",
  "bdsubj": "https://purl.org/fidbaudigital/subjects#",
  "lbds": "https://w3id.org/lbdserver#",
  "ghga": "http://w3id.org/ghga/",
  "ldpsc": "https://solid.ti.rw.fau.de/public/ns/stream-containers#",
  "kdsf": "https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#",
  "rsx": "http://rdf4j.org/shacl-extensions#",
  "walmart": "https://www.amazon.de/",
  "wfont": "https://w3id.org/wfont#",
  "ofo": "https://w3id.org/ofo#",
  "archivo": "https://archivo.dbpedia.org/onto#",
  "ppeer": "http://parliament.uk/ontologies/peerage/",
  "magmardl": "http://www.semanticweb.org/magma-core/rdl#",
  "lbdserver": "https://w3id.org/lbdserver#",
  "stix": "http://purl.org/cyber/stix#",
  "ontobras": "http://www.semanticweb.org/fefar/ontologies/ontobras#",
  "conllu": "https://universaldependencies.org/format.html#",
  "wdno": "http://www.wikidata.org/prop/novalue/",
  "hqdm": "http://www.semanticweb.org/hqdm#",
  "generiek": "https://data.vlaanderen.be/ns/generiek#",
  "osdu": "https://w3id.org/OSDU#",
  "experts": "http://emmo.info/emmo/application/maeo/experts#",
  "stirdata": "https://w3id.org/stirdata/vocabulary/",
  "rto": "https://w3id.org/rail/topo#",
  "rmlt": "http://semweb.mmlab.be/ns/rml-target#",
  "fpr": "http://www.filmstandards.org/schemas/filmportal_relations#",
  "bag2": "http://bag.basisregistraties.overheid.nl/def/bag#",
  "nprl": "http://data.nobelprize.org/resource/laureate/",
  "fso": "https://w3id.org/fso#",
  "dmo": "https://w3id.org/dmo#",
  "opltw": "http://www.openlinksw.com/schemas/twitter#",
  "linkml": "https://w3id.org/linkml/",
  "nomo": "https://nomenclature.info/nom/ontology/",
  "diso": "https://purls.helmholtz-metadaten.de/diso#",
  "express": "https://w3id.org/express#",
  "setl": "http://purl.org/twc/vocab/setl/",
  "marc": "http://www.loc.gov/MARC21/slim/",
  "tern": "http://w3id.org/tern/ontologies/tern/",
  "paam": "https://lod.mediathek-tanz-theater.de/schema/paam/",
  "rsp": "http://www.researchspace.org/resource/",
  "covido": "https://w3id.org/CovidO#",
  "crmsci": "http://www.cidoc-crm.org/extensions/crmsci/",
  "itcrdf": "http://www.w3.org/2005/11/its/rdf#",
  "rro": "http://semanticweb.org/patricia/ontologies/rro#",
  "lsqr": "http://lsq.aksw.org/",
  "rdaeo": "http://rdaregistry.info/Elements/e/object/",
  "jsonld": "http://www.w3.org/ns/json-ld#",
  "hni": "https://collectiedata.hetnieuweinstituut.nl/",
  "raum": "https://terminology.fraunhofer.de/voc/raum#",
  "roh": "http://w3id.org/roh#",
  "rism": "http://rism.online/",
  "ultragaz": "https://ultragaz24horas.com/",
  "chemrof": "https://w3id.org/chemrof/",
  "kgi": "http://ns.inria.fr/kg/index#",
  "weki": "https://en.wikipedia.org/wiki/",
  "pgo": "http://ii.uwb.edu.pl/pgo#",
  "respond": "https://w3id.org/respond#",
  "rnce": "https://data.cultureelerfgoed.nl/id/rnce#",
  "linkedart": "https://linked.art/ns/terms/",
  "lrcommon": "http://landregistry.data.gov.uk/def/common/",
  "chess": "http://purl.org/NET/rdfchess/ontology/",
  "consolid": "https://w3id.org/consolid#",
  "vl": "https://version.link/",
  "tempo": "http://purl.org/tempo/",
  "besluitvor": "https://data.vlaanderen.be/ns/besluitvorming#",
  "iddo": "https://w3id.org/iddo#",
  "cido": "http://purl.obolibrary.org/obo/cido.owl/",
  "nom": "https://nomenclature.info/nom/",
  "gufo": "http://purl.org/nemo/gufo#",
  "dsi": "https://data.dsi.omgeving.vlaanderen.be/ns/dsi#",
  "value": "http://gfgfd.vs/",
  "osmo": "https://purl.org/vimmp/osmo#",
  "vntourism": "http://www.semanticweb.org/minhn/ontologies/2021/0/vntourism#",
  "icon": "https://w3id.org/icon/ontology/",
  "grscicoll": "https://www.gbif.org/grscicoll/collection/",
  "bp3": "http://www.biopax.org/release/biopax-level3.owl#",
  "gql": "http://www.openlinksw.com/schemas/graphql#",
  "film": "http://semantics.id/ns/example/film/",
  "rtedurp": "http://purl.org/eduo/rtedurp/",
  "peco": "https://w3id.org/peco#",
  "rcgs": "https://collection.rcgs.jp/terms/",
  "ttrpg": "https://w3id.org/TTRpg#",
  "robotarm": "https://solid.ti.rw.fau.de/public/ns/robotArm#",
  "veelana": "http://onlyfans.com/veelana/",
  "mondo": "http://purl.obolibrary.org/obo/MONDO_",
  "perscido": "https://perscido.univ-grenoble-alpes.fr/",
  "dbd": "http://dbpedia.org/datatype/",
  "pubchem": "https://pubchem.ncbi.nlm.nih.gov/",
  "cvb": "http://rdfs.org/resume-rdf/base.rdfs#",
  "relation": "http://www.iana.org/assignments/relation/",
  "spatialf": "http://jena.apache.org/function/spatial#",
  "dqvno": "https://data.norge.no/vocabulary/dqvno#",
  "apods": "http://activitypods.org/ns/core#",
  "raad": "https://raadzaam.nl/schema/",
  "nen2660": "https://w3id.org/nen2660/def#",
  "aec3po": "https://w3id.org/lbd/aec3po/",
  "fdp": "https://w3id.org/fdp/fdp-o#",
  "kokot": "http://www.koko.t/",
  "yanice": "http://yanice-boady.webflow.io/",
  "vhbieo": "https://w3id.org/vhbieo#",
  "version": "https://version.link/",
  "iottta": "https://w3id.org/iot-tta#",
  "nalt": "https://lod.nal.usda.gov/nalt/",
  "era": "http://data.europa.eu/949/",
  "dcb": "http://dbpedia.org/resource/Category:",
  "bmp": "http://w3id.org/bmp#",
  "coy": "https://schema.coypu.org/global#",
  "skosm": "http://www.w3.org/2004/02/skos/mapping#",
  "lis": "http://rds.posccaesar.org/ontology/lis14/rdl/",
  "ufo": "http://ufo.com/#",
  "lol": "https://sbalot.github.io/lol/",
  "bto": "http://w3id.org/emmo-bto/bto#",
  "docbook": "http://docbook.org/ns/docbook/",
  "plant": "http://example.org/plant/",
  "epo": "http://data.europa.eu/a4g/ontology#",
  "hmas": "https://purl.org/hmas/",
  "thub": "http://vocabularis.crai.ub.edu/thub/",
  "fdof": "https://w3id.org/fdof/ontology#",
  "emmo": "https://w3id.org/emmo#",
  "bcgo": "http://purl.obolibrary.org/obo/ZP_",
  "nutscode": "http://data.europa.eu/nuts/code/",
  "ecfo": "https://w3id.org/ecfo#",
  "mi": "http://www.marineinfo.org/ns/ontology#",
  "dcatap": "http://data.europa.eu/r5r/",
  "fs": "https://www.compliancequest.com/training-management-software-system-solutions/",
  "dick": "http://pornhub.com/",
  "dcatno": "https://data.norge.no/vocabulary/dcatno#",
  "wrroc": "https://w3id.org/ro/terms/workflow-run#",
  "ontouml": "https://w3id.org/ontouml#",
  "vcs": "https://data.vlaanderen.be/ns/chemische_stof#",
  "hyr": "https://w3id.org/simulation/data/",
  "ammo": "http://ldf.fi/schema/ammo/",
  "to": "http://purl.obolibrary.org/obo/TO_",
  "ags": "https://id.agschemas.org/",
  "dbpg": "http://dbpedia.org/page/",
  "threat": "https://cve.mitre.org/",
  "asb": "https://w3id.org/asbingowl/core#",
  "acp": "http://www.w3.org/ns/solid/acp#",
  "coreo": "http://purl.org/coreo#",
  "atcc": "https://www.atcc.org/products/",
  "goavoc": "http://bio2rdf.org/goa_vocabulary:",
  "ntp": "https://schema.finto.fi/ntp#",
  "cur": "http://qudt.org/2.1/vocab/currency/",
  "risk": "https://www.w3id.org/risk#",
  "iop": "https://w3id.org/iadopt/ont/",
  "imbor": "https://data.crow.nl/imbor/def/",
  "lcnaf": "http://id.loc.gov/authorities/names/",
  "egdo": "http://example.org/",
  "coos": "http://id.unece.org/def/coos#",
  "baf": "https://w3id.org/baf#",
  "pico": "https://personsincontext.org/model#",
  "matmine": "http://materialsmine.org/ns/",
  "tsso": "https://scch.org/technical_standards#",
  "databus": "https://dataid.dbpedia.org/databus#",
  "mibc": "http://marineinfo.org/ns/library/bibcodes#",
  "sense": "https://w3id.org/sense#",
  "ksamsok": "http://kulturarvsdata.se/ksamsok#",
  "p2po": "https://purl.org/p2p-o#",
  "ceox": "https://linkeddata.cultureelerfgoed.nl/def/ceox#",
  "bacnet": "http://data.ashrae.org/bacnet/2020#",
  "uio": "https://www.mitre.org/mparmelee/ontologies/2023/6/UserIntentOntology/",
  "coda": "http://art.uniroma2.it/coda/contracts/",
  "mindat": "https://www.mindat.org/",
  "rb": "https://w3id.org/riverbench/schema/metadata#",
  "hu": "https://mail.google.com/",
  "ind": "https://w3id.org/inesdata#",
  "quest": "https://rb.gy/ntg7l/",
  "ocmv": "https://w3id.org/ontouml-models/vocabulary#",
  "keyon": "http://keyelements.ltd/ontologies/keyon/#",
  "bsdd": "http://bsdd.buildingsmart.org/def#",
  "notify": "http://www.w3.org/ns/solid/notifications#",
  "koko": "https://seznam.cz/",
  "fisa": "https://ifitkau.github.io/fisa/",
  "pit": "http://data.elsevier.com/vocabulary/ElsevierPubItemTypes/",
  "ogcf": "http://www.opengis.net/def/function/geosparql/",
  "mibt": "https://marineinfo.org/ns/library/bibtypes#",
  "bioschemas": "https://bioschemas.org/",
  "rbdoc": "https://w3id.org/riverbench/schema/documentation#",
  "into": "https://app.korfin.de/ontology/into/",
  "ncbi": "https://www.ncbi.nlm.nih.gov/",
  "sssom": "https://w3id.org/sssom/",
  "cpsvno": "http://data.norge.no/vocabulary/cpsvno#",
  "doce": "http://purl.org/nemo/doce#",
  "hy": "https://api.hyprdia.com/",
  "cercabib": "https://cercabib.ub.edu/",
  "semapv": "https://w3id.org/semapv/vocab/",
  "w3": "http://www.w3.org/",
  "exekg": "https://raw.githubusercontent.com/nsai-uio/ExeKGOntology/main/ds_exeKGOntology.ttl#",
  "dde": "https://www.ddeworld.org/",
  "pbac": "https://w3id.org/pbac#",
  "plasma": "https://w3id.org/plasma#",
  "mpio": "http://purl.obolibrary.org/obo/ZP_",
  "mifesto": "https://w3id.org/mifesto#",
  "ontologia": "http://ub.edu/dades/ontologia/Cinema#Cinemes#",
  "doam": "http://emmo.info/doam#",
  "lpwcc": "https://linkedpaperswithcode.com/class/",
  "quit": "http://quit.aksw.org/vocab/",
  "cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties/",
  "coswot": "https://w3id.org/coswot/",
  "pdumdv": "http://purl.obolibrary.org/obo/PdumDv_",
  "ioc": "http://w3id.org/ioc#",
  "skosno": "http://data.norge.no/skosno#",
  "ontohgis": "https://onto.kul.pl/ontohgis/",
  "pcp": "https://pcp-on-web.de/ontology/0.2/index-en.html#",
  "ohd": "http://purl.obolibrary.org/obo/ZP_",
  "top": "http://w3id.org/topologicpy#",
  "oplben": "http://www.openlinksw.com/ontology/benefits#",
  "hsapdv": "http://purl.obolibrary.org/obo/HsapDv_",
  "mfo": "http://purl.obolibrary.org/obo/ZP_",
  "battery": "https://w3id.org/emmo/domain/battery/battery#",
  "sure": "http://ns.inria.fr/sure#",
  "sri": "https://w3id.org/sri#",
  "batmanont": "http://emmo.info/emmo/application/bmo#",
  "isoprops": "https://w3id.org/isoprops#",
  "interpro": "https://www.ebi.ac.uk/interpro/entry/InterPro/",
  "mir": "http://marineinfo.org/ns/person/roles#",
  "nmr": "https://www.ebi.ac.uk/ols4/ontologies/nmrcv/terms?short_form=NMR:",
  "lpwc": "https://linkedpaperswithcode.com/property/",
  "oav": "http://lod.openaire.eu/vocab/",
  "gramene": "http://www.gramene.org/db/ontology/search?id=GRO:",
  "chpaf": "https://ch.paf.link/",
  "ies4": "http://ies.data.gov.uk/ontology/ies4#",
  "htn": "http://purl.obolibrary.org/obo/ZP_",
  "ies": "http://ies.data.gov.uk/ontology/ies4#",
  "eurovoc": "http://eurovoc.europa.eu/",
  "upheno": "http://purl.obolibrary.org/obo/UPHENO_",
  "loggerhead": "http://purl.obolibrary.org/obo/LOGGERHEAD_",
  "hom": "http://purl.obolibrary.org/obo/HOM_",
  "maeo": "http://w3id.org/emmo-maeo/maeo#",
  "ornaseq": "http://purl.obolibrary.org/obo/ORNASEQ_",
  "ddpheno": "http://purl.obolibrary.org/obo/DDPHENO_",
  "clyh": "http://purl.obolibrary.org/obo/ZP_",
  "proco": "http://purl.obolibrary.org/obo/PROCO_",
  "sopharm": "http://purl.obolibrary.org/obo/SOPHARM_",
  "apollosv": "http://purl.obolibrary.org/obo/APOLLO_SV_",
  "openwemi": "https://ns.dublincore.org/openwemi/",
  "cred": "https://www.w3.org/2018/credentials#",
  "cergy": "https://dbpedia.org/page/Cergy/",
  "przecieki": "http://onlyfans.com/emiliaszymanska/",
  "sep": "http://purl.obolibrary.org/obo/ZP_",
  "nyon": "https://w3id.org/def/nyon#",
  "sbo": "https://paul.ti.rw.fau.de/~jo00defe/ble/sbo#",
  "fro": "https://foundry.ai.mil/ontology/nas/fro/",
  "iig": "https://w3id.org/iicongraph/data/",
  "kbmarc": "https://id.kb.se/marc/",
  "wbls": "http://purl.obolibrary.org/obo/WBls_",
  "msl": "https://w3id.org/msl#",
  "imdb": "http://m.imdb.com/",
  "vt": "http://purl.obolibrary.org/obo/VT_",
  "mro": "http://purl.obolibrary.org/obo/MRO_",
  "olis": "http://olis.dev/",
  "fovt": "http://purl.obolibrary.org/obo/FOVT_",
  "tdm": "http://www.w3.org/ns/tdmrep#",
  "jps": "https://jpsearch.go.jp/term/property#",
  "cob": "http://purl.obolibrary.org/obo/COB_",
  "soa": "https://semopenalex.org/ontology/",
  "iptc4xmpc": "http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/",
  "htv": "http://www.w3.org/2011/http#",
  "gallont": "http://purl.obolibrary.org/obo/GALLONT_",
  "mee": "http://www.w3.org/ns/pim/meeting#",
  "shsh": "http://www.w3.org/ns/shacl-shacl#",
  "capdata": "https://ontologie.capdataculture.fr/v1/owl/#",
  "iceo": "http://purl.obolibrary.org/obo/ICEO_",
  "lpto": "http://w3id.org/lpto#",
  "credit": "https://credit.niso.org/",
  "dgaterms": "https://w3id.org/dgaterms#",
  "osh": "https://w3id.org/oseg/ont/osh#",
  "mao": "https://domestic-beethoven.eu/ontology/1.0/music-annotation-ontology.ttl#",
  "oplmarket": "http://www.openlinksw.com/ontology/market#",
  "doid": "http://purl.obolibrary.org/obo/DOID_",
  "loinc": "https://loinc.org/",
  "dcid": "https://datacommons.org/browser/",
  "taxrank": "http://purl.obolibrary.org/obo/TAXRANK_",
  "aao": "http://purl.obolibrary.org/obo/AAO_",
  "deonta": "https://deonta.linkedmodel.org/deonta/",
  "vhog": "http://purl.obolibrary.org/obo/VHOG_",
  "lrm": "https://iflastandards.info/ns/lrm/lrmoo/",
  "gecko": "http://purl.obolibrary.org/obo/ZP_",
  "planp": "http://purl.obolibrary.org/obo/PLANP_",
  "mop": "http://purl.obolibrary.org/obo/MOP_",
  "occupation": "http://nikunj.org/ontology/occupatioin#",
  "emap": "http://purl.obolibrary.org/obo/EMAP_",
  "fbdv": "http://purl.obolibrary.org/obo/FBdv_",
  "echem": "https://w3id.org/emmo/domain/electrochemistry#",
  "hao": "http://purl.obolibrary.org/obo/HAO_",
  "apmwg": "http://apmwg.ovh/",
  "obi": "http://purl.obolibrary.org/obo/OBI_",
  "spd": "http://purl.obolibrary.org/obo/SPD_",
  "okh": "https://w3id.org/oseg/ont/okh#",
  "geolink": "http://schema.geolink.org/1.0/base/main#",
  "foaa": "https://kibanshoe.com/",
  "propreo": "http://purl.obolibrary.org/obo/PROPREO_",
  "fbbt": "http://purl.obolibrary.org/obo/FBbt_",
  "chems": "https://w3id.org/emmo/domain/chemical-substance#",
  "fbcv": "http://purl.obolibrary.org/obo/FBcv_",
  "cmf": "http://purl.obolibrary.org/obo/CMF_",
  "hpo": "http://w3id.org/emmo-hpo/hpo#",
  "liph": "https://gallosiciliani.unict.it/ns/lpont#",
  "mco": "http://purl.obolibrary.org/obo/MCO_",
  "clao": "http://purl.obolibrary.org/obo/CLAO_",
  "mbl": "https://w3id.org/mbl#",
  "oio": "http://www.geneontology.org/formats/oboInOwl#",
  "ons": "http://purl.obolibrary.org/obo/ONS_",
  "idomal": "http://purl.obolibrary.org/obo/IDOMAL_",
  "firebim": "http://w3id.org/firebim#",
  "spo": "https://w3id.org/steel/ProcessOntology/",
  "sibo": "http://purl.obolibrary.org/obo/ZP_",
  "omo": "http://purl.obolibrary.org/obo/OMO_",
  "uo": "http://purl.obolibrary.org/obo/UO_",
  "crmgeo": "http://www.ics.forth.gr/isl/CRMgeo/",
  "foodon": "http://purl.obolibrary.org/obo/FOODON_",
  "sepio": "http://purl.obolibrary.org/obo/SEPIO_",
  "dpo": "http://purl.obolibrary.org/obo/FBcv_",
  "tsdcreq": "https://w3id.org/oseg/ont/tsdc/req#",
  "ogsf": "http://purl.obolibrary.org/obo/OGSF_",
  "pao": "http://purl.obolibrary.org/obo/PAO_",
  "aimaix": "https://w3id.org/aimaix#",
  "ontoavida": "http://purl.obolibrary.org/obo/ONTOAVIDA_",
  "imr": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IMR&id=",
  "fiaf": "https://ontology.fiafcore.org/",
  "tops": "http://www.topbraid.org/tops#",
  "schemas": "https://schema.org/",
  "rxno": "http://purl.obolibrary.org/obo/ZP_",
  "clo": "http://purl.obolibrary.org/obo/ZP_",
  "meas": "https://graph.interoptx.org/meas/",
  "cvdo": "http://purl.obolibrary.org/obo/CVDO_",
  "uiot": "http://www.w3id.org/urban-iot/core#",
  "cwo": "http://kcoyle.net/cwo/",
  "ecp": "http://www.ebu.ch/metadata/ontologies/ebucoreplus#",
  "ecocore": "http://purl.obolibrary.org/obo/ECOCORE_",
  "mfoem": "http://purl.obolibrary.org/obo/MFOEM_",
  "ovae": "http://purl.obolibrary.org/obo/OVAE_",
  "tto": "http://purl.obolibrary.org/obo/TTO_",
  "bcnres": "http://datos.bcn.cl/ontologies/bcn-resources#",
  "cacax": "http://cacax.fun/",
  "miprog": "https://marineinfo.org/ns/progress#",
  "pgdso": "http://purl.obolibrary.org/obo/PGDSO_",
  "maid": "https://mutual-aid.app/ns/core#",
  "guez": "http://guez.fr/",
  "stroke": "https://mre.zcu.cz/ontology/stroke.owl#",
  "duo": "http://purl.obolibrary.org/obo/DUO_",
  "crcr": "https://credit.niso.org/contributor-roles/",
  "bootstrep": "http://purl.obolibrary.org/obo/BOOTSTREP_",
  "gtm": "https://www.goudatijdmachine.nl/def#",
  "obom": "https://w3id.org/open-bom/ont/open-bom#",
  "tsdc": "https://w3id.org/oseg/ont/tsdc/core#",
  "qualityze": "https://www.qualityze.com/document-management/",
  "bspo": "http://purl.obolibrary.org/obo/BSPO_",
  "dictionary": "https://standards.buildingsmart.org/DataDictionary/",
  "edtf": "http://id.loc.gov/datatypes/EDTFScheme/",
  "vair": "https://w3id.org/vair#",
  "ohpi": "http://purl.obolibrary.org/obo/OHPI_",
  "multionto": "http://purl.org/net/multionto/",
  "ncro": "http://purl.obolibrary.org/obo/NCRO_",
  "mat": "http://purl.obolibrary.org/obo/MAT_",
  "eupath": "http://purl.obolibrary.org/obo/EUPATH_",
  "geogeo": "http://purl.obolibrary.org/obo/GEO_",
  "libeas": "https://w3id.org/libeas#",
  "hht": "https://w3id.org/HHT#",
  "xao": "http://purl.obolibrary.org/obo/XAO_",
  "mpath": "http://purl.obolibrary.org/obo/MPATH_",
  "mmusdv": "http://purl.obolibrary.org/obo/MmusDv_",
  "joe": "http://example.org/joe/",
  "symp": "http://purl.obolibrary.org/obo/SYMP_",
  "xco": "http://purl.obolibrary.org/obo/XCO_",
  "duodrl": "https://w3id.org/duodrl#",
  "amv": "https://w3id.org/amv/",
  "tgma": "http://purl.obolibrary.org/obo/TGMA_",
  "after": "http://rds.posccaesar.org/ontology/plm/ds/",
  "pwkso": "http://ns.inria.fr/pwkso/",
  "mfomd": "http://purl.obolibrary.org/obo/MFOMD_",
  "moont": "https://w3id.org/moont/",
  "otrl": "https://w3id.org/oseg/ont/otrl#",
  "cams": "https://graph.interoptx.org/cams/schema/",
  "oba": "http://purl.obolibrary.org/obo/OBA_",
  "pa": "http://vtw.elsevier.com/data/ns/properties/PromotionalAccess-1/",
  "nihss": "https://mre.zcu.cz/ontology/nihss.owl#",
  "emobon": "http://www.embrc.eu/emobon/EmoBonOntology#",
  "apo": "http://purl.obolibrary.org/obo/APO_",
  "labo": "http://purl.obolibrary.org/obo/LABO_",
  "zea": "http://purl.obolibrary.org/obo/ZEA_",
  "ckg": "http://example.org/ckg#",
  "ypc": "http://www.semanticweb.org/sunsr/ontologies/2024/ypc#",
  "opmi": "http://purl.obolibrary.org/obo/OPMI_",
  "ehdaa": "http://purl.obolibrary.org/obo/EHDAA_",
  "lipro": "http://purl.obolibrary.org/obo/LIPRO_",
  "cteno": "http://purl.obolibrary.org/obo/CTENO_",
  "edo": "http://semanticweb.org/edo#",
  "flopo": "http://purl.obolibrary.org/obo/FLOPO_",
  "biomodels": "http://purl.obolibrary.org/obo/KISAO_",
  "pcl": "http://purl.obolibrary.org/obo/PCL_",
  "dideo": "http://purl.obolibrary.org/obo/DIDEO_",
  "ogms": "http://purl.obolibrary.org/obo/OGMS_",
  "pdro": "http://purl.obolibrary.org/obo/PDRO_",
  "hancestro": "http://purl.obolibrary.org/obo/HANCESTRO_",
  "gsso": "http://purl.obolibrary.org/obo/GSSO_",
  "qcy": "https://qaecy.com/dev/ont#",
  "ceph": "http://purl.obolibrary.org/obo/CEPH_",
  "chiro": "http://purl.obolibrary.org/obo/CHIRO_",
  "amphx": "http://purl.obolibrary.org/obo/AMPHX_",
  "luffy": "http://google.com/",
  "chmo": "http://purl.obolibrary.org/obo/CHMO_",
  "ehdaa2": "http://purl.obolibrary.org/obo/EHDAA2_",
  "pw": "http://purl.obolibrary.org/obo/PW_",
  "spa": "https://paul.ti.rw.fau.de/~jo00defe/voc/spa#",
  "txpo": "http://purl.obolibrary.org/obo/ZP_",
  "slso": "http://purl.obolibrary.org/obo/SLSO_",
  "disdriv": "http://purl.obolibrary.org/obo/DISDRIV_",
  "termdat": "https://register.ld.admin.ch/termdat/",
  "occo": "http://purl.obolibrary.org/obo/OCCO_",
  "oplgit": "http://www.openlinksw.com/schemas/github#",
  "dprod": "https://ekgf.github.io/dprod/",
  "dop": "https://w3id.org/dob/voc/prop#",
  "whyis": "http://vocab.rpi.edu/whyis/",
  "omrse": "http://purl.obolibrary.org/obo/OMRSE_",
  "aio": "https://paul.ti.rw.fau.de/~jo00defe/SemWoT/aio#",
  "pes": "https://semanticweb.inesctec.pt/ontologies/pes/",
  "norse": "https://w3id.org/aksw/norse#",
  "did": "https://w3id.org/dob/id/",
  "vbo": "http://purl.obolibrary.org/obo/VBO_",
  "adw": "https://animaldiversity.org/accounts/",
  "flu": "http://purl.obolibrary.org/obo/FLU_",
  "bila": "http://4dx.embl.de/4DXpress/reg/all/cview/gene.do?geneID=",
  "psdo": "http://purl.obolibrary.org/obo/PSDO_",
  "tahe": "http://purl.obolibrary.org/obo/TAHE_",
  "fix": "http://purl.obolibrary.org/obo/FIX_",
  "nomen": "http://purl.obolibrary.org/obo/NOMEN_",
  "oplmark": "http://www.openlinksw.com/ontology/market#",
  "cr": "http://mlcommons.org/croissant/",
  "ico": "http://purl.obolibrary.org/obo/ICO_",
  "oplog": "http://www.openlinksw.com/schemas/opengraph#",
  "ogg": "http://purl.obolibrary.org/obo/OGG_",
  "vario": "http://purl.obolibrary.org/obo/VariO_",
  "omit": "http://purl.obolibrary.org/obo/OMIT_",
  "oarcs": "http://purl.obolibrary.org/obo/OARCS_",
  "fbbi": "http://purl.obolibrary.org/obo/FBbi_",
  "aix": "https://w3id.org/aix#",
  "rdfl": "https://w3id.org/rdf-lens/ontology#",
  "lepao": "http://purl.obolibrary.org/obo/LEPAO_",
  "loin": "http://w3id.org/loin#",
  "cmso": "http://purls.helmholtz-metadaten.de/cmso/",
  "makeup": "http://example.org/makeup#",
  "crdt": "https://vocab.noeldemartin.com/crdt/",
  "ypo": "http://purl.obolibrary.org/obo/YPO_",
  "psn": "https://purl.org/psn/vocab#",
  "oostt": "http://purl.obolibrary.org/obo/OOSTT_",
  "mcro": "https://www.ebi.ac.uk/ols4/ontologies/mcro/classes?obo_id=MCRO:",
  "tahh": "http://purl.obolibrary.org/obo/TAHH_",
  "ado": "http://purl.obolibrary.org/obo/ADO_",
  "lrmer": "http://iflastandards.info/ns/lrm/lrmer/",
  "envo": "http://purl.obolibrary.org/obo/ZP_",
  "airo": "https://w3id.org/airo#",
  "ceosp": "https://linkeddata.cultureelerfgoed.nl/def/ceosp/",
  "musi": "http://i-na-reg.musikinstrumentenbau.eu/ns/musi/",
  "upa": "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=",
  "dinto": "http://purl.obolibrary.org/obo/ZP_",
  "wbbt": "http://purl.obolibrary.org/obo/WBbt_",
  "tads": "http://purl.obolibrary.org/obo/TADS_",
  "nyanneko": "https://nyanneko.com/",
  "eo": "http://purl.obolibrary.org/obo/EO_",
  "ohmi": "http://purl.obolibrary.org/obo/OHMI_",
  "cdno": "http://purl.obolibrary.org/obo/CDNO_",
  "zfa": "http://purl.obolibrary.org/obo/ZFA_",
  "fobi": "http://purl.obolibrary.org/obo/FOBI_",
  "vsao": "http://purl.obolibrary.org/obo/VSAO_",
  "ogi": "http://purl.obolibrary.org/obo/OGI_",
  "dob": "https://w3id.org/dob/voc#",
  "plana": "http://purl.obolibrary.org/obo/PLANA_",
  "afpo": "http://purl.obolibrary.org/obo/AfPO_",
  "t4fs": "http://purl.obolibrary.org/obo/T4FS_",
  "olatdv": "http://purl.obolibrary.org/obo/OlatDv_",
  "epio": "http://purl.obolibrary.org/obo/EPIO_",
  "ehda": "http://purl.obolibrary.org/obo/EHDA_",
  "fbsp": "http://purl.obolibrary.org/obo/FBSP_",
  "geno": "http://purl.obolibrary.org/obo/GENO_",
  "cio": "http://purl.obolibrary.org/obo/CIO_",
  "reloc": "https://w3id.org/reloc#",
  "colao": "http://purl.obolibrary.org/obo/COLAO_",
  "dblpdocu": "https://dblp.org/rdf/docu/#",
  "vo": "http://purl.obolibrary.org/obo/VO_",
  "ror": "https://ror.org/",
  "zeco": "http://purl.obolibrary.org/obo/ZECO_",
  "vto": "http://purl.obolibrary.org/obo/VTO_",
  "omiabis": "http://purl.obolibrary.org/obo/OMIABIS_",
  "scdo": "http://purl.obolibrary.org/obo/SCDO_",
  "rmle": "https://w3id.org/imec/rml/ns/extensions#",
  "hso": "http://purl.obolibrary.org/obo/HSO_",
  "genepio": "http://purl.obolibrary.org/obo/GENEPIO_",
  "fypo": "http://purl.obolibrary.org/obo/FYPO_",
  "zp": "http://purl.obolibrary.org/obo/ZP_",
  "graphql": "https://graphql.org/",
  "psm": "https://paul.ti.rw.fau.de/~jo00defe/ont/psm#",
  "mfmo": "http://purl.obolibrary.org/obo/MFMO_",
  "cfg": "http://server.topbraidlive.org/web/2009/config#",
  "npc": "https://purl.org/npc#",
  "maxo": "http://purl.obolibrary.org/obo/MAXO_",
  "miapa": "http://purl.obolibrary.org/obo/MIAPA_",
  "oplic": "http://www.openlinksw.com/ontology/licenses#",
  "gno": "http://purl.obolibrary.org/obo/GNO_",
  "kvasir": "https://kvasir.discover.ilabt.imec.be/vocab#",
  "womo": "https://w3id.org/womo#",
  "obcs": "http://purl.obolibrary.org/obo/OBCS_",
  "dron": "http://purl.obolibrary.org/obo/DRON_",
  "ato": "http://purl.obolibrary.org/obo/ATO_",
  "geosrs": "https://w3id.org/geosrs#",
  "volipi": "http://data.sparna.fr/ontologies/volipi#",
  "dtkt": "https://data.wikitrek.org/prop/direct/",
  "vwlid": "https://vwgroup.leanix.net/Volkswagen/external/leanixId/",
  "oip": "http://www.exemple.org/ontologia/",
  "xpo": "http://purl.obolibrary.org/obo/XPO_",
  "miron": "https://stgermain.ebsi.umontreal.ca/miron/",
  "iev": "http://www.inoh.org/ontology-viewer/cgi-bin/InohOVAttr.php?type=IEV&id=",
  "oplgp": "http://www.openlinksw.com/schemas/googleplus#",
  "rex": "http://purl.obolibrary.org/obo/REX_",
  "trans": "http://purl.obolibrary.org/obo/TRANS_",
  "mpbv": "http://meta-pfarrerbuch.evangelische-archive.de/vocabulary#",
  "aero": "http://purl.obolibrary.org/obo/AERO_",
  "zfs": "http://purl.obolibrary.org/obo/ZFS_",
  "aschema": "https://schema.ld.admin.ch/",
  "hhtchange": "https://w3id.org/HHT/Change#",
  "freespins": "https://bohoaff.com/a34fd6fba/",
  "resid": "https://proteininformationresource.org/cgi-bin/resid?id=",
  "jabel54303": "https://softwarehorsepower.com/product/brand24/",
  "gaz": "http://purl.obolibrary.org/obo/GAZ_",
  "poro": "http://purl.obolibrary.org/obo/PORO_",
  "emapa": "http://purl.obolibrary.org/obo/EMAPA_",
  "micro": "http://purl.obolibrary.org/obo/MICRO_",
  "ssv": "https://w3id.org/ssv/",
  "aism": "http://purl.obolibrary.org/obo/AISM_",
  "ftr": "https://w3id.org/ftr#",
  "ino": "http://purl.obolibrary.org/obo/INO_",
  "zo": "https://linkeddata.cultureelerfgoed.nl/def/zo/",
  "tsdcr": "http://w3id.org/oseg/ont/tsdc/requirements#",
  "caro": "http://purl.obolibrary.org/obo/CARO_",
  "fair4ml": "https://w3id.org/fair4ml#",
  "creon": "http://purl.org/creon/",
  "oix": "http://www.exemple.org/ontologia/",
  "xlmod": "http://purl.obolibrary.org/obo/XLMOD_",
  "myv": "http://www.example.com/myvData/",
  "phipo": "http://purl.obolibrary.org/obo/PHIPO_",
  "miro": "http://purl.obolibrary.org/obo/MIRO_",
  "rnao": "http://purl.obolibrary.org/obo/RNAO_",
  "cdi": "http://ddialliance.org/Specification/DDI-CDI/1.0/RDF/",
  "ddanat": "http://purl.obolibrary.org/obo/DDANAT_",
  "ecao": "http://purl.obolibrary.org/obo/ECAO_",
  "jav": "https://www.niso.org/schemas/jav/1.0/",
  "aicat": "http://w3id.org/aicat#",
  "stato": "http://purl.obolibrary.org/obo/STATO_",
  "obib": "http://purl.obolibrary.org/obo/OBIB_",
  "codemeta": "https://codemeta.github.io/terms/",
  "fideo": "http://purl.obolibrary.org/obo/FIDEO_",
  "gsn": "https://w3id.org/OntoGSN/ontology#",
  "checks": "https://data.digichecks.eu/def/",
  "aiup": "http://w3id.org/aiup#",
  "mirnao": "http://purl.obolibrary.org/obo/MIRNAO_",
  "ngbo": "http://purl.obolibrary.org/obo/NGBO_",
  "onlyfans": "https://cutt.ly/3ry8LMcK/",
  "ecto": "http://purl.obolibrary.org/obo/ECTO_",
  "ceon": "http://w3id.org/CEON/",
  "sn": "https://purl.org/supply-network/onto#",
  "frac": "http://www.w3.org/ns/lemon/frac#",
  "ce": "https://purl.org/cityexplorer#",
  "bng": "https://w3id.org/dob/voc/epsg-27700#",
  "dtk": "https://data.wikitrek.org/entity/",
  "aro": "http://purl.obolibrary.org/obo/ARO_",
  "nace2": "http://data.europa.eu/ux2/nace2/",
  "aeo": "http://purl.obolibrary.org/obo/AEO_",
  "podio": "http://w3id.org/podio#",
  "vwlpr": "https://vwgroup.leanix.net/Volkswagen/factsheet/Process/",
  "azo": "https://linkeddata.cultureelerfgoed.nl/def/azo/",
  "encom": "https://semanticweb.inesctec.pt/ontologies/encom/",
  "fugas": "https://onlyfans.com/sammuwuu/",
  "northwind": "http://demo.openlinksw.com/schemas/Northwind/",
  "nsprov": "http://www.w3.org/ns/prov#",
  "passport": "https://nepalpassport.gov.np/",
  "tgc": "http://www.hds.utc.fr/tg#",
  "vrti": "https://www.w3id.org/virtual-treasury/ontology#",
  "fti": "http://franz.com/ns/allegrograph/2.2/textindex/",
  "regcomp": "https://regulacomp.unige.ch/ns/regcomp#",
  "bambara": "http://example.org/bambara#",
  "tgfm": "http://purl.org/terminology-guide-for-move/testvocab/",
  "pur": "http://prismstandard.org/namespaces/prismusagerights/2.1/",
  "rdb": "http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#",
  "unesco": "http://vocabularies.unesco.org/thesaurus/",
  "och": "http://w3id.org/def/och/",
  "ishi": "https://w3id.org/ishikawa-diagram-ontology#",
  "drammar": "http://www.purl.org/drammar#",
  "jats": "http://jats.nlm.nih.gov/",
  "vwlap": "https://vwgroup.leanix.net/Volkswagen/factsheet/Application/",
  "bam": "http://vtw.elsevier.com/data/voc/ns/bam-vtw-1/",
  "lindas": "https://ld.admin.ch/",
  "spot": "https://w3id.org/spot#",
  "arco": "https://w3id.org/arco/ontology/arco/",
  "npo": "https://w3id.org/NPO/ontology/",
  "picom": "https://personsincontext.org/model#",
  "scdt": "http://w3id.org/awslabs/neptune/SPARQL-CDTs/",
  "libro": "https://www.librorum.fr/ontology/",
  "itandrec": "http://www.semanticweb.org/pedri/ontologies/2025/3/IntelligentTourismAndRecommendations#",
  "oqs": "http://purl.org/nsoluti/oqs#",
  "ppm": "https://mestergruppen.no/ontologies/projectproductionmanagement/",
  "icd": "http://purl.bioontology.org/ontology/ICD9CM/",
  "vwgw": "https://group-wiki.wob.vw.vwg/wikis/pages/viewpage.action?pageId=",
  "rbo": "http://purl.obolibrary.org/obo/RBO_",
  "turism": "http://turism.com/",
  "sip": "https://purl.semanticip.org/linked-data/",
  "debias": "http://data.europa.eu/c4p/data/",
  "ris": "http://research-info-systems.com/schema/ris/",
  "fwo": "https://w3id.org/foodwaste/ontology#",
  "know": "https://know.dev/",
  "dsio": "https://ptb.de/si#",
  "sis": "https://ptb.de/sis/",
  "elsst": "https://elsst.cessda.eu/id/",
  "datmm": "http://id.nlm.nih.gov/datmm/",
  "dbpde": "http://de.dbpedia.org/property/",
  "riskman": "https://w3id.org/riskman/ontology#",
  "iirds": "http://iirds.tekom.de/iirds#",
  "ncl": "https://w3id.org/NCL/ontology/",
  "eliasempre": "https://eliasempresas.com/",
  "reno": "https://w3id.org/reno#",
  "sulo": "https://w3id.org/sulo/",
  "vm": "http://visual-meaning.com/rdf/",
  "vwdms": "https://vwdmsweb.wob.vw.vwg/groupdms/?docbase=vwdms&locateId=",
  "muno": "https://purl.org/muno/onto/",
  "genex": "http://purl.org/genex#",
  "bu": "http://borhan-onto.ir/ontology/upper#",
  "whu": "http://bdi.whu.edu.cn/",
  "golem": "https://w3id.org/golem/ontology#",
  "ubbont": "http://data.ub.uib.no/ontology/",
  "coso": "http://w3id.org/coso/v1/contaminoso#",
  "semts": "https://w3id.org/semts/ontology#",
  "dqa": "https://w3id.org/DQA#",
  "pmw": "http://ponymusic.wiki/ns#",
  "akco": "https://purl.archive.org/akco#",
  "coar": "http://purl.org/coar/resource_type/",
  "tribont": "https://w3id.org/tribont/core#",
  "piveau": "https://piveau.eu/ns/voc#",
  "gro": "http://www.bootstrep.eu/ontology/GRO#",
  "evorao": "http://w3id.org/evorao/",
  "exmo": "http://purl.obolibrary.org/obo/EXMO_",
  "csro": "https://w3id.org/csro/ontology#",
  "elm": "http://data.europa.eu/snb/model/elm/",
  "rdfc": "https://w3id.org/rdf-connect#",
  "csr": "http://purl.org/org/iode/po/voc/cruise-summary-reports#",
  "dtool": "https://devtoolkit.space/ontology#",
  "dcatde": "http://dcat-ap.de/def/dcatde/",
  "lib": "http://purl.org/library/",
  "a11y": "http://idpf.org/epub/vocab/package/a11y/#",
  "sz": "https://github.com/senzing-garage/sz-semantics/wiki/ns#",
  "bmont": "http://purl.obolibrary.org/obo/BMONT_",
  "bodi": "http://w3id.org/bodi#",
  "sdn": "https://ontology.seadatanet.org/#",
  "homoit": "https://homosaurus.org/v4/",
  "pghdprovo": "https://w3id.org/pghdprovo#",
  "modsrdf": "http://www.loc.gov/mods/rdf/v1#",
  "bno": "https://data.banenor.no/ontology/",
  "tfn": "https://w3id.org/time-fn#",
  "mdcat": "https://w3id.org/mobilitydcat-ap#",
  "bnd": "https://data.banenor.no/data/",
  "tbs": "http://topbraid.org/tbs#",
  "rtm": "http://ontology.railml.org/railtopomodel#",
  "tensor": "https://w3id.org/rdf-tensor/vocab#",
  "railml3": "http://ontology.railml.org/railml3#",
  "ard": "https://www.stratcom.mil/ontologies/electromagnetic-spectrum/adversary-radar-detection-ontology/",
  "dccs": "https://ptb.de/dccs/",
  "omekas": "http://omeka.org/s/vocabs/o#",
  "rdm": "https://terms.codata.org/rdmt/",
  "afy": "https://w3id.org/afy#",
  "dpp": "https://ns.verisav.fr/dpp#",
  "lubm": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
  "geodcatap": "http://data.europa.eu/930/",
  "submit": "https://ns.verisav.fr/dpp#",
  "aaao": "https://ontology.swissartresearch.net/aaao/",
  "dpvpd": "https://w3id.org/dpv/pd#",
  "let": "http://uispin.org/let#",
  "osmkey": "https://www.openstreetmap.org/wiki/Key:",
  "vlaanderen": "https://data.vlaanderen.be/ns/",
  "iut": "https://cours.iut-orsay.fr/",
  "idtype": "https://data.elsevier.com/e/identifier/",
  "mdo": "http://w3id.org/mdo/",
  "med": "http://data.esante.gouv.fr/ansm/medicament/",
  "plato": "https://w3id.org/plato#",
  "whg": "https://w3id.org/whg/id/",
  "mdr": "https://w3id.org/mdr#",
  "mlca": "https://w3id.org/mlca/",
  "animl": "http://www.w3id.org/animl/ontology/",
  "coord": "http://qudt.org/vocab/coordinate/",
  "tf": "https://takumifujimoto.com/schema/",
  "dbn": "https://www.darrinbaines.org/ns/identity#",
  "gid": "https://inspirewrap.ontologycentral.com/adv/gid/7.1#",
  "i40fd": "http://w3id.org/iaam/i40fd#",
  "riepr": "https://data.riepr.omgeving.vlaanderen.be/ns/riepr#",
  "lth": "https://vocab.lifetidy.com/",
  "puv": "http://data.elsevier.com/publishing/schema/puv/",
  "lack": "https://purl.net/climatesense/lack/ns#",
  "statdcatap": "http://data.europa.eu/s1n/",
  "mqto": "https://w3id.org/mqto#",
  "gwn": "https://globalwordnet.github.io/schemas/wn#",
  "norma": "https://w3id.org/def/norma-o#",
  "vwcds": "https://devstack.vwgroup.com/confluence/rest/api/content/",
  "vwag": "https://devstack.vwgroup.com/",
  "tal": "http://xml.zope.org/namespaces/tal/",
  "spectra": "https://w3id.org/spectra#",
  "tfo": "http://opendata.inrae.fr/PO2/Ontology/TransformON/",
  "lbco": "https://w3id.org/batcat#"
}
